/* eslint-disable */
/* prettier-ignore-file */
// @ts-nocheck
// Ce fichier est généré automatiquement par GraphQL Codegen
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { graphqlClient } from '@/shared/lib/graphql-client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: Record<string, any>; output: Record<string, any>; }
};

export type Analysis = {
  __typename?: 'Analysis';
  analysedProductCount: Maybe<Scalars['Float']['output']>;
  computeError: Maybe<Scalars['String']['output']>;
  computeState: AnalysisComputeState;
  createdAt: Scalars['DateTime']['output'];
  folderId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  isFavorite: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pageUrl: Scalars['String']['output'];
  parentAnalysisId: Maybe<Scalars['ID']['output']>;
  parsedFilter: Maybe<Scalars['JSON']['output']>;
  platform: AnalysisPlatform;
  position: Maybe<Scalars['Int']['output']>;
  publicCategoryId: Maybe<Scalars['ID']['output']>;
  publishedCount: Scalars['Int']['output'];
  queuePosition: Maybe<Scalars['Int']['output']>;
  scanTruncated: Scalars['Boolean']['output'];
  similarityDegraded: Scalars['Boolean']['output'];
  type: AnalysisType;
  userId: Maybe<Scalars['ID']['output']>;
  vestiaireFilter: Maybe<Scalars['JSON']['output']>;
};

export type AnalysisBrandDistribution = {
  __typename?: 'AnalysisBrandDistribution';
  avgSellsPrice: Scalars['Float']['output'];
  brand: Scalars['String']['output'];
  sellsCount: Scalars['Int']['output'];
  totalSellsPrice: Scalars['Float']['output'];
};

export type AnalysisCategoryDistribution = {
  __typename?: 'AnalysisCategoryDistribution';
  avgSellsPrice: Scalars['Float']['output'];
  categoryName: Scalars['String']['output'];
  fullPath: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  sellsCount: Scalars['Int']['output'];
  totalSellsPrice: Scalars['Float']['output'];
};

export type AnalysisCategoryDistributionLevel = {
  __typename?: 'AnalysisCategoryDistributionLevel';
  categories: Array<AnalysisCategoryDistribution>;
  level: Scalars['Int']['output'];
};

export type AnalysisCharStat = {
  __typename?: 'AnalysisCharStat';
  id: Scalars['Int']['output'];
  sales: Scalars['Int']['output'];
  soldPct: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type AnalysisCharacteristics = {
  __typename?: 'AnalysisCharacteristics';
  conditions: Array<AnalysisCharStat>;
  sizes: Array<AnalysisCharStat>;
};

export type AnalysisComputeState =
  | 'failed'
  | 'queued'
  | 'ready'
  | 'running'
  | '%future added value';

export type AnalysisDailyPoint = {
  __typename?: 'AnalysisDailyPoint';
  added: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  sales: Scalars['Int']['output'];
};

export type AnalysisDashboard = {
  __typename?: 'AnalysisDashboard';
  characteristics: AnalysisCharacteristics;
  dailyActivity: Array<AnalysisDailyPoint>;
  saleTimeDistribution: Array<AnalysisSaleTimeBucket>;
  stats: AnalysisStats;
  weeklyHeatmap: Array<AnalysisHeatPoint>;
};

export type AnalysisEngineKind =
  | 'filterService'
  | 'sql'
  | '%future added value';

export type AnalysisEngineMessage =
  | 'unavailable'
  | 'vectorsInactive'
  | 'vectorsIndexing'
  | 'windowStale'
  | '%future added value';

export type AnalysisEngineState =
  | 'degraded'
  | 'ok'
  | 'unavailable'
  | '%future added value';

export type AnalysisEngineStatus = {
  __typename?: 'AnalysisEngineStatus';
  checkedAt: Scalars['DateTime']['output'];
  engine: AnalysisEngineKind;
  incompleteVectorDays: Array<Scalars['String']['output']>;
  messageCode: Maybe<AnalysisEngineMessage>;
  staleDays: Array<Scalars['String']['output']>;
  state: AnalysisEngineState;
  windowDays: Maybe<Scalars['Int']['output']>;
};

export type AnalysisHeatPoint = {
  __typename?: 'AnalysisHeatPoint';
  added: Scalars['Int']['output'];
  day: Scalars['Int']['output'];
  sales: Scalars['Int']['output'];
  slot: Scalars['Int']['output'];
};

export type AnalysisMatchPreview = {
  __typename?: 'AnalysisMatchPreview';
  capped: Scalars['Boolean']['output'];
  engine: AnalysisEngineKind;
  exhaustive: Scalars['Boolean']['output'];
  sampledCount: Maybe<Scalars['Int']['output']>;
  similarityPending: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AnalysisNicheStats = {
  __typename?: 'AnalysisNicheStats';
  addedPerDay: Maybe<Scalars['Float']['output']>;
  avgPrice: Maybe<Scalars['Float']['output']>;
  caPerMonth: Maybe<Scalars['Float']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  niche: Scalars['String']['output'];
  nicheId: Maybe<Scalars['Int']['output']>;
  productCount: Scalars['Int']['output'];
  relaunchCriteria: Maybe<RelaunchSearchCriteria>;
  soldPct: Maybe<Scalars['Float']['output']>;
  soldPerDay: Maybe<Scalars['Float']['output']>;
  timeToSellHours: Maybe<Scalars['Float']['output']>;
  type: AnalysisNicheStatsType;
  vestiaireRelaunchCriteria: Maybe<VestiaireRelaunchCriteria>;
};

export type AnalysisNicheStatsType =
  | 'brand'
  | 'category'
  | '%future added value';

export type AnalysisPlatform =
  | 'vestiaire'
  | 'vinted'
  | '%future added value';

export type AnalysisQuota = {
  __typename?: 'AnalysisQuota';
  canCreateCatalogAnalysis: Scalars['Boolean']['output'];
  canCreateProfileAnalysis: Scalars['Boolean']['output'];
  catalogAnalysesAvailable: Scalars['Int']['output'];
  catalogAnalysesMax: Scalars['Int']['output'];
  catalogAnalysesUsed: Scalars['Int']['output'];
  hasFullPublicAnalysisAccess: Scalars['Boolean']['output'];
  hasPartialPublicAnalysisAccess: Scalars['Boolean']['output'];
  profileAnalysesAvailable: Scalars['Int']['output'];
  profileAnalysesMax: Scalars['Int']['output'];
  profileAnalysesUsed: Scalars['Int']['output'];
};

export type AnalysisSaleTimeBucket = {
  __typename?: 'AnalysisSaleTimeBucket';
  count: Scalars['Int']['output'];
  maxHours: Scalars['Int']['output'];
};

export type AnalysisSegmentFacets = {
  __typename?: 'AnalysisSegmentFacets';
  colors: Array<FacetOption>;
  conditions: Array<FacetOption>;
  countries: Array<FacetOption>;
  priceMax: Maybe<Scalars['Float']['output']>;
  priceMin: Maybe<Scalars['Float']['output']>;
  sizes: Array<FacetOption>;
};

export type AnalysisSegmentInput = {
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  conditionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  priceMax?: InputMaybe<Scalars['Float']['input']>;
  priceMin?: InputMaybe<Scalars['Float']['input']>;
  sizeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AnalysisSellerRegion =
  | 'europeEast'
  | 'europeWest'
  | 'northAmerica'
  | 'others'
  | 'unitedKingdom'
  | '%future added value';

export type AnalysisSellerStat = {
  __typename?: 'AnalysisSellerStat';
  avgPrice: Maybe<Scalars['Float']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  lastSales: Array<SellerSaleThumb>;
  profileUrl: Maybe<Scalars['String']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
  ratingBadge: Maybe<Scalars['String']['output']>;
  region: Maybe<AnalysisSellerRegion>;
  revenuePerMonth: Maybe<Scalars['Float']['output']>;
  reviews: Maybe<Scalars['Int']['output']>;
  salesInAnalysis: Maybe<Scalars['Int']['output']>;
  salesPerMonth: Maybe<Scalars['Int']['output']>;
  sellerId: Scalars['ID']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type AnalysisStats = {
  __typename?: 'AnalysisStats';
  averageSalePrice: Maybe<Scalars['Float']['output']>;
  averageSaleTimeSec: Maybe<Scalars['Int']['output']>;
  caPerMonth: Maybe<Scalars['Float']['output']>;
  newProductsPerDay: Maybe<Scalars['Float']['output']>;
  priceDistributionBuckets: Maybe<Array<PriceDistributionBucket>>;
  priceDistributionMax: Maybe<Scalars['Float']['output']>;
  priceDistributionMedian: Maybe<Scalars['Float']['output']>;
  priceDistributionMin: Maybe<Scalars['Float']['output']>;
  priceDistributionQ1: Maybe<Scalars['Float']['output']>;
  priceDistributionQ3: Maybe<Scalars['Float']['output']>;
  salePercentage: Maybe<Scalars['Float']['output']>;
  salesPerDay: Maybe<Scalars['Float']['output']>;
  totalProductsAnalyzed: Maybe<Scalars['Int']['output']>;
  totalSalesRecorded: Maybe<Scalars['Int']['output']>;
};

export type AnalysisTopSellers = {
  __typename?: 'AnalysisTopSellers';
  recurringSellerCount: Scalars['Int']['output'];
  sellers: Array<AnalysisSellerStat>;
};

export type AnalysisType =
  | 'catalog'
  | 'profile'
  | '%future added value';

export type CreateAnalysisFromFiltersInput = {
  criteria?: InputMaybe<SearchCriteriaInput>;
  name: Scalars['String']['input'];
  parentAnalysisId?: InputMaybe<Scalars['ID']['input']>;
  sellerVintedId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSearchFolderInput = {
  name: Scalars['String']['input'];
  type: AnalysisType;
};

export type CreateSearchImageUploadUrlInput = {
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
};

export type CreateStripeCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  periodicity: SubscriptionPlanPeriodicity;
  planId: Scalars['ID']['input'];
  successUrl: Scalars['String']['input'];
};

export type CreateStripeCheckoutSessionRes = {
  __typename?: 'CreateStripeCheckoutSessionRes';
  url: Scalars['String']['output'];
};

export type CreateStripePortalSessionInput = {
  returnUrl: Scalars['String']['input'];
  type: StripePortailType;
};

export type CreateStripePortalSessionRes = {
  __typename?: 'CreateStripePortalSessionRes';
  url: Scalars['String']['output'];
};

export type CreateVeilleInput = {
  criteria?: InputMaybe<SearchCriteriaInput>;
  name: Scalars['String']['input'];
  sellerVintedId?: InputMaybe<Scalars['String']['input']>;
  sourceAnalysisId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateVestiaireAnalysisInput = {
  criteria?: InputMaybe<VestiaireSearchCriteriaInput>;
  name: Scalars['String']['input'];
  parentAnalysisId?: InputMaybe<Scalars['ID']['input']>;
  seller?: InputMaybe<Scalars['String']['input']>;
};

export type FacetOption = {
  __typename?: 'FacetOption';
  count: Scalars['Int']['output'];
  hex: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type KeywordSearchOperator =
  | 'and'
  | 'or'
  | '%future added value';

export type MoveAnalysisToFolderInput = {
  analysisId: Scalars['ID']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveAnalysisToPositionInput = {
  analysisId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type MoveFolderToPositionInput = {
  folderId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createAnalysisFromFilters: Analysis;
  createSearchFolder: SearchFolder;
  createSearchImageUploadUrl: SearchImageUploadUrl;
  createStripeCheckoutSession: CreateStripeCheckoutSessionRes;
  createStripePortalSession: CreateStripePortalSessionRes;
  createVeille: Veille;
  createVestiaireAnalysis: Analysis;
  deleteAnalysis: Scalars['Boolean']['output'];
  deleteSearchFolder: Scalars['Boolean']['output'];
  moveAnalysisToFolder: Analysis;
  moveAnalysisToPosition: Analysis;
  moveFolderToPosition: SearchFolder;
  pauseVeille: Veille;
  removeAnalysisParent: Analysis;
  renameSearchFolder: SearchFolder;
  renameVeille: Veille;
  resumeVeille: Veille;
  selectPlanDuringTrial: UserSubscription;
  setAnalysisParent: Analysis;
  stopVeille: Veille;
  toggleAnalysisFavorite: Analysis;
  updateAnalysisName: Analysis;
  updateUserLanguage: UserLanguage;
  updateUserNotificationSettings: UserNotificationSettings;
  updateVeilleNotificationConfig: VeilleNotificationConfig;
};


export type MutationCreateAnalysisFromFiltersArgs = {
  input: CreateAnalysisFromFiltersInput;
};


export type MutationCreateSearchFolderArgs = {
  input: CreateSearchFolderInput;
};


export type MutationCreateSearchImageUploadUrlArgs = {
  input: CreateSearchImageUploadUrlInput;
};


export type MutationCreateStripeCheckoutSessionArgs = {
  input: CreateStripeCheckoutSessionInput;
};


export type MutationCreateStripePortalSessionArgs = {
  input: CreateStripePortalSessionInput;
};


export type MutationCreateVeilleArgs = {
  input: CreateVeilleInput;
};


export type MutationCreateVestiaireAnalysisArgs = {
  input: CreateVestiaireAnalysisInput;
};


export type MutationDeleteAnalysisArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSearchFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveAnalysisToFolderArgs = {
  input: MoveAnalysisToFolderInput;
};


export type MutationMoveAnalysisToPositionArgs = {
  input: MoveAnalysisToPositionInput;
};


export type MutationMoveFolderToPositionArgs = {
  input: MoveFolderToPositionInput;
};


export type MutationPauseVeilleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAnalysisParentArgs = {
  childId: Scalars['ID']['input'];
};


export type MutationRenameSearchFolderArgs = {
  input: RenameSearchFolderInput;
};


export type MutationRenameVeilleArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationResumeVeilleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSelectPlanDuringTrialArgs = {
  input: SelectPlanDuringTrialInput;
};


export type MutationSetAnalysisParentArgs = {
  input: SetAnalysisParentInput;
};


export type MutationStopVeilleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleAnalysisFavoriteArgs = {
  analysisId: Scalars['ID']['input'];
};


export type MutationUpdateAnalysisNameArgs = {
  input: UpdateAnalysisNameInput;
};


export type MutationUpdateUserLanguageArgs = {
  language: UserLanguage;
};


export type MutationUpdateUserNotificationSettingsArgs = {
  input: UpdateUserNotificationSettingsInput;
};


export type MutationUpdateVeilleNotificationConfigArgs = {
  input: UpdateVeilleNotificationInput;
};

export type PaginatedAnalysis = {
  __typename?: 'PaginatedAnalysis';
  analyses: Array<Analysis>;
  hasNextPage: Scalars['Boolean']['output'];
  nextCursor: Maybe<Scalars['String']['output']>;
};

export type PaginatedProduct = {
  __typename?: 'PaginatedProduct';
  hasNextPage: Scalars['Boolean']['output'];
  nextCursor: Maybe<Scalars['String']['output']>;
  products: Array<Product>;
};

export type ParsedVintedSearch = {
  __typename?: 'ParsedVintedSearch';
  brandCollections: Maybe<Array<ParsedVintedSearchOption>>;
  brands: Maybe<Array<ParsedVintedSearchOption>>;
  catalogs: Maybe<Array<ParsedVintedSearchOption>>;
  colors: Maybe<Array<ParsedVintedSearchOption>>;
  conditions: Maybe<Array<ParsedVintedSearchOption>>;
  internalMemoryCapacities: Maybe<Array<ParsedVintedSearchOption>>;
  keywords: Maybe<Array<Scalars['String']['output']>>;
  languageBooks: Maybe<Array<ParsedVintedSearchOption>>;
  materials: Maybe<Array<ParsedVintedSearchOption>>;
  patterns: Maybe<Array<ParsedVintedSearchOption>>;
  priceMax: Maybe<Scalars['Float']['output']>;
  priceMin: Maybe<Scalars['Float']['output']>;
  sellerVintedId: Maybe<Scalars['String']['output']>;
  simLocks: Maybe<Array<ParsedVintedSearchOption>>;
  sizes: Maybe<Array<ParsedVintedSearchOption>>;
  videoGamePlatforms: Maybe<Array<ParsedVintedSearchOption>>;
  videoGameRatings: Maybe<Array<ParsedVintedSearchOption>>;
};

export type ParsedVintedSearchOption = {
  __typename?: 'ParsedVintedSearchOption';
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PriceDistributionBucket = {
  __typename?: 'PriceDistributionBucket';
  count: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
};

export type Product = {
  __typename?: 'Product';
  attributes: Maybe<Array<ProductAttribute>>;
  brand: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  favouriteCount: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images: Array<ProductImage>;
  inactivatedAt: Maybe<Scalars['DateTime']['output']>;
  isPromoted: Maybe<Scalars['Boolean']['output']>;
  itemCondition: Maybe<ProductItemCondition>;
  lastUpdateAt: Maybe<Scalars['DateTime']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  sellerName: Maybe<Scalars['String']['output']>;
  sellerRating: Maybe<Scalars['Float']['output']>;
  sellerReviews: Maybe<Scalars['Int']['output']>;
  sellerUrl: Maybe<Scalars['String']['output']>;
  status: ProductStatus;
  title: Scalars['String']['output'];
  uploadedAt: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductBrandCount = {
  __typename?: 'ProductBrandCount';
  brand: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  displayOrder: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type ProductItemCondition =
  | 'good'
  | 'goodCondition'
  | 'newWithTag'
  | 'newWithoutTag'
  | 'satisfactory'
  | 'somePiecesNotWorking'
  | 'veryGoodCondition'
  | '%future added value';

export type ProductItemConditionCount = {
  __typename?: 'ProductItemConditionCount';
  count: Scalars['Int']['output'];
  itemCondition: ProductItemCondition;
};

export type ProductSort =
  | 'newest'
  | 'oldest'
  | 'priceAsc'
  | 'priceDesc'
  | 'similarity'
  | '%future added value';

export type ProductStatus =
  | 'active'
  | 'booked'
  | 'expired'
  | 'holidays'
  | 'masked'
  | 'removed'
  | 'sold'
  | 'unknown'
  | '%future added value';

export type PublicAnalysisCategory = {
  __typename?: 'PublicAnalysisCategory';
  analyses: Array<Analysis>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAnalysisBrandDistribution: Array<AnalysisBrandDistribution>;
  getAnalysisById: Maybe<Analysis>;
  getAnalysisCategoriesLevelsDistribution: Array<AnalysisCategoryDistributionLevel>;
  getAnalysisDashboard: AnalysisDashboard;
  getAnalysisEngineStatus: AnalysisEngineStatus;
  getAnalysisNiches: Array<AnalysisNicheStats>;
  getAnalysisSegmentFacets: AnalysisSegmentFacets;
  getAnalysisTopSellers: AnalysisTopSellers;
  getAvailableBrands: Array<ProductBrandCount>;
  getAvailableItemConditions: Array<ProductItemConditionCount>;
  getAvailableSubscriptionPlans: Array<SubscriptionPlan>;
  getCanStartFreeTrial: Scalars['Boolean']['output'];
  getCurrentUserAnalysisQuotas: AnalysisQuota;
  getCurrentUserSubscription: Maybe<UserSubscription>;
  getCurrentUserVeilleQuotas: VeilleQuota;
  getCurrentUserVestiaireAccess: Scalars['Boolean']['output'];
  getNicheSoldProducts: Array<Product>;
  getProductById: Maybe<Product>;
  getProductFeed: PaginatedProduct;
  getProductsByStatus: Array<Product>;
  getPublicAnalysisCategories: Array<PublicAnalysisCategory>;
  getSellerByLogin: Maybe<SellerLookup>;
  getTrendList: TrendList;
  getUserAnalysesPaginated: PaginatedAnalysis;
  getUserAnalysisStatsCsv: Scalars['String']['output'];
  getUserLanguage: UserLanguage;
  getUserNotificationSettings: UserNotificationSettings;
  getUserSearchFolders: Array<SearchFolder>;
  getUserVeilles: Array<Veille>;
  getVeilleById: Maybe<Veille>;
  getVeilleDailyStats: Array<VeilleDailyStats>;
  getVeilleFeed: VeilleFeedPage;
  getVeilleLiveCurve: Array<VeilleLiveCurvePoint>;
  getVeilleNotificationConfig: Maybe<VeilleNotificationConfig>;
  getVeilleNotificationHistory: Array<VeilleNotificationDelivery>;
  getVeilleStatsComparison: VeilleStatsComparison;
  getVeilleWeeklyStats: Array<VeilleWeeklyStats>;
  getVestiaireCatalogTree: Array<VestiaireCatalogNode>;
  getVestiaireCountries: Array<VestiaireCountry>;
  getVestiaireFilterOptions: Array<VestiaireFilterOption>;
  getVintedCatalogFilters: Array<VintedCatalogFilter>;
  getVintedCatalogTree: Array<VintedCatalogNode>;
  getVintedCountries: Array<VintedCountry>;
  parseVestiaireSearchUrl: VestiaireSearchUrlImport;
  parseVestiaireSellerRef: Maybe<VestiaireSellerRef>;
  parseVintedCatalogUrl: ParsedVintedSearch;
  previewAnalysisMatchCount: AnalysisMatchPreview;
  previewVestiaireMatchCount: VestiaireMatchPreview;
  searchVintedCatalogFilterOptions: Array<VintedCatalogFilterOption>;
};


export type QueryGetAnalysisBrandDistributionArgs = {
  analysisId: Scalars['ID']['input'];
  categoryPath: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAnalysisByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAnalysisCategoriesLevelsDistributionArgs = {
  analysisId: Scalars['ID']['input'];
};


export type QueryGetAnalysisDashboardArgs = {
  analysisId: Scalars['ID']['input'];
  segment: InputMaybe<AnalysisSegmentInput>;
};


export type QueryGetAnalysisNichesArgs = {
  analysisId: Scalars['ID']['input'];
  segment: InputMaybe<AnalysisSegmentInput>;
};


export type QueryGetAnalysisSegmentFacetsArgs = {
  analysisId: Scalars['ID']['input'];
};


export type QueryGetAnalysisTopSellersArgs = {
  analysisId: Scalars['ID']['input'];
  regions: InputMaybe<Array<AnalysisSellerRegion>>;
};


export type QueryGetAvailableBrandsArgs = {
  analysisId: Scalars['ID']['input'];
  status: InputMaybe<ProductStatus>;
};


export type QueryGetAvailableItemConditionsArgs = {
  analysisId: Scalars['ID']['input'];
  status: InputMaybe<ProductStatus>;
};


export type QueryGetNicheSoldProductsArgs = {
  analysisId: Scalars['ID']['input'];
  brandOrFullPath: Scalars['String']['input'];
};


export type QueryGetProductByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProductFeedArgs = {
  analysisId: Scalars['ID']['input'];
  brand: InputMaybe<Scalars['String']['input']>;
  colorIds: InputMaybe<Array<Scalars['Int']['input']>>;
  conditionIds: InputMaybe<Array<Scalars['Int']['input']>>;
  countryIds: InputMaybe<Array<Scalars['Int']['input']>>;
  cursor: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  priceMax: InputMaybe<Scalars['Float']['input']>;
  priceMin: InputMaybe<Scalars['Float']['input']>;
  searchText: InputMaybe<Scalars['String']['input']>;
  sizeIds: InputMaybe<Array<Scalars['Int']['input']>>;
  sort: InputMaybe<ProductSort>;
  status: InputMaybe<ProductStatus>;
};


export type QueryGetProductsByStatusArgs = {
  analysisId: Scalars['ID']['input'];
  status: ProductStatus;
};


export type QueryGetSellerByLoginArgs = {
  login: Scalars['String']['input'];
};


export type QueryGetTrendListArgs = {
  catalogId: InputMaybe<Scalars['Int']['input']>;
  countryId: InputMaybe<Scalars['Int']['input']>;
  list: TrendListKind;
  runOffset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUserAnalysesPaginatedArgs = {
  cursor: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  type: AnalysisType;
};


export type QueryGetUserSearchFoldersArgs = {
  type: AnalysisType;
};


export type QueryGetVeilleByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVeilleDailyStatsArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
  veilleId: Scalars['ID']['input'];
};


export type QueryGetVeilleFeedArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  veilleId: Scalars['ID']['input'];
  windowMinutes: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetVeilleLiveCurveArgs = {
  veilleId: Scalars['ID']['input'];
};


export type QueryGetVeilleNotificationConfigArgs = {
  veilleId: Scalars['ID']['input'];
};


export type QueryGetVeilleNotificationHistoryArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  veilleId: Scalars['ID']['input'];
};


export type QueryGetVeilleStatsComparisonArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
  veilleId: Scalars['ID']['input'];
};


export type QueryGetVeilleWeeklyStatsArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
  veilleId: Scalars['ID']['input'];
};


export type QueryGetVestiaireFilterOptionsArgs = {
  filterType: VestiaireFilterType;
  ids: InputMaybe<Array<Scalars['Int']['input']>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  query: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetVintedCatalogFiltersArgs = {
  mainCatalogIds: Array<Scalars['Int']['input']>;
};


export type QueryParseVestiaireSearchUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryParseVestiaireSellerRefArgs = {
  input: Scalars['String']['input'];
};


export type QueryParseVintedCatalogUrlArgs = {
  catalogUrl: Scalars['String']['input'];
};


export type QueryPreviewAnalysisMatchCountArgs = {
  input: SearchCriteriaInput;
};


export type QueryPreviewVestiaireMatchCountArgs = {
  input: VestiaireSearchCriteriaInput;
};


export type QuerySearchVintedCatalogFilterOptionsArgs = {
  filterType: VintedCatalogFilterType;
  mainCatalogIds: Array<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

export type RelaunchSearchCriteria = {
  __typename?: 'RelaunchSearchCriteria';
  brandCollectionIds: Maybe<Array<Scalars['Int']['output']>>;
  brandIds: Maybe<Array<Scalars['Int']['output']>>;
  catalogIds: Maybe<Array<Scalars['Int']['output']>>;
  colorIds: Maybe<Array<Scalars['Int']['output']>>;
  conditionIds: Maybe<Array<Scalars['Int']['output']>>;
  countryIds: Maybe<Array<Scalars['Int']['output']>>;
  description: Maybe<Scalars['String']['output']>;
  excludedBrandIds: Maybe<Array<Scalars['Int']['output']>>;
  excludedKeywords: Maybe<Array<Scalars['String']['output']>>;
  imageKey: Maybe<Scalars['String']['output']>;
  internalMemoryCapacityIds: Maybe<Array<Scalars['Int']['output']>>;
  keywords: Maybe<Array<Scalars['String']['output']>>;
  keywordsOperator: Maybe<KeywordSearchOperator>;
  languageBookIds: Maybe<Array<Scalars['Int']['output']>>;
  materialIds: Maybe<Array<Scalars['Int']['output']>>;
  patternIds: Maybe<Array<Scalars['Int']['output']>>;
  priceMax: Maybe<Scalars['Float']['output']>;
  priceMin: Maybe<Scalars['Float']['output']>;
  simLockIds: Maybe<Array<Scalars['Int']['output']>>;
  similarityThreshold: Maybe<Scalars['Float']['output']>;
  sizeIds: Maybe<Array<Scalars['Int']['output']>>;
  sourceProductId: Maybe<Scalars['ID']['output']>;
  videoGamePlatformIds: Maybe<Array<Scalars['Int']['output']>>;
  videoGameRatingIds: Maybe<Array<Scalars['Int']['output']>>;
};

export type RenameSearchFolderInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type SearchCriteriaInput = {
  brandCollectionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  catalogIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  conditionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludedBrandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludedKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  imageKey?: InputMaybe<Scalars['String']['input']>;
  internalMemoryCapacityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  keywordsOperator?: InputMaybe<KeywordSearchOperator>;
  languageBookIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  patternIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  priceMax?: InputMaybe<Scalars['Float']['input']>;
  priceMin?: InputMaybe<Scalars['Float']['input']>;
  simLockIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  similarityThreshold?: InputMaybe<Scalars['Float']['input']>;
  sizeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sourceProductId?: InputMaybe<Scalars['ID']['input']>;
  videoGamePlatformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  videoGameRatingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SearchFolder = {
  __typename?: 'SearchFolder';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  type: AnalysisType;
};

export type SearchImageUploadUrl = {
  __typename?: 'SearchImageUploadUrl';
  expiresInSecs: Scalars['Int']['output'];
  fields: Scalars['JSON']['output'];
  key: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type SelectPlanDuringTrialInput = {
  periodicity: SubscriptionPlanPeriodicity;
  planId: Scalars['ID']['input'];
};

export type SellerLookup = {
  __typename?: 'SellerLookup';
  login: Scalars['String']['output'];
  sellerVintedId: Scalars['String']['output'];
};

export type SellerSaleThumb = {
  __typename?: 'SellerSaleThumb';
  imageUrl: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

export type SetAnalysisParentInput = {
  childId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};

export type StripePortailType =
  | 'paymentMethodAndInvoices'
  | 'subscriptionCancel'
  | '%future added value';

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  catalogAnalysisQuotas: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceMonthly: Maybe<Scalars['Float']['output']>;
  priceYearly: Maybe<Scalars['Float']['output']>;
  profileAnalysisQuotas: Scalars['Int']['output'];
  trialCatalogAnalysisQuotas: Maybe<Scalars['Int']['output']>;
  trialPeriodDays: Scalars['Int']['output'];
  trialProfileAnalysisQuotas: Maybe<Scalars['Int']['output']>;
  trialVeilleQuotas: Maybe<Scalars['Int']['output']>;
  vestiaireAccess: Scalars['Boolean']['output'];
};

export type SubscriptionPlanPeriodicity =
  | 'monthly'
  | 'yearly'
  | '%future added value';

export type TrendBrand = {
  __typename?: 'TrendBrand';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TrendCatalog = {
  __typename?: 'TrendCatalog';
  leafId: Maybe<Scalars['Int']['output']>;
  leafName: Maybe<Scalars['String']['output']>;
  level1Id: Maybe<Scalars['Int']['output']>;
  level1Name: Maybe<Scalars['String']['output']>;
  rootId: Maybe<Scalars['Int']['output']>;
  rootName: Maybe<Scalars['String']['output']>;
};

export type TrendLastSale = {
  __typename?: 'TrendLastSale';
  imageUrl: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  productId: Scalars['ID']['output'];
  soldAt: Maybe<Scalars['DateTime']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type TrendList = {
  __typename?: 'TrendList';
  computedAt: Maybe<Scalars['DateTime']['output']>;
  list: TrendListKind;
  niches: Array<TrendNiche>;
  total: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
  weekAnchor: Maybe<Scalars['String']['output']>;
};

export type TrendListKind =
  | 'top'
  | 'trend'
  | '%future added value';

export type TrendNiche = {
  __typename?: 'TrendNiche';
  brand: Maybe<TrendBrand>;
  catalog: Maybe<TrendCatalog>;
  countryId: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isStratum: Scalars['Boolean']['output'];
  keyword: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  lastSales: Array<TrendLastSale>;
  metrics: TrendNicheMetrics;
  name: Scalars['String']['output'];
  nameSource: Scalars['String']['output'];
  relaunchCriteria: Maybe<RelaunchSearchCriteria>;
  seed: Maybe<TrendSeed>;
  series: Array<TrendSeriesPoint>;
  topSellers: Array<TrendTopSeller>;
};

export type TrendNicheMetrics = {
  __typename?: 'TrendNicheMetrics';
  avgPrice: Maybe<Scalars['Float']['output']>;
  caPerMonth: Maybe<Scalars['Float']['output']>;
  growthPct: Maybe<Scalars['Float']['output']>;
  medianPrice: Maybe<Scalars['Float']['output']>;
  productCount: Scalars['Int']['output'];
  salesPerDay: Maybe<Scalars['Float']['output']>;
  soldPct: Maybe<Scalars['Float']['output']>;
  timeToSellHours: Maybe<Scalars['Float']['output']>;
};

export type TrendSeed = {
  __typename?: 'TrendSeed';
  imageUrl: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type TrendSeriesPoint = {
  __typename?: 'TrendSeriesPoint';
  day: Scalars['String']['output'];
  sales: Scalars['Int']['output'];
};

export type TrendTopSeller = {
  __typename?: 'TrendTopSeller';
  imageUrl: Maybe<Scalars['String']['output']>;
  sales: Scalars['Int']['output'];
  sellerId: Scalars['ID']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type UpdateAnalysisNameInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateUserNotificationSettingsInput = {
  discordWebhook?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVeilleNotificationInput = {
  dailyReport?: InputMaybe<Scalars['Boolean']['input']>;
  discordEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eachSale?: InputMaybe<Scalars['Boolean']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  thresholds?: InputMaybe<Scalars['JSON']['input']>;
  veilleId: Scalars['ID']['input'];
  weeklyReport?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLanguage =
  | 'en'
  | 'fr'
  | '%future added value';

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  discordWebhook: Maybe<Scalars['String']['output']>;
  notificationEmail: Maybe<Scalars['String']['output']>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  cancelAt: Maybe<Scalars['DateTime']['output']>;
  inactivatedAt: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  isTrialing: Scalars['Boolean']['output'];
  plan: Maybe<UserSubscriptionPlan>;
};

export type UserSubscriptionPlan = {
  __typename?: 'UserSubscriptionPlan';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextRenewalAt: Maybe<Scalars['DateTime']['output']>;
  periodicity: SubscriptionPlanPeriodicity;
  price: Scalars['Float']['output'];
};

export type Veille = {
  __typename?: 'Veille';
  createdAt: Scalars['DateTime']['output'];
  historyState: VeilleHistoryState;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pageUrl: Maybe<Scalars['String']['output']>;
  parsedFilter: Maybe<Scalars['JSON']['output']>;
  sellerVintedId: Maybe<Scalars['String']['output']>;
  similarityDegraded: Scalars['Boolean']['output'];
  sourceAnalysisId: Maybe<Scalars['ID']['output']>;
  state: VeilleState;
  type: VeilleType;
};

export type VeilleDailyStats = {
  __typename?: 'VeilleDailyStats';
  averagePrice: Maybe<Scalars['Float']['output']>;
  day: Scalars['String']['output'];
  newItems: Scalars['Int']['output'];
  sales: Scalars['Int']['output'];
  sellThroughRate: Maybe<Scalars['Float']['output']>;
  sellers: Scalars['Int']['output'];
};

export type VeilleFeedItem = {
  __typename?: 'VeilleFeedItem';
  brandTitle: Maybe<Scalars['String']['output']>;
  conditionTitle: Maybe<Scalars['String']['output']>;
  favouriteCount: Maybe<Scalars['Int']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  productId: Scalars['ID']['output'];
  sellerFeedbackCount: Maybe<Scalars['Int']['output']>;
  sellerFeedbackRating: Maybe<Scalars['Float']['output']>;
  sellerId: Maybe<Scalars['ID']['output']>;
  sellerLogin: Maybe<Scalars['String']['output']>;
  soldAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  uploadedAt: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type VeilleFeedPage = {
  __typename?: 'VeilleFeedPage';
  items: Array<VeilleFeedItem>;
  nextCursor: Maybe<Scalars['String']['output']>;
};

export type VeilleHistoryState =
  | 'failed'
  | 'queued'
  | 'ready'
  | 'running'
  | '%future added value';

export type VeilleLiveCurvePoint = {
  __typename?: 'VeilleLiveCurvePoint';
  bucketStart: Scalars['DateTime']['output'];
  newItems: Scalars['Int']['output'];
  newItemsPerMinute: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
  salesPerMinute: Scalars['Float']['output'];
};

export type VeilleNotificationConfig = {
  __typename?: 'VeilleNotificationConfig';
  dailyReport: Scalars['Boolean']['output'];
  discordEnabled: Scalars['Boolean']['output'];
  eachSale: Scalars['Boolean']['output'];
  emailEnabled: Scalars['Boolean']['output'];
  lastDeliveryFailed: Scalars['Boolean']['output'];
  lastReason: Maybe<Scalars['String']['output']>;
  notificationEmail: Maybe<Scalars['String']['output']>;
  thresholds: Maybe<Scalars['JSON']['output']>;
  veilleId: Scalars['ID']['output'];
  weeklyReport: Scalars['Boolean']['output'];
};

export type VeilleNotificationDelivery = {
  __typename?: 'VeilleNotificationDelivery';
  at: Scalars['DateTime']['output'];
  kind: VeilleNotificationDeliveryKind;
  label: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  reason: Maybe<Scalars['String']['output']>;
};

export type VeilleNotificationDeliveryKind =
  | 'digest'
  | 'report'
  | 'single'
  | '%future added value';

export type VeilleQuota = {
  __typename?: 'VeilleQuota';
  canCreateVeille: Scalars['Boolean']['output'];
  veillesAvailable: Scalars['Int']['output'];
  veillesMax: Scalars['Int']['output'];
  veillesUsed: Scalars['Int']['output'];
};

export type VeilleState =
  | 'active'
  | 'paused'
  | 'stopped'
  | '%future added value';

export type VeilleStatsComparison = {
  __typename?: 'VeilleStatsComparison';
  averagePriceVariation: Maybe<Scalars['Float']['output']>;
  currentPeriodDays: Scalars['Int']['output'];
  newItemsVariation: Maybe<Scalars['Float']['output']>;
  previousPeriodDays: Scalars['Int']['output'];
  salesVariation: Maybe<Scalars['Float']['output']>;
  sellThroughRateVariation: Maybe<Scalars['Float']['output']>;
  sellersVariation: Maybe<Scalars['Float']['output']>;
};

export type VeilleType =
  | 'product'
  | 'seller'
  | '%future added value';

export type VeilleWeeklyStats = {
  __typename?: 'VeilleWeeklyStats';
  averagePrice: Maybe<Scalars['Float']['output']>;
  daysCounted: Scalars['Int']['output'];
  newItems: Scalars['Int']['output'];
  sales: Scalars['Int']['output'];
  sellThroughRate: Maybe<Scalars['Float']['output']>;
  sellers: Scalars['Int']['output'];
  weekStart: Scalars['String']['output'];
};

export type VestiaireCatalogNode = {
  __typename?: 'VestiaireCatalogNode';
  children: Array<VestiaireCatalogNode>;
  id: Scalars['Int']['output'];
  kind: VestiaireCatalogNodeKind;
  title: Scalars['String']['output'];
};

export type VestiaireCatalogNodeKind =
  | 'level1'
  | 'level2'
  | 'root'
  | 'universe'
  | '%future added value';

export type VestiaireCountry = {
  __typename?: 'VestiaireCountry';
  id: Scalars['Int']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  region: AnalysisSellerRegion;
  sellerCount: Scalars['Int']['output'];
};

export type VestiaireFilterOption = {
  __typename?: 'VestiaireFilterOption';
  id: Scalars['Int']['output'];
  level: Maybe<Scalars['Int']['output']>;
  parentId: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type VestiaireFilterType =
  | 'brand'
  | 'category'
  | 'color'
  | 'condition'
  | 'material'
  | 'model'
  | 'size'
  | 'subcategory'
  | 'universe'
  | '%future added value';

export type VestiaireItemBadge =
  | 'dealEligible'
  | 'exceptional'
  | 'officialStore'
  | 'vintage'
  | 'weLove'
  | '%future added value';

export type VestiaireMatchPreview = {
  __typename?: 'VestiaireMatchPreview';
  capped: Scalars['Boolean']['output'];
  priceMax: Maybe<Scalars['Float']['output']>;
  priceMin: Maybe<Scalars['Float']['output']>;
  sampleWindowDays: Scalars['Int']['output'];
  sampledCount: Scalars['Int']['output'];
  similarityPending: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type VestiaireRelaunchCriteria = {
  __typename?: 'VestiaireRelaunchCriteria';
  brandIds: Maybe<Array<Scalars['Int']['output']>>;
  catalogLevel1Ids: Maybe<Array<Scalars['Int']['output']>>;
  catalogLevel2Ids: Maybe<Array<Scalars['Int']['output']>>;
  catalogRootIds: Maybe<Array<Scalars['Int']['output']>>;
  colorIds: Maybe<Array<Scalars['Int']['output']>>;
  conditionIds: Maybe<Array<Scalars['Int']['output']>>;
  countryIds: Maybe<Array<Scalars['Int']['output']>>;
  description: Maybe<Scalars['String']['output']>;
  excludedBrandIds: Maybe<Array<Scalars['Int']['output']>>;
  excludedKeywords: Maybe<Array<Scalars['String']['output']>>;
  imageKey: Maybe<Scalars['String']['output']>;
  itemBadges: Maybe<Array<VestiaireItemBadge>>;
  keywords: Maybe<Array<Scalars['String']['output']>>;
  keywordsOperator: Maybe<KeywordSearchOperator>;
  materialIds: Maybe<Array<Scalars['Int']['output']>>;
  modelIds: Maybe<Array<Scalars['Int']['output']>>;
  priceMax: Maybe<Scalars['Float']['output']>;
  priceMin: Maybe<Scalars['Float']['output']>;
  sellerBadges: Maybe<Array<VestiaireSellerBadge>>;
  similarityThreshold: Maybe<Scalars['Float']['output']>;
  sizeIds: Maybe<Array<Scalars['Int']['output']>>;
  sourceProductId: Maybe<Scalars['ID']['output']>;
  universeIds: Maybe<Array<Scalars['Int']['output']>>;
};

export type VestiaireSearchCriteriaInput = {
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  catalogLevel1Ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  catalogLevel2Ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  catalogRootIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  conditionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludedBrandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludedKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  imageKey?: InputMaybe<Scalars['String']['input']>;
  itemBadges?: InputMaybe<Array<VestiaireItemBadge>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  keywordsOperator?: InputMaybe<KeywordSearchOperator>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  modelIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  priceMax?: InputMaybe<Scalars['Float']['input']>;
  priceMin?: InputMaybe<Scalars['Float']['input']>;
  sellerBadges?: InputMaybe<Array<VestiaireSellerBadge>>;
  similarityThreshold?: InputMaybe<Scalars['Float']['input']>;
  sizeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sourceProductId?: InputMaybe<Scalars['ID']['input']>;
  universeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type VestiaireSearchUrlImport = {
  __typename?: 'VestiaireSearchUrlImport';
  brands: Array<VestiaireFilterOption>;
  criteria: VestiaireRelaunchCriteria;
  ignored: Array<VestiaireUrlIgnoredPart>;
  models: Array<VestiaireFilterOption>;
};

export type VestiaireSellerBadge =
  | 'expert'
  | 'trusted'
  | '%future added value';

export type VestiaireSellerRef = {
  __typename?: 'VestiaireSellerRef';
  known: Scalars['Boolean']['output'];
  profileUrl: Scalars['String']['output'];
  sellerId: Scalars['ID']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type VestiaireUrlIgnoredPart = {
  __typename?: 'VestiaireUrlIgnoredPart';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VintedCatalogFilter = {
  __typename?: 'VintedCatalogFilter';
  options: Array<VintedCatalogFilterOption>;
  search: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: VintedCatalogFilterType;
};

export type VintedCatalogFilterOption = {
  __typename?: 'VintedCatalogFilterOption';
  children: Maybe<Array<VintedCatalogFilterOption>>;
  hex: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  itemsCount: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type: VintedCatalogFilterOptionType;
};

export type VintedCatalogFilterOptionType =
  | 'DEFAULT'
  | 'GROUP'
  | 'NAVIGATIONAL'
  | '%future added value';

export type VintedCatalogFilterType =
  | 'BRAND'
  | 'BRAND_COLLECTION'
  | 'COLOR'
  | 'INTERNAL_MEMORY_CAPACITY'
  | 'LANGUAGE_BOOK'
  | 'MATERIAL'
  | 'PATTERNS'
  | 'SIM_LOCK'
  | 'SIZE'
  | 'STATUS'
  | 'VIDEO_GAME_PLATFORM'
  | 'VIDEO_GAME_RATING'
  | '%future added value';

export type VintedCatalogNode = {
  __typename?: 'VintedCatalogNode';
  children: Array<VintedCatalogNode>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type VintedCountry = {
  __typename?: 'VintedCountry';
  id: Scalars['Int']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  region: AnalysisSellerRegion;
};

export type AnalysisBaseFragment = { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, folderId: string | null | undefined, position: number | null | undefined, isFavorite: boolean, parentAnalysisId: string | null | undefined, parsedFilter: Record<string, any> | null | undefined, similarityDegraded: boolean, scanTruncated: boolean, computeState: AnalysisComputeState, queuePosition: number | null | undefined, publishedCount: number, computeError: string | null | undefined, platform: AnalysisPlatform, vestiaireFilter: Record<string, any> | null | undefined };

export type ProductBaseFragment = { __typename?: 'Product', id: string, url: string, title: string, description: string | null | undefined, price: number | null | undefined, status: ProductStatus, itemCondition: ProductItemCondition | null | undefined, brand: string | null | undefined, favouriteCount: number | null | undefined, sellerUrl: string | null | undefined, sellerName: string | null | undefined, sellerReviews: number | null | undefined, sellerRating: number | null | undefined, uploadedAt: string | null | undefined, inactivatedAt: string | null | undefined, lastUpdateAt: string | null | undefined, createdAt: string, attributes: Array<{ __typename?: 'ProductAttribute', key: string, name: string, value: string }> | null | undefined, images: Array<{ __typename?: 'ProductImage', url: string, displayOrder: number }> };

export type VeilleBaseFragment = { __typename?: 'Veille', id: string, name: string, type: VeilleType, state: VeilleState, createdAt: string, parsedFilter: Record<string, any> | null | undefined, sellerVintedId: string | null | undefined, pageUrl: string | null | undefined, imageUrl: string | null | undefined, sourceAnalysisId: string | null | undefined, historyState: VeilleHistoryState, similarityDegraded: boolean };

export type CreateAnalysisFromFiltersMutationVariables = Exact<{
  input: CreateAnalysisFromFiltersInput;
}>;


export type CreateAnalysisFromFiltersMutation = { __typename?: 'Mutation', createAnalysisFromFilters: { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, folderId: string | null | undefined, position: number | null | undefined, isFavorite: boolean, parentAnalysisId: string | null | undefined, parsedFilter: Record<string, any> | null | undefined, similarityDegraded: boolean, scanTruncated: boolean, computeState: AnalysisComputeState, queuePosition: number | null | undefined, publishedCount: number, computeError: string | null | undefined, platform: AnalysisPlatform, vestiaireFilter: Record<string, any> | null | undefined } };

export type CreateSearchImageUploadUrlMutationVariables = Exact<{
  input: CreateSearchImageUploadUrlInput;
}>;


export type CreateSearchImageUploadUrlMutation = { __typename?: 'Mutation', createSearchImageUploadUrl: { __typename?: 'SearchImageUploadUrl', uploadUrl: string, fields: Record<string, any>, key: string, publicUrl: string, expiresInSecs: number } };

export type DeleteAnalysisMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAnalysisMutation = { __typename?: 'Mutation', deleteAnalysis: boolean };

export type UpdateAnalysisNameMutationVariables = Exact<{
  input: UpdateAnalysisNameInput;
}>;


export type UpdateAnalysisNameMutation = { __typename?: 'Mutation', updateAnalysisName: { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, folderId: string | null | undefined, position: number | null | undefined, isFavorite: boolean, parentAnalysisId: string | null | undefined, parsedFilter: Record<string, any> | null | undefined, similarityDegraded: boolean, scanTruncated: boolean, computeState: AnalysisComputeState, queuePosition: number | null | undefined, publishedCount: number, computeError: string | null | undefined, platform: AnalysisPlatform, vestiaireFilter: Record<string, any> | null | undefined } };

export type CreateSearchFolderMutationVariables = Exact<{
  input: CreateSearchFolderInput;
}>;


export type CreateSearchFolderMutation = { __typename?: 'Mutation', createSearchFolder: { __typename?: 'SearchFolder', id: string, name: string, type: AnalysisType, position: number, createdAt: string } };

export type RenameSearchFolderMutationVariables = Exact<{
  input: RenameSearchFolderInput;
}>;


export type RenameSearchFolderMutation = { __typename?: 'Mutation', renameSearchFolder: { __typename?: 'SearchFolder', id: string, name: string } };

export type DeleteSearchFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSearchFolderMutation = { __typename?: 'Mutation', deleteSearchFolder: boolean };

export type MoveAnalysisToFolderMutationVariables = Exact<{
  input: MoveAnalysisToFolderInput;
}>;


export type MoveAnalysisToFolderMutation = { __typename?: 'Mutation', moveAnalysisToFolder: { __typename?: 'Analysis', id: string, folderId: string | null | undefined, position: number | null | undefined } };

export type MoveAnalysisToPositionMutationVariables = Exact<{
  input: MoveAnalysisToPositionInput;
}>;


export type MoveAnalysisToPositionMutation = { __typename?: 'Mutation', moveAnalysisToPosition: { __typename?: 'Analysis', id: string, position: number | null | undefined } };

export type MoveFolderToPositionMutationVariables = Exact<{
  input: MoveFolderToPositionInput;
}>;


export type MoveFolderToPositionMutation = { __typename?: 'Mutation', moveFolderToPosition: { __typename?: 'SearchFolder', id: string, position: number } };

export type ToggleAnalysisFavoriteMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type ToggleAnalysisFavoriteMutation = { __typename?: 'Mutation', toggleAnalysisFavorite: { __typename?: 'Analysis', id: string, isFavorite: boolean } };

export type SetAnalysisParentMutationVariables = Exact<{
  input: SetAnalysisParentInput;
}>;


export type SetAnalysisParentMutation = { __typename?: 'Mutation', setAnalysisParent: { __typename?: 'Analysis', id: string, parentAnalysisId: string | null | undefined } };

export type RemoveAnalysisParentMutationVariables = Exact<{
  childId: Scalars['ID']['input'];
}>;


export type RemoveAnalysisParentMutation = { __typename?: 'Mutation', removeAnalysisParent: { __typename?: 'Analysis', id: string, parentAnalysisId: string | null | undefined } };

export type CreateStripeCheckoutSessionMutationVariables = Exact<{
  input: CreateStripeCheckoutSessionInput;
}>;


export type CreateStripeCheckoutSessionMutation = { __typename?: 'Mutation', createStripeCheckoutSession: { __typename?: 'CreateStripeCheckoutSessionRes', url: string } };

export type CreateStripePortalSessionMutationVariables = Exact<{
  input: CreateStripePortalSessionInput;
}>;


export type CreateStripePortalSessionMutation = { __typename?: 'Mutation', createStripePortalSession: { __typename?: 'CreateStripePortalSessionRes', url: string } };

export type SelectPlanDuringTrialMutationVariables = Exact<{
  input: SelectPlanDuringTrialInput;
}>;


export type SelectPlanDuringTrialMutation = { __typename?: 'Mutation', selectPlanDuringTrial: { __typename?: 'UserSubscription', isActive: boolean, isTrialing: boolean, inactivatedAt: string | null | undefined, plan: { __typename?: 'UserSubscriptionPlan', id: string, name: string, periodicity: SubscriptionPlanPeriodicity, price: number, nextRenewalAt: string | null | undefined } | null | undefined } };

export type UpdateUserLanguageMutationVariables = Exact<{
  language: UserLanguage;
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutation', updateUserLanguage: UserLanguage };

export type CreateVeilleMutationVariables = Exact<{
  input: CreateVeilleInput;
}>;


export type CreateVeilleMutation = { __typename?: 'Mutation', createVeille: { __typename?: 'Veille', id: string, name: string, type: VeilleType, state: VeilleState, createdAt: string, parsedFilter: Record<string, any> | null | undefined, sellerVintedId: string | null | undefined, pageUrl: string | null | undefined, imageUrl: string | null | undefined, sourceAnalysisId: string | null | undefined, historyState: VeilleHistoryState, similarityDegraded: boolean } };

export type PauseVeilleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PauseVeilleMutation = { __typename?: 'Mutation', pauseVeille: { __typename?: 'Veille', id: string, name: string, type: VeilleType, state: VeilleState, createdAt: string, parsedFilter: Record<string, any> | null | undefined, sellerVintedId: string | null | undefined, pageUrl: string | null | undefined, imageUrl: string | null | undefined, sourceAnalysisId: string | null | undefined, historyState: VeilleHistoryState, similarityDegraded: boolean } };

export type ResumeVeilleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResumeVeilleMutation = { __typename?: 'Mutation', resumeVeille: { __typename?: 'Veille', id: string, name: string, type: VeilleType, state: VeilleState, createdAt: string, parsedFilter: Record<string, any> | null | undefined, sellerVintedId: string | null | undefined, pageUrl: string | null | undefined, imageUrl: string | null | undefined, sourceAnalysisId: string | null | undefined, historyState: VeilleHistoryState, similarityDegraded: boolean } };

export type StopVeilleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StopVeilleMutation = { __typename?: 'Mutation', stopVeille: { __typename?: 'Veille', id: string, name: string, type: VeilleType, state: VeilleState, createdAt: string, parsedFilter: Record<string, any> | null | undefined, sellerVintedId: string | null | undefined, pageUrl: string | null | undefined, imageUrl: string | null | undefined, sourceAnalysisId: string | null | undefined, historyState: VeilleHistoryState, similarityDegraded: boolean } };

export type RenameVeilleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameVeilleMutation = { __typename?: 'Mutation', renameVeille: { __typename?: 'Veille', id: string, name: string, type: VeilleType, state: VeilleState, createdAt: string, parsedFilter: Record<string, any> | null | undefined, sellerVintedId: string | null | undefined, pageUrl: string | null | undefined, imageUrl: string | null | undefined, sourceAnalysisId: string | null | undefined, historyState: VeilleHistoryState, similarityDegraded: boolean } };

export type UpdateVeilleNotificationConfigMutationVariables = Exact<{
  input: UpdateVeilleNotificationInput;
}>;


export type UpdateVeilleNotificationConfigMutation = { __typename?: 'Mutation', updateVeilleNotificationConfig: { __typename?: 'VeilleNotificationConfig', veilleId: string, eachSale: boolean, discordEnabled: boolean, thresholds: Record<string, any> | null | undefined, dailyReport: boolean, weeklyReport: boolean, emailEnabled: boolean, notificationEmail: string | null | undefined, lastDeliveryFailed: boolean, lastReason: string | null | undefined } };

export type UpdateUserNotificationSettingsMutationVariables = Exact<{
  input: UpdateUserNotificationSettingsInput;
}>;


export type UpdateUserNotificationSettingsMutation = { __typename?: 'Mutation', updateUserNotificationSettings: { __typename?: 'UserNotificationSettings', discordWebhook: string | null | undefined, notificationEmail: string | null | undefined } };

export type CreateVestiaireAnalysisMutationVariables = Exact<{
  input: CreateVestiaireAnalysisInput;
}>;


export type CreateVestiaireAnalysisMutation = { __typename?: 'Mutation', createVestiaireAnalysis: { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, folderId: string | null | undefined, position: number | null | undefined, isFavorite: boolean, parentAnalysisId: string | null | undefined, parsedFilter: Record<string, any> | null | undefined, similarityDegraded: boolean, scanTruncated: boolean, computeState: AnalysisComputeState, queuePosition: number | null | undefined, publishedCount: number, computeError: string | null | undefined, platform: AnalysisPlatform, vestiaireFilter: Record<string, any> | null | undefined } };

export type GetAnalysisDashboardQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  segment: InputMaybe<AnalysisSegmentInput>;
}>;


export type GetAnalysisDashboardQuery = { __typename?: 'Query', getAnalysisDashboard: { __typename?: 'AnalysisDashboard', stats: { __typename?: 'AnalysisStats', averageSalePrice: number | null | undefined, salePercentage: number | null | undefined, averageSaleTimeSec: number | null | undefined, totalProductsAnalyzed: number | null | undefined, totalSalesRecorded: number | null | undefined, newProductsPerDay: number | null | undefined, salesPerDay: number | null | undefined, priceDistributionQ1: number | null | undefined, priceDistributionQ3: number | null | undefined, priceDistributionMin: number | null | undefined, priceDistributionMax: number | null | undefined, caPerMonth: number | null | undefined, priceDistributionBuckets: Array<{ __typename?: 'PriceDistributionBucket', price: number, count: number }> | null | undefined }, dailyActivity: Array<{ __typename?: 'AnalysisDailyPoint', date: string, added: number, sales: number }>, weeklyHeatmap: Array<{ __typename?: 'AnalysisHeatPoint', day: number, slot: number, added: number, sales: number }>, saleTimeDistribution: Array<{ __typename?: 'AnalysisSaleTimeBucket', maxHours: number, count: number }>, characteristics: { __typename?: 'AnalysisCharacteristics', conditions: Array<{ __typename?: 'AnalysisCharStat', id: number, title: string, soldPct: number, sales: number }>, sizes: Array<{ __typename?: 'AnalysisCharStat', id: number, title: string, soldPct: number, sales: number }> } } };

export type GetAnalysisSegmentFacetsQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type GetAnalysisSegmentFacetsQuery = { __typename?: 'Query', getAnalysisSegmentFacets: { __typename?: 'AnalysisSegmentFacets', priceMin: number | null | undefined, priceMax: number | null | undefined, conditions: Array<{ __typename?: 'FacetOption', id: number, title: string, hex: string | null | undefined, count: number }>, sizes: Array<{ __typename?: 'FacetOption', id: number, title: string, hex: string | null | undefined, count: number }>, colors: Array<{ __typename?: 'FacetOption', id: number, title: string, hex: string | null | undefined, count: number }>, countries: Array<{ __typename?: 'FacetOption', id: number, title: string, hex: string | null | undefined, count: number }> } };

export type GetAnalysisNichesQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  segment: InputMaybe<AnalysisSegmentInput>;
}>;


export type GetAnalysisNichesQuery = { __typename?: 'Query', getAnalysisNiches: Array<{ __typename?: 'AnalysisNicheStats', type: AnalysisNicheStatsType, niche: string, imageUrl: string | null | undefined, avgPrice: number | null | undefined, productCount: number, soldPct: number | null | undefined, soldPerDay: number | null | undefined, addedPerDay: number | null | undefined, timeToSellHours: number | null | undefined, caPerMonth: number | null | undefined, nicheId: number | null | undefined, relaunchCriteria: { __typename?: 'RelaunchSearchCriteria', countryIds: Array<number> | null | undefined, priceMin: number | null | undefined, priceMax: number | null | undefined, catalogIds: Array<number> | null | undefined, brandIds: Array<number> | null | undefined, excludedBrandIds: Array<number> | null | undefined, conditionIds: Array<number> | null | undefined, colorIds: Array<number> | null | undefined, sizeIds: Array<number> | null | undefined, materialIds: Array<number> | null | undefined, patternIds: Array<number> | null | undefined, brandCollectionIds: Array<number> | null | undefined, videoGamePlatformIds: Array<number> | null | undefined, videoGameRatingIds: Array<number> | null | undefined, internalMemoryCapacityIds: Array<number> | null | undefined, languageBookIds: Array<number> | null | undefined, simLockIds: Array<number> | null | undefined, keywords: Array<string> | null | undefined, keywordsOperator: KeywordSearchOperator | null | undefined, excludedKeywords: Array<string> | null | undefined, imageKey: string | null | undefined, sourceProductId: string | null | undefined, description: string | null | undefined } | null | undefined, vestiaireRelaunchCriteria: { __typename?: 'VestiaireRelaunchCriteria', universeIds: Array<number> | null | undefined, catalogRootIds: Array<number> | null | undefined, catalogLevel1Ids: Array<number> | null | undefined, catalogLevel2Ids: Array<number> | null | undefined, brandIds: Array<number> | null | undefined, excludedBrandIds: Array<number> | null | undefined, modelIds: Array<number> | null | undefined, conditionIds: Array<number> | null | undefined, sizeIds: Array<number> | null | undefined, colorIds: Array<number> | null | undefined, materialIds: Array<number> | null | undefined, countryIds: Array<number> | null | undefined, sellerBadges: Array<VestiaireSellerBadge> | null | undefined, itemBadges: Array<VestiaireItemBadge> | null | undefined, priceMin: number | null | undefined, priceMax: number | null | undefined, keywords: Array<string> | null | undefined, keywordsOperator: KeywordSearchOperator | null | undefined, excludedKeywords: Array<string> | null | undefined, imageKey: string | null | undefined, sourceProductId: string | null | undefined, similarityThreshold: number | null | undefined, description: string | null | undefined } | null | undefined }> };

export type GetAnalysisTopSellersQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  regions: InputMaybe<Array<AnalysisSellerRegion> | AnalysisSellerRegion>;
}>;


export type GetAnalysisTopSellersQuery = { __typename?: 'Query', getAnalysisTopSellers: { __typename?: 'AnalysisTopSellers', recurringSellerCount: number, sellers: Array<{ __typename?: 'AnalysisSellerStat', sellerId: string, username: string | null | undefined, region: AnalysisSellerRegion | null | undefined, imageUrl: string | null | undefined, rating: number | null | undefined, reviews: number | null | undefined, revenuePerMonth: number | null | undefined, salesPerMonth: number | null | undefined, avgPrice: number | null | undefined, ratingBadge: string | null | undefined, salesInAnalysis: number | null | undefined, profileUrl: string | null | undefined, lastSales: Array<{ __typename?: 'SellerSaleThumb', imageUrl: string | null | undefined, title: string, price: number | null | undefined }> }> } };

export type GetUserAnalysisStatsCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAnalysisStatsCsvQuery = { __typename?: 'Query', getUserAnalysisStatsCsv: string };

export type GetAnalysisByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAnalysisByIdQuery = { __typename?: 'Query', getAnalysisById: { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, folderId: string | null | undefined, position: number | null | undefined, isFavorite: boolean, parentAnalysisId: string | null | undefined, parsedFilter: Record<string, any> | null | undefined, similarityDegraded: boolean, scanTruncated: boolean, computeState: AnalysisComputeState, queuePosition: number | null | undefined, publishedCount: number, computeError: string | null | undefined, platform: AnalysisPlatform, vestiaireFilter: Record<string, any> | null | undefined } | null | undefined };

export type GetUserAnalysesPaginatedQueryVariables = Exact<{
  type: AnalysisType;
  cursor: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserAnalysesPaginatedQuery = { __typename?: 'Query', getUserAnalysesPaginated: { __typename?: 'PaginatedAnalysis', nextCursor: string | null | undefined, hasNextPage: boolean, analyses: Array<{ __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, folderId: string | null | undefined, position: number | null | undefined, isFavorite: boolean, parentAnalysisId: string | null | undefined, parsedFilter: Record<string, any> | null | undefined, similarityDegraded: boolean, scanTruncated: boolean, computeState: AnalysisComputeState, queuePosition: number | null | undefined, publishedCount: number, computeError: string | null | undefined, platform: AnalysisPlatform, vestiaireFilter: Record<string, any> | null | undefined }> } };

export type GetPublicAnalysisCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicAnalysisCategoriesQuery = { __typename?: 'Query', getPublicAnalysisCategories: Array<{ __typename?: 'PublicAnalysisCategory', id: string, name: string, analyses: Array<{ __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, folderId: string | null | undefined, position: number | null | undefined, isFavorite: boolean, parentAnalysisId: string | null | undefined, parsedFilter: Record<string, any> | null | undefined, similarityDegraded: boolean, scanTruncated: boolean, computeState: AnalysisComputeState, queuePosition: number | null | undefined, publishedCount: number, computeError: string | null | undefined, platform: AnalysisPlatform, vestiaireFilter: Record<string, any> | null | undefined }> }> };

export type GetAnalysisBrandDistributionQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  categoryPath: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnalysisBrandDistributionQuery = { __typename?: 'Query', getAnalysisBrandDistribution: Array<{ __typename?: 'AnalysisBrandDistribution', brand: string, sellsCount: number, totalSellsPrice: number, avgSellsPrice: number }> };

export type GetAnalysisCategoriesLevelsDistributionQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type GetAnalysisCategoriesLevelsDistributionQuery = { __typename?: 'Query', getAnalysisCategoriesLevelsDistribution: Array<{ __typename?: 'AnalysisCategoryDistributionLevel', level: number, categories: Array<{ __typename?: 'AnalysisCategoryDistribution', categoryName: string, fullPath: string, level: number, sellsCount: number, totalSellsPrice: number, avgSellsPrice: number }> }> };

export type GetUserSearchFoldersQueryVariables = Exact<{
  type: AnalysisType;
}>;


export type GetUserSearchFoldersQuery = { __typename?: 'Query', getUserSearchFolders: Array<{ __typename?: 'SearchFolder', id: string, name: string, type: AnalysisType, position: number, createdAt: string }> };

export type GetAnalysisEngineStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalysisEngineStatusQuery = { __typename?: 'Query', getAnalysisEngineStatus: { __typename?: 'AnalysisEngineStatus', state: AnalysisEngineState, engine: AnalysisEngineKind, messageCode: AnalysisEngineMessage | null | undefined, windowDays: number | null | undefined, staleDays: Array<string>, incompleteVectorDays: Array<string>, checkedAt: string } };

export type GetProductByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductByIdQuery = { __typename?: 'Query', getProductById: { __typename?: 'Product', id: string, url: string, title: string, description: string | null | undefined, price: number | null | undefined, status: ProductStatus, itemCondition: ProductItemCondition | null | undefined, brand: string | null | undefined, favouriteCount: number | null | undefined, sellerUrl: string | null | undefined, sellerName: string | null | undefined, sellerReviews: number | null | undefined, sellerRating: number | null | undefined, uploadedAt: string | null | undefined, inactivatedAt: string | null | undefined, lastUpdateAt: string | null | undefined, createdAt: string, attributes: Array<{ __typename?: 'ProductAttribute', key: string, name: string, value: string }> | null | undefined, images: Array<{ __typename?: 'ProductImage', url: string, displayOrder: number }> } | null | undefined };

export type GetAvailableBrandsQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  status: InputMaybe<ProductStatus>;
}>;


export type GetAvailableBrandsQuery = { __typename?: 'Query', getAvailableBrands: Array<{ __typename?: 'ProductBrandCount', brand: string, count: number }> };

export type GetAvailableItemConditionsQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  status: InputMaybe<ProductStatus>;
}>;


export type GetAvailableItemConditionsQuery = { __typename?: 'Query', getAvailableItemConditions: Array<{ __typename?: 'ProductItemConditionCount', itemCondition: ProductItemCondition, count: number }> };

export type GetProductsByStatusQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  status: ProductStatus;
}>;


export type GetProductsByStatusQuery = { __typename?: 'Query', getProductsByStatus: Array<{ __typename?: 'Product', id: string, url: string, title: string, description: string | null | undefined, price: number | null | undefined, status: ProductStatus, itemCondition: ProductItemCondition | null | undefined, brand: string | null | undefined, favouriteCount: number | null | undefined, sellerUrl: string | null | undefined, sellerName: string | null | undefined, sellerReviews: number | null | undefined, sellerRating: number | null | undefined, uploadedAt: string | null | undefined, inactivatedAt: string | null | undefined, lastUpdateAt: string | null | undefined, createdAt: string, attributes: Array<{ __typename?: 'ProductAttribute', key: string, name: string, value: string }> | null | undefined, images: Array<{ __typename?: 'ProductImage', url: string, displayOrder: number }> }> };

export type GetNicheSoldProductsQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  brandOrFullPath: Scalars['String']['input'];
}>;


export type GetNicheSoldProductsQuery = { __typename?: 'Query', getNicheSoldProducts: Array<{ __typename?: 'Product', id: string, url: string, title: string, description: string | null | undefined, price: number | null | undefined, status: ProductStatus, itemCondition: ProductItemCondition | null | undefined, brand: string | null | undefined, favouriteCount: number | null | undefined, sellerUrl: string | null | undefined, sellerName: string | null | undefined, sellerReviews: number | null | undefined, sellerRating: number | null | undefined, uploadedAt: string | null | undefined, inactivatedAt: string | null | undefined, lastUpdateAt: string | null | undefined, createdAt: string, attributes: Array<{ __typename?: 'ProductAttribute', key: string, name: string, value: string }> | null | undefined, images: Array<{ __typename?: 'ProductImage', url: string, displayOrder: number }> }> };

export type GetProductFeedQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  status: InputMaybe<ProductStatus>;
  limit: InputMaybe<Scalars['Int']['input']>;
  cursor: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<ProductSort>;
  brand: InputMaybe<Scalars['String']['input']>;
  searchText: InputMaybe<Scalars['String']['input']>;
  conditionIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  sizeIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  colorIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  countryIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  priceMin: InputMaybe<Scalars['Float']['input']>;
  priceMax: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetProductFeedQuery = { __typename?: 'Query', getProductFeed: { __typename?: 'PaginatedProduct', nextCursor: string | null | undefined, hasNextPage: boolean, products: Array<{ __typename?: 'Product', id: string, url: string, title: string, description: string | null | undefined, price: number | null | undefined, status: ProductStatus, itemCondition: ProductItemCondition | null | undefined, brand: string | null | undefined, favouriteCount: number | null | undefined, sellerUrl: string | null | undefined, sellerName: string | null | undefined, sellerReviews: number | null | undefined, sellerRating: number | null | undefined, uploadedAt: string | null | undefined, inactivatedAt: string | null | undefined, lastUpdateAt: string | null | undefined, createdAt: string, attributes: Array<{ __typename?: 'ProductAttribute', key: string, name: string, value: string }> | null | undefined, images: Array<{ __typename?: 'ProductImage', url: string, displayOrder: number }> }> } };

export type PreviewAnalysisMatchCountQueryVariables = Exact<{
  input: SearchCriteriaInput;
}>;


export type PreviewAnalysisMatchCountQuery = { __typename?: 'Query', previewAnalysisMatchCount: { __typename?: 'AnalysisMatchPreview', totalCount: number, capped: boolean, similarityPending: boolean, exhaustive: boolean, sampledCount: number | null | undefined } };

export type GetVintedCatalogTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVintedCatalogTreeQuery = { __typename?: 'Query', getVintedCatalogTree: Array<{ __typename?: 'VintedCatalogNode', id: number, title: string, children: Array<{ __typename?: 'VintedCatalogNode', id: number, title: string, children: Array<{ __typename?: 'VintedCatalogNode', id: number, title: string, children: Array<{ __typename?: 'VintedCatalogNode', id: number, title: string, children: Array<{ __typename?: 'VintedCatalogNode', id: number, title: string, children: Array<{ __typename?: 'VintedCatalogNode', id: number, title: string, children: Array<{ __typename?: 'VintedCatalogNode', id: number, title: string }> }> }> }> }> }> }> };

export type GetVintedCatalogFiltersQueryVariables = Exact<{
  mainCatalogIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetVintedCatalogFiltersQuery = { __typename?: 'Query', getVintedCatalogFilters: Array<{ __typename?: 'VintedCatalogFilter', type: VintedCatalogFilterType, title: string, search: boolean, options: Array<{ __typename?: 'VintedCatalogFilterOption', id: number, title: string, type: VintedCatalogFilterOptionType, itemsCount: number | null | undefined, hex: string | null | undefined, imageUrl: string | null | undefined, children: Array<{ __typename?: 'VintedCatalogFilterOption', id: number, title: string, itemsCount: number | null | undefined }> | null | undefined }> }> };

export type SearchVintedCatalogFilterOptionsQueryVariables = Exact<{
  mainCatalogIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  filterType: VintedCatalogFilterType;
  query: Scalars['String']['input'];
}>;


export type SearchVintedCatalogFilterOptionsQuery = { __typename?: 'Query', searchVintedCatalogFilterOptions: Array<{ __typename?: 'VintedCatalogFilterOption', id: number, title: string, itemsCount: number | null | undefined }> };

export type ParseVintedCatalogUrlQueryVariables = Exact<{
  catalogUrl: Scalars['String']['input'];
}>;


export type ParseVintedCatalogUrlQuery = { __typename?: 'Query', parseVintedCatalogUrl: { __typename?: 'ParsedVintedSearch', sellerVintedId: string | null | undefined, priceMin: number | null | undefined, priceMax: number | null | undefined, keywords: Array<string> | null | undefined, catalogs: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, brands: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, conditions: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, colors: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, sizes: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, materials: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, patterns: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, brandCollections: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, videoGamePlatforms: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, videoGameRatings: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, internalMemoryCapacities: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, languageBooks: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined, simLocks: Array<{ __typename?: 'ParsedVintedSearchOption', id: number, title: string }> | null | undefined } };

export type GetVintedCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVintedCountriesQuery = { __typename?: 'Query', getVintedCountries: Array<{ __typename?: 'VintedCountry', id: number, isoCode: string, name: string, region: AnalysisSellerRegion }> };

export type GetAvailableSubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableSubscriptionPlansQuery = { __typename?: 'Query', getAvailableSubscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, name: string, isPublic: boolean, priceMonthly: number | null | undefined, priceYearly: number | null | undefined, catalogAnalysisQuotas: number, profileAnalysisQuotas: number, trialPeriodDays: number, trialCatalogAnalysisQuotas: number | null | undefined, trialProfileAnalysisQuotas: number | null | undefined, trialVeilleQuotas: number | null | undefined, vestiaireAccess: boolean }> };

export type GetCurrentUserSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserSubscriptionQuery = { __typename?: 'Query', getCurrentUserSubscription: { __typename?: 'UserSubscription', isActive: boolean, isTrialing: boolean, inactivatedAt: string | null | undefined, cancelAt: string | null | undefined, plan: { __typename?: 'UserSubscriptionPlan', id: string, name: string, periodicity: SubscriptionPlanPeriodicity, price: number, nextRenewalAt: string | null | undefined } | null | undefined } | null | undefined };

export type GetCanStartFreeTrialQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCanStartFreeTrialQuery = { __typename?: 'Query', getCanStartFreeTrial: boolean };

export type GetTrendListQueryVariables = Exact<{
  catalogId: InputMaybe<Scalars['Int']['input']>;
  countryId: InputMaybe<Scalars['Int']['input']>;
  list: TrendListKind;
  runOffset: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTrendListQuery = { __typename?: 'Query', getTrendList: { __typename?: 'TrendList', list: TrendListKind, computedAt: string | null | undefined, weekAnchor: string | null | undefined, total: number, truncated: boolean, niches: Array<{ __typename?: 'TrendNiche', id: string, isStratum: boolean, name: string, nameSource: string, label: string | null | undefined, keyword: string | null | undefined, countryId: number | null | undefined, brand: { __typename?: 'TrendBrand', id: number, name: string } | null | undefined, catalog: { __typename?: 'TrendCatalog', rootId: number | null | undefined, rootName: string | null | undefined, level1Id: number | null | undefined, level1Name: string | null | undefined, leafId: number | null | undefined, leafName: string | null | undefined } | null | undefined, metrics: { __typename?: 'TrendNicheMetrics', productCount: number, soldPct: number | null | undefined, avgPrice: number | null | undefined, medianPrice: number | null | undefined, timeToSellHours: number | null | undefined, salesPerDay: number | null | undefined, caPerMonth: number | null | undefined, growthPct: number | null | undefined }, series: Array<{ __typename?: 'TrendSeriesPoint', day: string, sales: number }>, seed: { __typename?: 'TrendSeed', productId: string, title: string | null | undefined, imageUrl: string | null | undefined, url: string | null | undefined } | null | undefined, lastSales: Array<{ __typename?: 'TrendLastSale', productId: string, title: string | null | undefined, price: number | null | undefined, imageUrl: string | null | undefined, soldAt: string | null | undefined, url: string | null | undefined }>, topSellers: Array<{ __typename?: 'TrendTopSeller', sellerId: string, username: string | null | undefined, imageUrl: string | null | undefined, sales: number }>, relaunchCriteria: { __typename?: 'RelaunchSearchCriteria', catalogIds: Array<number> | null | undefined, brandIds: Array<number> | null | undefined, countryIds: Array<number> | null | undefined, sourceProductId: string | null | undefined, similarityThreshold: number | null | undefined, keywords: Array<string> | null | undefined, keywordsOperator: KeywordSearchOperator | null | undefined } | null | undefined }> } };

export type GetUserLanguageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLanguageQuery = { __typename?: 'Query', getUserLanguage: UserLanguage };

export type GetCurrentUserAnalysisQuotasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserAnalysisQuotasQuery = { __typename?: 'Query', getCurrentUserAnalysisQuotas: { __typename?: 'AnalysisQuota', hasPartialPublicAnalysisAccess: boolean, hasFullPublicAnalysisAccess: boolean, catalogAnalysesUsed: number, catalogAnalysesMax: number, catalogAnalysesAvailable: number, profileAnalysesUsed: number, profileAnalysesMax: number, profileAnalysesAvailable: number, canCreateCatalogAnalysis: boolean, canCreateProfileAnalysis: boolean } };

export type GetCurrentUserVestiaireAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserVestiaireAccessQuery = { __typename?: 'Query', getCurrentUserVestiaireAccess: boolean };

export type GetUserVeillesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserVeillesQuery = { __typename?: 'Query', getUserVeilles: Array<{ __typename?: 'Veille', id: string, name: string, type: VeilleType, state: VeilleState, createdAt: string, parsedFilter: Record<string, any> | null | undefined, sellerVintedId: string | null | undefined, pageUrl: string | null | undefined, imageUrl: string | null | undefined, sourceAnalysisId: string | null | undefined, historyState: VeilleHistoryState, similarityDegraded: boolean }> };

export type GetVeilleByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVeilleByIdQuery = { __typename?: 'Query', getVeilleById: { __typename?: 'Veille', id: string, name: string, type: VeilleType, state: VeilleState, createdAt: string, parsedFilter: Record<string, any> | null | undefined, sellerVintedId: string | null | undefined, pageUrl: string | null | undefined, imageUrl: string | null | undefined, sourceAnalysisId: string | null | undefined, historyState: VeilleHistoryState, similarityDegraded: boolean } | null | undefined };

export type GetCurrentUserVeilleQuotasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserVeilleQuotasQuery = { __typename?: 'Query', getCurrentUserVeilleQuotas: { __typename?: 'VeilleQuota', veillesUsed: number, veillesMax: number, veillesAvailable: number, canCreateVeille: boolean } };

export type GetSellerByLoginQueryVariables = Exact<{
  login: Scalars['String']['input'];
}>;


export type GetSellerByLoginQuery = { __typename?: 'Query', getSellerByLogin: { __typename?: 'SellerLookup', sellerVintedId: string, login: string } | null | undefined };

export type GetVeilleDailyStatsQueryVariables = Exact<{
  veilleId: Scalars['ID']['input'];
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetVeilleDailyStatsQuery = { __typename?: 'Query', getVeilleDailyStats: Array<{ __typename?: 'VeilleDailyStats', day: string, sales: number, newItems: number, sellers: number, averagePrice: number | null | undefined, sellThroughRate: number | null | undefined }> };

export type GetVeilleWeeklyStatsQueryVariables = Exact<{
  veilleId: Scalars['ID']['input'];
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetVeilleWeeklyStatsQuery = { __typename?: 'Query', getVeilleWeeklyStats: Array<{ __typename?: 'VeilleWeeklyStats', weekStart: string, daysCounted: number, sales: number, newItems: number, sellers: number, averagePrice: number | null | undefined, sellThroughRate: number | null | undefined }> };

export type GetVeilleStatsComparisonQueryVariables = Exact<{
  veilleId: Scalars['ID']['input'];
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetVeilleStatsComparisonQuery = { __typename?: 'Query', getVeilleStatsComparison: { __typename?: 'VeilleStatsComparison', currentPeriodDays: number, previousPeriodDays: number, salesVariation: number | null | undefined, newItemsVariation: number | null | undefined, sellersVariation: number | null | undefined, averagePriceVariation: number | null | undefined, sellThroughRateVariation: number | null | undefined } };

export type GetVeilleFeedQueryVariables = Exact<{
  veilleId: Scalars['ID']['input'];
  windowMinutes: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVeilleFeedQuery = { __typename?: 'Query', getVeilleFeed: { __typename?: 'VeilleFeedPage', nextCursor: string | null | undefined, items: Array<{ __typename?: 'VeilleFeedItem', productId: string, title: string, price: number | null | undefined, soldAt: string, sellerId: string | null | undefined, imageUrl: string | null | undefined, url: string, brandTitle: string | null | undefined, conditionTitle: string | null | undefined, sellerLogin: string | null | undefined, sellerFeedbackCount: number | null | undefined, sellerFeedbackRating: number | null | undefined, favouriteCount: number | null | undefined, uploadedAt: string | null | undefined }> } };

export type GetVeilleLiveCurveQueryVariables = Exact<{
  veilleId: Scalars['ID']['input'];
}>;


export type GetVeilleLiveCurveQuery = { __typename?: 'Query', getVeilleLiveCurve: Array<{ __typename?: 'VeilleLiveCurvePoint', bucketStart: string, sales: number, newItems: number, salesPerMinute: number, newItemsPerMinute: number }> };

export type GetUserNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationSettingsQuery = { __typename?: 'Query', getUserNotificationSettings: { __typename?: 'UserNotificationSettings', discordWebhook: string | null | undefined, notificationEmail: string | null | undefined } };

export type GetVeilleNotificationConfigQueryVariables = Exact<{
  veilleId: Scalars['ID']['input'];
}>;


export type GetVeilleNotificationConfigQuery = { __typename?: 'Query', getVeilleNotificationConfig: { __typename?: 'VeilleNotificationConfig', veilleId: string, eachSale: boolean, discordEnabled: boolean, thresholds: Record<string, any> | null | undefined, dailyReport: boolean, weeklyReport: boolean, emailEnabled: boolean, notificationEmail: string | null | undefined, lastDeliveryFailed: boolean, lastReason: string | null | undefined } | null | undefined };

export type GetVeilleNotificationHistoryQueryVariables = Exact<{
  veilleId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVeilleNotificationHistoryQuery = { __typename?: 'Query', getVeilleNotificationHistory: Array<{ __typename?: 'VeilleNotificationDelivery', at: string, kind: VeilleNotificationDeliveryKind, ok: boolean, reason: string | null | undefined, label: string | null | undefined }> };

export type GetVestiaireCatalogTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVestiaireCatalogTreeQuery = { __typename?: 'Query', getVestiaireCatalogTree: Array<{ __typename?: 'VestiaireCatalogNode', id: number, kind: VestiaireCatalogNodeKind, title: string, children: Array<{ __typename?: 'VestiaireCatalogNode', id: number, kind: VestiaireCatalogNodeKind, title: string, children: Array<{ __typename?: 'VestiaireCatalogNode', id: number, kind: VestiaireCatalogNodeKind, title: string, children: Array<{ __typename?: 'VestiaireCatalogNode', id: number, kind: VestiaireCatalogNodeKind, title: string }> }> }> }> };

export type GetVestiaireFilterOptionsQueryVariables = Exact<{
  filterType: VestiaireFilterType;
  query: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  ids: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetVestiaireFilterOptionsQuery = { __typename?: 'Query', getVestiaireFilterOptions: Array<{ __typename?: 'VestiaireFilterOption', id: number, title: string, parentId: number | null | undefined, level: number | null | undefined }> };

export type GetVestiaireCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVestiaireCountriesQuery = { __typename?: 'Query', getVestiaireCountries: Array<{ __typename?: 'VestiaireCountry', id: number, isoCode: string, name: string, region: AnalysisSellerRegion, sellerCount: number }> };

export type PreviewVestiaireMatchCountQueryVariables = Exact<{
  input: VestiaireSearchCriteriaInput;
}>;


export type PreviewVestiaireMatchCountQuery = { __typename?: 'Query', previewVestiaireMatchCount: { __typename?: 'VestiaireMatchPreview', totalCount: number, sampledCount: number, capped: boolean, sampleWindowDays: number, priceMin: number | null | undefined, priceMax: number | null | undefined, similarityPending: boolean } };

export type ParseVestiaireSellerRefQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type ParseVestiaireSellerRefQuery = { __typename?: 'Query', parseVestiaireSellerRef: { __typename?: 'VestiaireSellerRef', sellerId: string, profileUrl: string, username: string | null | undefined, known: boolean } | null | undefined };

export type ParseVestiaireSearchUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type ParseVestiaireSearchUrlQuery = { __typename?: 'Query', parseVestiaireSearchUrl: { __typename?: 'VestiaireSearchUrlImport', criteria: { __typename?: 'VestiaireRelaunchCriteria', universeIds: Array<number> | null | undefined, catalogRootIds: Array<number> | null | undefined, catalogLevel1Ids: Array<number> | null | undefined, catalogLevel2Ids: Array<number> | null | undefined, brandIds: Array<number> | null | undefined, modelIds: Array<number> | null | undefined, conditionIds: Array<number> | null | undefined, colorIds: Array<number> | null | undefined, materialIds: Array<number> | null | undefined, countryIds: Array<number> | null | undefined, sellerBadges: Array<VestiaireSellerBadge> | null | undefined, itemBadges: Array<VestiaireItemBadge> | null | undefined, priceMin: number | null | undefined, priceMax: number | null | undefined, keywords: Array<string> | null | undefined }, ignored: Array<{ __typename?: 'VestiaireUrlIgnoredPart', key: string, value: string }>, brands: Array<{ __typename?: 'VestiaireFilterOption', id: number, title: string }>, models: Array<{ __typename?: 'VestiaireFilterOption', id: number, title: string }> } };


export const AnalysisBaseFragmentDoc = `
    fragment AnalysisBase on Analysis {
  id
  name
  pageUrl
  imageUrl
  type
  isPublic
  userId
  publicCategoryId
  createdAt
  analysedProductCount
  folderId
  position
  isFavorite
  parentAnalysisId
  parsedFilter
  similarityDegraded
  scanTruncated
  computeState
  queuePosition
  publishedCount
  computeError
  platform
  vestiaireFilter
}
    `;
export const ProductBaseFragmentDoc = `
    fragment ProductBase on Product {
  id
  url
  title
  description
  price
  status
  itemCondition
  brand
  favouriteCount
  attributes {
    key
    name
    value
  }
  sellerUrl
  sellerName
  sellerReviews
  sellerRating
  uploadedAt
  inactivatedAt
  lastUpdateAt
  createdAt
  images {
    url
    displayOrder
  }
}
    `;
export const VeilleBaseFragmentDoc = `
    fragment VeilleBase on Veille {
  id
  name
  type
  state
  createdAt
  parsedFilter
  sellerVintedId
  pageUrl
  imageUrl
  sourceAnalysisId
  historyState
  similarityDegraded
}
    `;
export const CreateAnalysisFromFiltersDocument = `
    mutation CreateAnalysisFromFilters($input: CreateAnalysisFromFiltersInput!) {
  createAnalysisFromFilters(input: $input) {
    ...AnalysisBase
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useCreateAnalysisFromFiltersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAnalysisFromFiltersMutation, TError, CreateAnalysisFromFiltersMutationVariables, TContext>) => {
    
    return useMutation<CreateAnalysisFromFiltersMutation, TError, CreateAnalysisFromFiltersMutationVariables, TContext>(
      {
    mutationKey: ['CreateAnalysisFromFilters'],
    mutationFn: (variables?: CreateAnalysisFromFiltersMutationVariables) => graphqlClient<CreateAnalysisFromFiltersMutation, CreateAnalysisFromFiltersMutationVariables>(CreateAnalysisFromFiltersDocument, variables)(),
    ...options
  }
    )};

useCreateAnalysisFromFiltersMutation.getKey = () => ['CreateAnalysisFromFilters'];


useCreateAnalysisFromFiltersMutation.fetcher = (variables: CreateAnalysisFromFiltersMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateAnalysisFromFiltersMutation, CreateAnalysisFromFiltersMutationVariables>(CreateAnalysisFromFiltersDocument, variables, options);

export const CreateSearchImageUploadUrlDocument = `
    mutation CreateSearchImageUploadUrl($input: CreateSearchImageUploadUrlInput!) {
  createSearchImageUploadUrl(input: $input) {
    uploadUrl
    fields
    key
    publicUrl
    expiresInSecs
  }
}
    `;

export const useCreateSearchImageUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSearchImageUploadUrlMutation, TError, CreateSearchImageUploadUrlMutationVariables, TContext>) => {
    
    return useMutation<CreateSearchImageUploadUrlMutation, TError, CreateSearchImageUploadUrlMutationVariables, TContext>(
      {
    mutationKey: ['CreateSearchImageUploadUrl'],
    mutationFn: (variables?: CreateSearchImageUploadUrlMutationVariables) => graphqlClient<CreateSearchImageUploadUrlMutation, CreateSearchImageUploadUrlMutationVariables>(CreateSearchImageUploadUrlDocument, variables)(),
    ...options
  }
    )};

useCreateSearchImageUploadUrlMutation.getKey = () => ['CreateSearchImageUploadUrl'];


useCreateSearchImageUploadUrlMutation.fetcher = (variables: CreateSearchImageUploadUrlMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateSearchImageUploadUrlMutation, CreateSearchImageUploadUrlMutationVariables>(CreateSearchImageUploadUrlDocument, variables, options);

export const DeleteAnalysisDocument = `
    mutation DeleteAnalysis($id: ID!) {
  deleteAnalysis(id: $id)
}
    `;

export const useDeleteAnalysisMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAnalysisMutation, TError, DeleteAnalysisMutationVariables, TContext>) => {
    
    return useMutation<DeleteAnalysisMutation, TError, DeleteAnalysisMutationVariables, TContext>(
      {
    mutationKey: ['DeleteAnalysis'],
    mutationFn: (variables?: DeleteAnalysisMutationVariables) => graphqlClient<DeleteAnalysisMutation, DeleteAnalysisMutationVariables>(DeleteAnalysisDocument, variables)(),
    ...options
  }
    )};

useDeleteAnalysisMutation.getKey = () => ['DeleteAnalysis'];


useDeleteAnalysisMutation.fetcher = (variables: DeleteAnalysisMutationVariables, options?: RequestInit['headers']) => graphqlClient<DeleteAnalysisMutation, DeleteAnalysisMutationVariables>(DeleteAnalysisDocument, variables, options);

export const UpdateAnalysisNameDocument = `
    mutation UpdateAnalysisName($input: UpdateAnalysisNameInput!) {
  updateAnalysisName(input: $input) {
    ...AnalysisBase
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useUpdateAnalysisNameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAnalysisNameMutation, TError, UpdateAnalysisNameMutationVariables, TContext>) => {
    
    return useMutation<UpdateAnalysisNameMutation, TError, UpdateAnalysisNameMutationVariables, TContext>(
      {
    mutationKey: ['UpdateAnalysisName'],
    mutationFn: (variables?: UpdateAnalysisNameMutationVariables) => graphqlClient<UpdateAnalysisNameMutation, UpdateAnalysisNameMutationVariables>(UpdateAnalysisNameDocument, variables)(),
    ...options
  }
    )};

useUpdateAnalysisNameMutation.getKey = () => ['UpdateAnalysisName'];


useUpdateAnalysisNameMutation.fetcher = (variables: UpdateAnalysisNameMutationVariables, options?: RequestInit['headers']) => graphqlClient<UpdateAnalysisNameMutation, UpdateAnalysisNameMutationVariables>(UpdateAnalysisNameDocument, variables, options);

export const CreateSearchFolderDocument = `
    mutation CreateSearchFolder($input: CreateSearchFolderInput!) {
  createSearchFolder(input: $input) {
    id
    name
    type
    position
    createdAt
  }
}
    `;

export const useCreateSearchFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSearchFolderMutation, TError, CreateSearchFolderMutationVariables, TContext>) => {
    
    return useMutation<CreateSearchFolderMutation, TError, CreateSearchFolderMutationVariables, TContext>(
      {
    mutationKey: ['CreateSearchFolder'],
    mutationFn: (variables?: CreateSearchFolderMutationVariables) => graphqlClient<CreateSearchFolderMutation, CreateSearchFolderMutationVariables>(CreateSearchFolderDocument, variables)(),
    ...options
  }
    )};

useCreateSearchFolderMutation.getKey = () => ['CreateSearchFolder'];


useCreateSearchFolderMutation.fetcher = (variables: CreateSearchFolderMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateSearchFolderMutation, CreateSearchFolderMutationVariables>(CreateSearchFolderDocument, variables, options);

export const RenameSearchFolderDocument = `
    mutation RenameSearchFolder($input: RenameSearchFolderInput!) {
  renameSearchFolder(input: $input) {
    id
    name
  }
}
    `;

export const useRenameSearchFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RenameSearchFolderMutation, TError, RenameSearchFolderMutationVariables, TContext>) => {
    
    return useMutation<RenameSearchFolderMutation, TError, RenameSearchFolderMutationVariables, TContext>(
      {
    mutationKey: ['RenameSearchFolder'],
    mutationFn: (variables?: RenameSearchFolderMutationVariables) => graphqlClient<RenameSearchFolderMutation, RenameSearchFolderMutationVariables>(RenameSearchFolderDocument, variables)(),
    ...options
  }
    )};

useRenameSearchFolderMutation.getKey = () => ['RenameSearchFolder'];


useRenameSearchFolderMutation.fetcher = (variables: RenameSearchFolderMutationVariables, options?: RequestInit['headers']) => graphqlClient<RenameSearchFolderMutation, RenameSearchFolderMutationVariables>(RenameSearchFolderDocument, variables, options);

export const DeleteSearchFolderDocument = `
    mutation DeleteSearchFolder($id: ID!) {
  deleteSearchFolder(id: $id)
}
    `;

export const useDeleteSearchFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSearchFolderMutation, TError, DeleteSearchFolderMutationVariables, TContext>) => {
    
    return useMutation<DeleteSearchFolderMutation, TError, DeleteSearchFolderMutationVariables, TContext>(
      {
    mutationKey: ['DeleteSearchFolder'],
    mutationFn: (variables?: DeleteSearchFolderMutationVariables) => graphqlClient<DeleteSearchFolderMutation, DeleteSearchFolderMutationVariables>(DeleteSearchFolderDocument, variables)(),
    ...options
  }
    )};

useDeleteSearchFolderMutation.getKey = () => ['DeleteSearchFolder'];


useDeleteSearchFolderMutation.fetcher = (variables: DeleteSearchFolderMutationVariables, options?: RequestInit['headers']) => graphqlClient<DeleteSearchFolderMutation, DeleteSearchFolderMutationVariables>(DeleteSearchFolderDocument, variables, options);

export const MoveAnalysisToFolderDocument = `
    mutation MoveAnalysisToFolder($input: MoveAnalysisToFolderInput!) {
  moveAnalysisToFolder(input: $input) {
    id
    folderId
    position
  }
}
    `;

export const useMoveAnalysisToFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveAnalysisToFolderMutation, TError, MoveAnalysisToFolderMutationVariables, TContext>) => {
    
    return useMutation<MoveAnalysisToFolderMutation, TError, MoveAnalysisToFolderMutationVariables, TContext>(
      {
    mutationKey: ['MoveAnalysisToFolder'],
    mutationFn: (variables?: MoveAnalysisToFolderMutationVariables) => graphqlClient<MoveAnalysisToFolderMutation, MoveAnalysisToFolderMutationVariables>(MoveAnalysisToFolderDocument, variables)(),
    ...options
  }
    )};

useMoveAnalysisToFolderMutation.getKey = () => ['MoveAnalysisToFolder'];


useMoveAnalysisToFolderMutation.fetcher = (variables: MoveAnalysisToFolderMutationVariables, options?: RequestInit['headers']) => graphqlClient<MoveAnalysisToFolderMutation, MoveAnalysisToFolderMutationVariables>(MoveAnalysisToFolderDocument, variables, options);

export const MoveAnalysisToPositionDocument = `
    mutation MoveAnalysisToPosition($input: MoveAnalysisToPositionInput!) {
  moveAnalysisToPosition(input: $input) {
    id
    position
  }
}
    `;

export const useMoveAnalysisToPositionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveAnalysisToPositionMutation, TError, MoveAnalysisToPositionMutationVariables, TContext>) => {
    
    return useMutation<MoveAnalysisToPositionMutation, TError, MoveAnalysisToPositionMutationVariables, TContext>(
      {
    mutationKey: ['MoveAnalysisToPosition'],
    mutationFn: (variables?: MoveAnalysisToPositionMutationVariables) => graphqlClient<MoveAnalysisToPositionMutation, MoveAnalysisToPositionMutationVariables>(MoveAnalysisToPositionDocument, variables)(),
    ...options
  }
    )};

useMoveAnalysisToPositionMutation.getKey = () => ['MoveAnalysisToPosition'];


useMoveAnalysisToPositionMutation.fetcher = (variables: MoveAnalysisToPositionMutationVariables, options?: RequestInit['headers']) => graphqlClient<MoveAnalysisToPositionMutation, MoveAnalysisToPositionMutationVariables>(MoveAnalysisToPositionDocument, variables, options);

export const MoveFolderToPositionDocument = `
    mutation MoveFolderToPosition($input: MoveFolderToPositionInput!) {
  moveFolderToPosition(input: $input) {
    id
    position
  }
}
    `;

export const useMoveFolderToPositionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveFolderToPositionMutation, TError, MoveFolderToPositionMutationVariables, TContext>) => {
    
    return useMutation<MoveFolderToPositionMutation, TError, MoveFolderToPositionMutationVariables, TContext>(
      {
    mutationKey: ['MoveFolderToPosition'],
    mutationFn: (variables?: MoveFolderToPositionMutationVariables) => graphqlClient<MoveFolderToPositionMutation, MoveFolderToPositionMutationVariables>(MoveFolderToPositionDocument, variables)(),
    ...options
  }
    )};

useMoveFolderToPositionMutation.getKey = () => ['MoveFolderToPosition'];


useMoveFolderToPositionMutation.fetcher = (variables: MoveFolderToPositionMutationVariables, options?: RequestInit['headers']) => graphqlClient<MoveFolderToPositionMutation, MoveFolderToPositionMutationVariables>(MoveFolderToPositionDocument, variables, options);

export const ToggleAnalysisFavoriteDocument = `
    mutation ToggleAnalysisFavorite($analysisId: ID!) {
  toggleAnalysisFavorite(analysisId: $analysisId) {
    id
    isFavorite
  }
}
    `;

export const useToggleAnalysisFavoriteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleAnalysisFavoriteMutation, TError, ToggleAnalysisFavoriteMutationVariables, TContext>) => {
    
    return useMutation<ToggleAnalysisFavoriteMutation, TError, ToggleAnalysisFavoriteMutationVariables, TContext>(
      {
    mutationKey: ['ToggleAnalysisFavorite'],
    mutationFn: (variables?: ToggleAnalysisFavoriteMutationVariables) => graphqlClient<ToggleAnalysisFavoriteMutation, ToggleAnalysisFavoriteMutationVariables>(ToggleAnalysisFavoriteDocument, variables)(),
    ...options
  }
    )};

useToggleAnalysisFavoriteMutation.getKey = () => ['ToggleAnalysisFavorite'];


useToggleAnalysisFavoriteMutation.fetcher = (variables: ToggleAnalysisFavoriteMutationVariables, options?: RequestInit['headers']) => graphqlClient<ToggleAnalysisFavoriteMutation, ToggleAnalysisFavoriteMutationVariables>(ToggleAnalysisFavoriteDocument, variables, options);

export const SetAnalysisParentDocument = `
    mutation SetAnalysisParent($input: SetAnalysisParentInput!) {
  setAnalysisParent(input: $input) {
    id
    parentAnalysisId
  }
}
    `;

export const useSetAnalysisParentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetAnalysisParentMutation, TError, SetAnalysisParentMutationVariables, TContext>) => {
    
    return useMutation<SetAnalysisParentMutation, TError, SetAnalysisParentMutationVariables, TContext>(
      {
    mutationKey: ['SetAnalysisParent'],
    mutationFn: (variables?: SetAnalysisParentMutationVariables) => graphqlClient<SetAnalysisParentMutation, SetAnalysisParentMutationVariables>(SetAnalysisParentDocument, variables)(),
    ...options
  }
    )};

useSetAnalysisParentMutation.getKey = () => ['SetAnalysisParent'];


useSetAnalysisParentMutation.fetcher = (variables: SetAnalysisParentMutationVariables, options?: RequestInit['headers']) => graphqlClient<SetAnalysisParentMutation, SetAnalysisParentMutationVariables>(SetAnalysisParentDocument, variables, options);

export const RemoveAnalysisParentDocument = `
    mutation RemoveAnalysisParent($childId: ID!) {
  removeAnalysisParent(childId: $childId) {
    id
    parentAnalysisId
  }
}
    `;

export const useRemoveAnalysisParentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAnalysisParentMutation, TError, RemoveAnalysisParentMutationVariables, TContext>) => {
    
    return useMutation<RemoveAnalysisParentMutation, TError, RemoveAnalysisParentMutationVariables, TContext>(
      {
    mutationKey: ['RemoveAnalysisParent'],
    mutationFn: (variables?: RemoveAnalysisParentMutationVariables) => graphqlClient<RemoveAnalysisParentMutation, RemoveAnalysisParentMutationVariables>(RemoveAnalysisParentDocument, variables)(),
    ...options
  }
    )};

useRemoveAnalysisParentMutation.getKey = () => ['RemoveAnalysisParent'];


useRemoveAnalysisParentMutation.fetcher = (variables: RemoveAnalysisParentMutationVariables, options?: RequestInit['headers']) => graphqlClient<RemoveAnalysisParentMutation, RemoveAnalysisParentMutationVariables>(RemoveAnalysisParentDocument, variables, options);

export const CreateStripeCheckoutSessionDocument = `
    mutation CreateStripeCheckoutSession($input: CreateStripeCheckoutSessionInput!) {
  createStripeCheckoutSession(input: $input) {
    url
  }
}
    `;

export const useCreateStripeCheckoutSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateStripeCheckoutSessionMutation, TError, CreateStripeCheckoutSessionMutationVariables, TContext>) => {
    
    return useMutation<CreateStripeCheckoutSessionMutation, TError, CreateStripeCheckoutSessionMutationVariables, TContext>(
      {
    mutationKey: ['CreateStripeCheckoutSession'],
    mutationFn: (variables?: CreateStripeCheckoutSessionMutationVariables) => graphqlClient<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>(CreateStripeCheckoutSessionDocument, variables)(),
    ...options
  }
    )};

useCreateStripeCheckoutSessionMutation.getKey = () => ['CreateStripeCheckoutSession'];


useCreateStripeCheckoutSessionMutation.fetcher = (variables: CreateStripeCheckoutSessionMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>(CreateStripeCheckoutSessionDocument, variables, options);

export const CreateStripePortalSessionDocument = `
    mutation CreateStripePortalSession($input: CreateStripePortalSessionInput!) {
  createStripePortalSession(input: $input) {
    url
  }
}
    `;

export const useCreateStripePortalSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateStripePortalSessionMutation, TError, CreateStripePortalSessionMutationVariables, TContext>) => {
    
    return useMutation<CreateStripePortalSessionMutation, TError, CreateStripePortalSessionMutationVariables, TContext>(
      {
    mutationKey: ['CreateStripePortalSession'],
    mutationFn: (variables?: CreateStripePortalSessionMutationVariables) => graphqlClient<CreateStripePortalSessionMutation, CreateStripePortalSessionMutationVariables>(CreateStripePortalSessionDocument, variables)(),
    ...options
  }
    )};

useCreateStripePortalSessionMutation.getKey = () => ['CreateStripePortalSession'];


useCreateStripePortalSessionMutation.fetcher = (variables: CreateStripePortalSessionMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateStripePortalSessionMutation, CreateStripePortalSessionMutationVariables>(CreateStripePortalSessionDocument, variables, options);

export const SelectPlanDuringTrialDocument = `
    mutation SelectPlanDuringTrial($input: SelectPlanDuringTrialInput!) {
  selectPlanDuringTrial(input: $input) {
    isActive
    isTrialing
    plan {
      id
      name
      periodicity
      price
      nextRenewalAt
    }
    inactivatedAt
  }
}
    `;

export const useSelectPlanDuringTrialMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SelectPlanDuringTrialMutation, TError, SelectPlanDuringTrialMutationVariables, TContext>) => {
    
    return useMutation<SelectPlanDuringTrialMutation, TError, SelectPlanDuringTrialMutationVariables, TContext>(
      {
    mutationKey: ['SelectPlanDuringTrial'],
    mutationFn: (variables?: SelectPlanDuringTrialMutationVariables) => graphqlClient<SelectPlanDuringTrialMutation, SelectPlanDuringTrialMutationVariables>(SelectPlanDuringTrialDocument, variables)(),
    ...options
  }
    )};

useSelectPlanDuringTrialMutation.getKey = () => ['SelectPlanDuringTrial'];


useSelectPlanDuringTrialMutation.fetcher = (variables: SelectPlanDuringTrialMutationVariables, options?: RequestInit['headers']) => graphqlClient<SelectPlanDuringTrialMutation, SelectPlanDuringTrialMutationVariables>(SelectPlanDuringTrialDocument, variables, options);

export const UpdateUserLanguageDocument = `
    mutation UpdateUserLanguage($language: UserLanguage!) {
  updateUserLanguage(language: $language)
}
    `;

export const useUpdateUserLanguageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserLanguageMutation, TError, UpdateUserLanguageMutationVariables, TContext>) => {
    
    return useMutation<UpdateUserLanguageMutation, TError, UpdateUserLanguageMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserLanguage'],
    mutationFn: (variables?: UpdateUserLanguageMutationVariables) => graphqlClient<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(UpdateUserLanguageDocument, variables)(),
    ...options
  }
    )};

useUpdateUserLanguageMutation.getKey = () => ['UpdateUserLanguage'];


useUpdateUserLanguageMutation.fetcher = (variables: UpdateUserLanguageMutationVariables, options?: RequestInit['headers']) => graphqlClient<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(UpdateUserLanguageDocument, variables, options);

export const CreateVeilleDocument = `
    mutation CreateVeille($input: CreateVeilleInput!) {
  createVeille(input: $input) {
    ...VeilleBase
  }
}
    ${VeilleBaseFragmentDoc}`;

export const useCreateVeilleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateVeilleMutation, TError, CreateVeilleMutationVariables, TContext>) => {
    
    return useMutation<CreateVeilleMutation, TError, CreateVeilleMutationVariables, TContext>(
      {
    mutationKey: ['CreateVeille'],
    mutationFn: (variables?: CreateVeilleMutationVariables) => graphqlClient<CreateVeilleMutation, CreateVeilleMutationVariables>(CreateVeilleDocument, variables)(),
    ...options
  }
    )};

useCreateVeilleMutation.getKey = () => ['CreateVeille'];


useCreateVeilleMutation.fetcher = (variables: CreateVeilleMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateVeilleMutation, CreateVeilleMutationVariables>(CreateVeilleDocument, variables, options);

export const PauseVeilleDocument = `
    mutation PauseVeille($id: ID!) {
  pauseVeille(id: $id) {
    ...VeilleBase
  }
}
    ${VeilleBaseFragmentDoc}`;

export const usePauseVeilleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PauseVeilleMutation, TError, PauseVeilleMutationVariables, TContext>) => {
    
    return useMutation<PauseVeilleMutation, TError, PauseVeilleMutationVariables, TContext>(
      {
    mutationKey: ['PauseVeille'],
    mutationFn: (variables?: PauseVeilleMutationVariables) => graphqlClient<PauseVeilleMutation, PauseVeilleMutationVariables>(PauseVeilleDocument, variables)(),
    ...options
  }
    )};

usePauseVeilleMutation.getKey = () => ['PauseVeille'];


usePauseVeilleMutation.fetcher = (variables: PauseVeilleMutationVariables, options?: RequestInit['headers']) => graphqlClient<PauseVeilleMutation, PauseVeilleMutationVariables>(PauseVeilleDocument, variables, options);

export const ResumeVeilleDocument = `
    mutation ResumeVeille($id: ID!) {
  resumeVeille(id: $id) {
    ...VeilleBase
  }
}
    ${VeilleBaseFragmentDoc}`;

export const useResumeVeilleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResumeVeilleMutation, TError, ResumeVeilleMutationVariables, TContext>) => {
    
    return useMutation<ResumeVeilleMutation, TError, ResumeVeilleMutationVariables, TContext>(
      {
    mutationKey: ['ResumeVeille'],
    mutationFn: (variables?: ResumeVeilleMutationVariables) => graphqlClient<ResumeVeilleMutation, ResumeVeilleMutationVariables>(ResumeVeilleDocument, variables)(),
    ...options
  }
    )};

useResumeVeilleMutation.getKey = () => ['ResumeVeille'];


useResumeVeilleMutation.fetcher = (variables: ResumeVeilleMutationVariables, options?: RequestInit['headers']) => graphqlClient<ResumeVeilleMutation, ResumeVeilleMutationVariables>(ResumeVeilleDocument, variables, options);

export const StopVeilleDocument = `
    mutation StopVeille($id: ID!) {
  stopVeille(id: $id) {
    ...VeilleBase
  }
}
    ${VeilleBaseFragmentDoc}`;

export const useStopVeilleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StopVeilleMutation, TError, StopVeilleMutationVariables, TContext>) => {
    
    return useMutation<StopVeilleMutation, TError, StopVeilleMutationVariables, TContext>(
      {
    mutationKey: ['StopVeille'],
    mutationFn: (variables?: StopVeilleMutationVariables) => graphqlClient<StopVeilleMutation, StopVeilleMutationVariables>(StopVeilleDocument, variables)(),
    ...options
  }
    )};

useStopVeilleMutation.getKey = () => ['StopVeille'];


useStopVeilleMutation.fetcher = (variables: StopVeilleMutationVariables, options?: RequestInit['headers']) => graphqlClient<StopVeilleMutation, StopVeilleMutationVariables>(StopVeilleDocument, variables, options);

export const RenameVeilleDocument = `
    mutation RenameVeille($id: ID!, $name: String!) {
  renameVeille(id: $id, name: $name) {
    ...VeilleBase
  }
}
    ${VeilleBaseFragmentDoc}`;

export const useRenameVeilleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RenameVeilleMutation, TError, RenameVeilleMutationVariables, TContext>) => {
    
    return useMutation<RenameVeilleMutation, TError, RenameVeilleMutationVariables, TContext>(
      {
    mutationKey: ['RenameVeille'],
    mutationFn: (variables?: RenameVeilleMutationVariables) => graphqlClient<RenameVeilleMutation, RenameVeilleMutationVariables>(RenameVeilleDocument, variables)(),
    ...options
  }
    )};

useRenameVeilleMutation.getKey = () => ['RenameVeille'];


useRenameVeilleMutation.fetcher = (variables: RenameVeilleMutationVariables, options?: RequestInit['headers']) => graphqlClient<RenameVeilleMutation, RenameVeilleMutationVariables>(RenameVeilleDocument, variables, options);

export const UpdateVeilleNotificationConfigDocument = `
    mutation UpdateVeilleNotificationConfig($input: UpdateVeilleNotificationInput!) {
  updateVeilleNotificationConfig(input: $input) {
    veilleId
    eachSale
    discordEnabled
    thresholds
    dailyReport
    weeklyReport
    emailEnabled
    notificationEmail
    lastDeliveryFailed
    lastReason
  }
}
    `;

export const useUpdateVeilleNotificationConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateVeilleNotificationConfigMutation, TError, UpdateVeilleNotificationConfigMutationVariables, TContext>) => {
    
    return useMutation<UpdateVeilleNotificationConfigMutation, TError, UpdateVeilleNotificationConfigMutationVariables, TContext>(
      {
    mutationKey: ['UpdateVeilleNotificationConfig'],
    mutationFn: (variables?: UpdateVeilleNotificationConfigMutationVariables) => graphqlClient<UpdateVeilleNotificationConfigMutation, UpdateVeilleNotificationConfigMutationVariables>(UpdateVeilleNotificationConfigDocument, variables)(),
    ...options
  }
    )};

useUpdateVeilleNotificationConfigMutation.getKey = () => ['UpdateVeilleNotificationConfig'];


useUpdateVeilleNotificationConfigMutation.fetcher = (variables: UpdateVeilleNotificationConfigMutationVariables, options?: RequestInit['headers']) => graphqlClient<UpdateVeilleNotificationConfigMutation, UpdateVeilleNotificationConfigMutationVariables>(UpdateVeilleNotificationConfigDocument, variables, options);

export const UpdateUserNotificationSettingsDocument = `
    mutation UpdateUserNotificationSettings($input: UpdateUserNotificationSettingsInput!) {
  updateUserNotificationSettings(input: $input) {
    discordWebhook
    notificationEmail
  }
}
    `;

export const useUpdateUserNotificationSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserNotificationSettingsMutation, TError, UpdateUserNotificationSettingsMutationVariables, TContext>) => {
    
    return useMutation<UpdateUserNotificationSettingsMutation, TError, UpdateUserNotificationSettingsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserNotificationSettings'],
    mutationFn: (variables?: UpdateUserNotificationSettingsMutationVariables) => graphqlClient<UpdateUserNotificationSettingsMutation, UpdateUserNotificationSettingsMutationVariables>(UpdateUserNotificationSettingsDocument, variables)(),
    ...options
  }
    )};

useUpdateUserNotificationSettingsMutation.getKey = () => ['UpdateUserNotificationSettings'];


useUpdateUserNotificationSettingsMutation.fetcher = (variables: UpdateUserNotificationSettingsMutationVariables, options?: RequestInit['headers']) => graphqlClient<UpdateUserNotificationSettingsMutation, UpdateUserNotificationSettingsMutationVariables>(UpdateUserNotificationSettingsDocument, variables, options);

export const CreateVestiaireAnalysisDocument = `
    mutation CreateVestiaireAnalysis($input: CreateVestiaireAnalysisInput!) {
  createVestiaireAnalysis(input: $input) {
    ...AnalysisBase
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useCreateVestiaireAnalysisMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateVestiaireAnalysisMutation, TError, CreateVestiaireAnalysisMutationVariables, TContext>) => {
    
    return useMutation<CreateVestiaireAnalysisMutation, TError, CreateVestiaireAnalysisMutationVariables, TContext>(
      {
    mutationKey: ['CreateVestiaireAnalysis'],
    mutationFn: (variables?: CreateVestiaireAnalysisMutationVariables) => graphqlClient<CreateVestiaireAnalysisMutation, CreateVestiaireAnalysisMutationVariables>(CreateVestiaireAnalysisDocument, variables)(),
    ...options
  }
    )};

useCreateVestiaireAnalysisMutation.getKey = () => ['CreateVestiaireAnalysis'];


useCreateVestiaireAnalysisMutation.fetcher = (variables: CreateVestiaireAnalysisMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateVestiaireAnalysisMutation, CreateVestiaireAnalysisMutationVariables>(CreateVestiaireAnalysisDocument, variables, options);

export const GetAnalysisDashboardDocument = `
    query GetAnalysisDashboard($analysisId: ID!, $segment: AnalysisSegmentInput) {
  getAnalysisDashboard(analysisId: $analysisId, segment: $segment) {
    stats {
      averageSalePrice
      salePercentage
      averageSaleTimeSec
      totalProductsAnalyzed
      totalSalesRecorded
      newProductsPerDay
      salesPerDay
      priceDistributionQ1
      priceDistributionQ3
      priceDistributionMin
      priceDistributionMax
      priceDistributionBuckets {
        price
        count
      }
      caPerMonth
    }
    dailyActivity {
      date
      added
      sales
    }
    weeklyHeatmap {
      day
      slot
      added
      sales
    }
    saleTimeDistribution {
      maxHours
      count
    }
    characteristics {
      conditions {
        id
        title
        soldPct
        sales
      }
      sizes {
        id
        title
        soldPct
        sales
      }
    }
  }
}
    `;

export const useGetAnalysisDashboardQuery = <
      TData = GetAnalysisDashboardQuery,
      TError = unknown
    >(
      variables: GetAnalysisDashboardQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisDashboardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisDashboardQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisDashboardQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisDashboard', variables],
    queryFn: graphqlClient<GetAnalysisDashboardQuery, GetAnalysisDashboardQueryVariables>(GetAnalysisDashboardDocument, variables),
    ...options
  }
    )};

useGetAnalysisDashboardQuery.getKey = (variables: GetAnalysisDashboardQueryVariables) => ['GetAnalysisDashboard', variables];

export const useInfiniteGetAnalysisDashboardQuery = <
      TData = InfiniteData<GetAnalysisDashboardQuery>,
      TError = unknown
    >(
      variables: GetAnalysisDashboardQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisDashboardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisDashboardQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisDashboardQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisDashboard.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisDashboardQuery, GetAnalysisDashboardQueryVariables>(GetAnalysisDashboardDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisDashboardQuery.getKey = (variables: GetAnalysisDashboardQueryVariables) => ['GetAnalysisDashboard.infinite', variables];


useGetAnalysisDashboardQuery.fetcher = (variables: GetAnalysisDashboardQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisDashboardQuery, GetAnalysisDashboardQueryVariables>(GetAnalysisDashboardDocument, variables, options);

export const GetAnalysisSegmentFacetsDocument = `
    query GetAnalysisSegmentFacets($analysisId: ID!) {
  getAnalysisSegmentFacets(analysisId: $analysisId) {
    conditions {
      id
      title
      hex
      count
    }
    sizes {
      id
      title
      hex
      count
    }
    colors {
      id
      title
      hex
      count
    }
    countries {
      id
      title
      hex
      count
    }
    priceMin
    priceMax
  }
}
    `;

export const useGetAnalysisSegmentFacetsQuery = <
      TData = GetAnalysisSegmentFacetsQuery,
      TError = unknown
    >(
      variables: GetAnalysisSegmentFacetsQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisSegmentFacetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisSegmentFacetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisSegmentFacetsQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisSegmentFacets', variables],
    queryFn: graphqlClient<GetAnalysisSegmentFacetsQuery, GetAnalysisSegmentFacetsQueryVariables>(GetAnalysisSegmentFacetsDocument, variables),
    ...options
  }
    )};

useGetAnalysisSegmentFacetsQuery.getKey = (variables: GetAnalysisSegmentFacetsQueryVariables) => ['GetAnalysisSegmentFacets', variables];

export const useInfiniteGetAnalysisSegmentFacetsQuery = <
      TData = InfiniteData<GetAnalysisSegmentFacetsQuery>,
      TError = unknown
    >(
      variables: GetAnalysisSegmentFacetsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisSegmentFacetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisSegmentFacetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisSegmentFacetsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisSegmentFacets.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisSegmentFacetsQuery, GetAnalysisSegmentFacetsQueryVariables>(GetAnalysisSegmentFacetsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisSegmentFacetsQuery.getKey = (variables: GetAnalysisSegmentFacetsQueryVariables) => ['GetAnalysisSegmentFacets.infinite', variables];


useGetAnalysisSegmentFacetsQuery.fetcher = (variables: GetAnalysisSegmentFacetsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisSegmentFacetsQuery, GetAnalysisSegmentFacetsQueryVariables>(GetAnalysisSegmentFacetsDocument, variables, options);

export const GetAnalysisNichesDocument = `
    query GetAnalysisNiches($analysisId: ID!, $segment: AnalysisSegmentInput) {
  getAnalysisNiches(analysisId: $analysisId, segment: $segment) {
    type
    niche
    imageUrl
    avgPrice
    productCount
    soldPct
    soldPerDay
    addedPerDay
    timeToSellHours
    caPerMonth
    nicheId
    relaunchCriteria {
      countryIds
      priceMin
      priceMax
      catalogIds
      brandIds
      excludedBrandIds
      conditionIds
      colorIds
      sizeIds
      materialIds
      patternIds
      brandCollectionIds
      videoGamePlatformIds
      videoGameRatingIds
      internalMemoryCapacityIds
      languageBookIds
      simLockIds
      keywords
      keywordsOperator
      excludedKeywords
      imageKey
      sourceProductId
      description
    }
    vestiaireRelaunchCriteria {
      universeIds
      catalogRootIds
      catalogLevel1Ids
      catalogLevel2Ids
      brandIds
      excludedBrandIds
      modelIds
      conditionIds
      sizeIds
      colorIds
      materialIds
      countryIds
      sellerBadges
      itemBadges
      priceMin
      priceMax
      keywords
      keywordsOperator
      excludedKeywords
      imageKey
      sourceProductId
      similarityThreshold
      description
    }
  }
}
    `;

export const useGetAnalysisNichesQuery = <
      TData = GetAnalysisNichesQuery,
      TError = unknown
    >(
      variables: GetAnalysisNichesQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisNichesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisNichesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisNichesQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisNiches', variables],
    queryFn: graphqlClient<GetAnalysisNichesQuery, GetAnalysisNichesQueryVariables>(GetAnalysisNichesDocument, variables),
    ...options
  }
    )};

useGetAnalysisNichesQuery.getKey = (variables: GetAnalysisNichesQueryVariables) => ['GetAnalysisNiches', variables];

export const useInfiniteGetAnalysisNichesQuery = <
      TData = InfiniteData<GetAnalysisNichesQuery>,
      TError = unknown
    >(
      variables: GetAnalysisNichesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisNichesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisNichesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisNichesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisNiches.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisNichesQuery, GetAnalysisNichesQueryVariables>(GetAnalysisNichesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisNichesQuery.getKey = (variables: GetAnalysisNichesQueryVariables) => ['GetAnalysisNiches.infinite', variables];


useGetAnalysisNichesQuery.fetcher = (variables: GetAnalysisNichesQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisNichesQuery, GetAnalysisNichesQueryVariables>(GetAnalysisNichesDocument, variables, options);

export const GetAnalysisTopSellersDocument = `
    query GetAnalysisTopSellers($analysisId: ID!, $regions: [AnalysisSellerRegion!]) {
  getAnalysisTopSellers(analysisId: $analysisId, regions: $regions) {
    recurringSellerCount
    sellers {
      sellerId
      username
      region
      imageUrl
      rating
      reviews
      revenuePerMonth
      salesPerMonth
      avgPrice
      ratingBadge
      salesInAnalysis
      profileUrl
      lastSales {
        imageUrl
        title
        price
      }
    }
  }
}
    `;

export const useGetAnalysisTopSellersQuery = <
      TData = GetAnalysisTopSellersQuery,
      TError = unknown
    >(
      variables: GetAnalysisTopSellersQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisTopSellersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisTopSellersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisTopSellersQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisTopSellers', variables],
    queryFn: graphqlClient<GetAnalysisTopSellersQuery, GetAnalysisTopSellersQueryVariables>(GetAnalysisTopSellersDocument, variables),
    ...options
  }
    )};

useGetAnalysisTopSellersQuery.getKey = (variables: GetAnalysisTopSellersQueryVariables) => ['GetAnalysisTopSellers', variables];

export const useInfiniteGetAnalysisTopSellersQuery = <
      TData = InfiniteData<GetAnalysisTopSellersQuery>,
      TError = unknown
    >(
      variables: GetAnalysisTopSellersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisTopSellersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisTopSellersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisTopSellersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisTopSellers.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisTopSellersQuery, GetAnalysisTopSellersQueryVariables>(GetAnalysisTopSellersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisTopSellersQuery.getKey = (variables: GetAnalysisTopSellersQueryVariables) => ['GetAnalysisTopSellers.infinite', variables];


useGetAnalysisTopSellersQuery.fetcher = (variables: GetAnalysisTopSellersQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisTopSellersQuery, GetAnalysisTopSellersQueryVariables>(GetAnalysisTopSellersDocument, variables, options);

export const GetUserAnalysisStatsCsvDocument = `
    query GetUserAnalysisStatsCsv {
  getUserAnalysisStatsCsv
}
    `;

export const useGetUserAnalysisStatsCsvQuery = <
      TData = GetUserAnalysisStatsCsvQuery,
      TError = unknown
    >(
      variables?: GetUserAnalysisStatsCsvQueryVariables,
      options?: Omit<UseQueryOptions<GetUserAnalysisStatsCsvQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserAnalysisStatsCsvQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserAnalysisStatsCsvQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserAnalysisStatsCsv'] : ['GetUserAnalysisStatsCsv', variables],
    queryFn: graphqlClient<GetUserAnalysisStatsCsvQuery, GetUserAnalysisStatsCsvQueryVariables>(GetUserAnalysisStatsCsvDocument, variables),
    ...options
  }
    )};

useGetUserAnalysisStatsCsvQuery.getKey = (variables?: GetUserAnalysisStatsCsvQueryVariables) => variables === undefined ? ['GetUserAnalysisStatsCsv'] : ['GetUserAnalysisStatsCsv', variables];

export const useInfiniteGetUserAnalysisStatsCsvQuery = <
      TData = InfiniteData<GetUserAnalysisStatsCsvQuery>,
      TError = unknown
    >(
      variables: GetUserAnalysisStatsCsvQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserAnalysisStatsCsvQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserAnalysisStatsCsvQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserAnalysisStatsCsvQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetUserAnalysisStatsCsv.infinite'] : ['GetUserAnalysisStatsCsv.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetUserAnalysisStatsCsvQuery, GetUserAnalysisStatsCsvQueryVariables>(GetUserAnalysisStatsCsvDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserAnalysisStatsCsvQuery.getKey = (variables?: GetUserAnalysisStatsCsvQueryVariables) => variables === undefined ? ['GetUserAnalysisStatsCsv.infinite'] : ['GetUserAnalysisStatsCsv.infinite', variables];


useGetUserAnalysisStatsCsvQuery.fetcher = (variables?: GetUserAnalysisStatsCsvQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetUserAnalysisStatsCsvQuery, GetUserAnalysisStatsCsvQueryVariables>(GetUserAnalysisStatsCsvDocument, variables, options);

export const GetAnalysisByIdDocument = `
    query GetAnalysisById($id: ID!) {
  getAnalysisById(id: $id) {
    ...AnalysisBase
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useGetAnalysisByIdQuery = <
      TData = GetAnalysisByIdQuery,
      TError = unknown
    >(
      variables: GetAnalysisByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisByIdQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisById', variables],
    queryFn: graphqlClient<GetAnalysisByIdQuery, GetAnalysisByIdQueryVariables>(GetAnalysisByIdDocument, variables),
    ...options
  }
    )};

useGetAnalysisByIdQuery.getKey = (variables: GetAnalysisByIdQueryVariables) => ['GetAnalysisById', variables];

export const useInfiniteGetAnalysisByIdQuery = <
      TData = InfiniteData<GetAnalysisByIdQuery>,
      TError = unknown
    >(
      variables: GetAnalysisByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisById.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisByIdQuery, GetAnalysisByIdQueryVariables>(GetAnalysisByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisByIdQuery.getKey = (variables: GetAnalysisByIdQueryVariables) => ['GetAnalysisById.infinite', variables];


useGetAnalysisByIdQuery.fetcher = (variables: GetAnalysisByIdQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisByIdQuery, GetAnalysisByIdQueryVariables>(GetAnalysisByIdDocument, variables, options);

export const GetUserAnalysesPaginatedDocument = `
    query GetUserAnalysesPaginated($type: AnalysisType!, $cursor: String, $limit: Int) {
  getUserAnalysesPaginated(type: $type, cursor: $cursor, limit: $limit) {
    analyses {
      ...AnalysisBase
    }
    nextCursor
    hasNextPage
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useGetUserAnalysesPaginatedQuery = <
      TData = GetUserAnalysesPaginatedQuery,
      TError = unknown
    >(
      variables: GetUserAnalysesPaginatedQueryVariables,
      options?: Omit<UseQueryOptions<GetUserAnalysesPaginatedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserAnalysesPaginatedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserAnalysesPaginatedQuery, TError, TData>(
      {
    queryKey: ['GetUserAnalysesPaginated', variables],
    queryFn: graphqlClient<GetUserAnalysesPaginatedQuery, GetUserAnalysesPaginatedQueryVariables>(GetUserAnalysesPaginatedDocument, variables),
    ...options
  }
    )};

useGetUserAnalysesPaginatedQuery.getKey = (variables: GetUserAnalysesPaginatedQueryVariables) => ['GetUserAnalysesPaginated', variables];

export const useInfiniteGetUserAnalysesPaginatedQuery = <
      TData = InfiniteData<GetUserAnalysesPaginatedQuery>,
      TError = unknown
    >(
      variables: GetUserAnalysesPaginatedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserAnalysesPaginatedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserAnalysesPaginatedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserAnalysesPaginatedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUserAnalysesPaginated.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetUserAnalysesPaginatedQuery, GetUserAnalysesPaginatedQueryVariables>(GetUserAnalysesPaginatedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserAnalysesPaginatedQuery.getKey = (variables: GetUserAnalysesPaginatedQueryVariables) => ['GetUserAnalysesPaginated.infinite', variables];


useGetUserAnalysesPaginatedQuery.fetcher = (variables: GetUserAnalysesPaginatedQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetUserAnalysesPaginatedQuery, GetUserAnalysesPaginatedQueryVariables>(GetUserAnalysesPaginatedDocument, variables, options);

export const GetPublicAnalysisCategoriesDocument = `
    query GetPublicAnalysisCategories {
  getPublicAnalysisCategories {
    id
    name
    analyses {
      ...AnalysisBase
    }
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useGetPublicAnalysisCategoriesQuery = <
      TData = GetPublicAnalysisCategoriesQuery,
      TError = unknown
    >(
      variables?: GetPublicAnalysisCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<GetPublicAnalysisCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPublicAnalysisCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPublicAnalysisCategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPublicAnalysisCategories'] : ['GetPublicAnalysisCategories', variables],
    queryFn: graphqlClient<GetPublicAnalysisCategoriesQuery, GetPublicAnalysisCategoriesQueryVariables>(GetPublicAnalysisCategoriesDocument, variables),
    ...options
  }
    )};

useGetPublicAnalysisCategoriesQuery.getKey = (variables?: GetPublicAnalysisCategoriesQueryVariables) => variables === undefined ? ['GetPublicAnalysisCategories'] : ['GetPublicAnalysisCategories', variables];

export const useInfiniteGetPublicAnalysisCategoriesQuery = <
      TData = InfiniteData<GetPublicAnalysisCategoriesQuery>,
      TError = unknown
    >(
      variables: GetPublicAnalysisCategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetPublicAnalysisCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetPublicAnalysisCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetPublicAnalysisCategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetPublicAnalysisCategories.infinite'] : ['GetPublicAnalysisCategories.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetPublicAnalysisCategoriesQuery, GetPublicAnalysisCategoriesQueryVariables>(GetPublicAnalysisCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetPublicAnalysisCategoriesQuery.getKey = (variables?: GetPublicAnalysisCategoriesQueryVariables) => variables === undefined ? ['GetPublicAnalysisCategories.infinite'] : ['GetPublicAnalysisCategories.infinite', variables];


useGetPublicAnalysisCategoriesQuery.fetcher = (variables?: GetPublicAnalysisCategoriesQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetPublicAnalysisCategoriesQuery, GetPublicAnalysisCategoriesQueryVariables>(GetPublicAnalysisCategoriesDocument, variables, options);

export const GetAnalysisBrandDistributionDocument = `
    query GetAnalysisBrandDistribution($analysisId: ID!, $categoryPath: String) {
  getAnalysisBrandDistribution(
    analysisId: $analysisId
    categoryPath: $categoryPath
  ) {
    brand
    sellsCount
    totalSellsPrice
    avgSellsPrice
  }
}
    `;

export const useGetAnalysisBrandDistributionQuery = <
      TData = GetAnalysisBrandDistributionQuery,
      TError = unknown
    >(
      variables: GetAnalysisBrandDistributionQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisBrandDistributionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisBrandDistributionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisBrandDistributionQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisBrandDistribution', variables],
    queryFn: graphqlClient<GetAnalysisBrandDistributionQuery, GetAnalysisBrandDistributionQueryVariables>(GetAnalysisBrandDistributionDocument, variables),
    ...options
  }
    )};

useGetAnalysisBrandDistributionQuery.getKey = (variables: GetAnalysisBrandDistributionQueryVariables) => ['GetAnalysisBrandDistribution', variables];

export const useInfiniteGetAnalysisBrandDistributionQuery = <
      TData = InfiniteData<GetAnalysisBrandDistributionQuery>,
      TError = unknown
    >(
      variables: GetAnalysisBrandDistributionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisBrandDistributionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisBrandDistributionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisBrandDistributionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisBrandDistribution.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisBrandDistributionQuery, GetAnalysisBrandDistributionQueryVariables>(GetAnalysisBrandDistributionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisBrandDistributionQuery.getKey = (variables: GetAnalysisBrandDistributionQueryVariables) => ['GetAnalysisBrandDistribution.infinite', variables];


useGetAnalysisBrandDistributionQuery.fetcher = (variables: GetAnalysisBrandDistributionQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisBrandDistributionQuery, GetAnalysisBrandDistributionQueryVariables>(GetAnalysisBrandDistributionDocument, variables, options);

export const GetAnalysisCategoriesLevelsDistributionDocument = `
    query GetAnalysisCategoriesLevelsDistribution($analysisId: ID!) {
  getAnalysisCategoriesLevelsDistribution(analysisId: $analysisId) {
    level
    categories {
      categoryName
      fullPath
      level
      sellsCount
      totalSellsPrice
      avgSellsPrice
    }
  }
}
    `;

export const useGetAnalysisCategoriesLevelsDistributionQuery = <
      TData = GetAnalysisCategoriesLevelsDistributionQuery,
      TError = unknown
    >(
      variables: GetAnalysisCategoriesLevelsDistributionQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisCategoriesLevelsDistribution', variables],
    queryFn: graphqlClient<GetAnalysisCategoriesLevelsDistributionQuery, GetAnalysisCategoriesLevelsDistributionQueryVariables>(GetAnalysisCategoriesLevelsDistributionDocument, variables),
    ...options
  }
    )};

useGetAnalysisCategoriesLevelsDistributionQuery.getKey = (variables: GetAnalysisCategoriesLevelsDistributionQueryVariables) => ['GetAnalysisCategoriesLevelsDistribution', variables];

export const useInfiniteGetAnalysisCategoriesLevelsDistributionQuery = <
      TData = InfiniteData<GetAnalysisCategoriesLevelsDistributionQuery>,
      TError = unknown
    >(
      variables: GetAnalysisCategoriesLevelsDistributionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisCategoriesLevelsDistribution.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisCategoriesLevelsDistributionQuery, GetAnalysisCategoriesLevelsDistributionQueryVariables>(GetAnalysisCategoriesLevelsDistributionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisCategoriesLevelsDistributionQuery.getKey = (variables: GetAnalysisCategoriesLevelsDistributionQueryVariables) => ['GetAnalysisCategoriesLevelsDistribution.infinite', variables];


useGetAnalysisCategoriesLevelsDistributionQuery.fetcher = (variables: GetAnalysisCategoriesLevelsDistributionQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisCategoriesLevelsDistributionQuery, GetAnalysisCategoriesLevelsDistributionQueryVariables>(GetAnalysisCategoriesLevelsDistributionDocument, variables, options);

export const GetUserSearchFoldersDocument = `
    query GetUserSearchFolders($type: AnalysisType!) {
  getUserSearchFolders(type: $type) {
    id
    name
    type
    position
    createdAt
  }
}
    `;

export const useGetUserSearchFoldersQuery = <
      TData = GetUserSearchFoldersQuery,
      TError = unknown
    >(
      variables: GetUserSearchFoldersQueryVariables,
      options?: Omit<UseQueryOptions<GetUserSearchFoldersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserSearchFoldersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserSearchFoldersQuery, TError, TData>(
      {
    queryKey: ['GetUserSearchFolders', variables],
    queryFn: graphqlClient<GetUserSearchFoldersQuery, GetUserSearchFoldersQueryVariables>(GetUserSearchFoldersDocument, variables),
    ...options
  }
    )};

useGetUserSearchFoldersQuery.getKey = (variables: GetUserSearchFoldersQueryVariables) => ['GetUserSearchFolders', variables];

export const useInfiniteGetUserSearchFoldersQuery = <
      TData = InfiniteData<GetUserSearchFoldersQuery>,
      TError = unknown
    >(
      variables: GetUserSearchFoldersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserSearchFoldersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserSearchFoldersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserSearchFoldersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUserSearchFolders.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetUserSearchFoldersQuery, GetUserSearchFoldersQueryVariables>(GetUserSearchFoldersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserSearchFoldersQuery.getKey = (variables: GetUserSearchFoldersQueryVariables) => ['GetUserSearchFolders.infinite', variables];


useGetUserSearchFoldersQuery.fetcher = (variables: GetUserSearchFoldersQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetUserSearchFoldersQuery, GetUserSearchFoldersQueryVariables>(GetUserSearchFoldersDocument, variables, options);

export const GetAnalysisEngineStatusDocument = `
    query GetAnalysisEngineStatus {
  getAnalysisEngineStatus {
    state
    engine
    messageCode
    windowDays
    staleDays
    incompleteVectorDays
    checkedAt
  }
}
    `;

export const useGetAnalysisEngineStatusQuery = <
      TData = GetAnalysisEngineStatusQuery,
      TError = unknown
    >(
      variables?: GetAnalysisEngineStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisEngineStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisEngineStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisEngineStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAnalysisEngineStatus'] : ['GetAnalysisEngineStatus', variables],
    queryFn: graphqlClient<GetAnalysisEngineStatusQuery, GetAnalysisEngineStatusQueryVariables>(GetAnalysisEngineStatusDocument, variables),
    ...options
  }
    )};

useGetAnalysisEngineStatusQuery.getKey = (variables?: GetAnalysisEngineStatusQueryVariables) => variables === undefined ? ['GetAnalysisEngineStatus'] : ['GetAnalysisEngineStatus', variables];

export const useInfiniteGetAnalysisEngineStatusQuery = <
      TData = InfiniteData<GetAnalysisEngineStatusQuery>,
      TError = unknown
    >(
      variables: GetAnalysisEngineStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisEngineStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisEngineStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisEngineStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetAnalysisEngineStatus.infinite'] : ['GetAnalysisEngineStatus.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisEngineStatusQuery, GetAnalysisEngineStatusQueryVariables>(GetAnalysisEngineStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisEngineStatusQuery.getKey = (variables?: GetAnalysisEngineStatusQueryVariables) => variables === undefined ? ['GetAnalysisEngineStatus.infinite'] : ['GetAnalysisEngineStatus.infinite', variables];


useGetAnalysisEngineStatusQuery.fetcher = (variables?: GetAnalysisEngineStatusQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisEngineStatusQuery, GetAnalysisEngineStatusQueryVariables>(GetAnalysisEngineStatusDocument, variables, options);

export const GetProductByIdDocument = `
    query GetProductById($id: ID!) {
  getProductById(id: $id) {
    ...ProductBase
  }
}
    ${ProductBaseFragmentDoc}`;

export const useGetProductByIdQuery = <
      TData = GetProductByIdQuery,
      TError = unknown
    >(
      variables: GetProductByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProductByIdQuery, TError, TData>(
      {
    queryKey: ['GetProductById', variables],
    queryFn: graphqlClient<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, variables),
    ...options
  }
    )};

useGetProductByIdQuery.getKey = (variables: GetProductByIdQueryVariables) => ['GetProductById', variables];

export const useInfiniteGetProductByIdQuery = <
      TData = InfiniteData<GetProductByIdQuery>,
      TError = unknown
    >(
      variables: GetProductByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetProductByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProductById.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProductByIdQuery.getKey = (variables: GetProductByIdQueryVariables) => ['GetProductById.infinite', variables];


useGetProductByIdQuery.fetcher = (variables: GetProductByIdQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, variables, options);

export const GetAvailableBrandsDocument = `
    query GetAvailableBrands($analysisId: ID!, $status: ProductStatus) {
  getAvailableBrands(analysisId: $analysisId, status: $status) {
    brand
    count
  }
}
    `;

export const useGetAvailableBrandsQuery = <
      TData = GetAvailableBrandsQuery,
      TError = unknown
    >(
      variables: GetAvailableBrandsQueryVariables,
      options?: Omit<UseQueryOptions<GetAvailableBrandsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAvailableBrandsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAvailableBrandsQuery, TError, TData>(
      {
    queryKey: ['GetAvailableBrands', variables],
    queryFn: graphqlClient<GetAvailableBrandsQuery, GetAvailableBrandsQueryVariables>(GetAvailableBrandsDocument, variables),
    ...options
  }
    )};

useGetAvailableBrandsQuery.getKey = (variables: GetAvailableBrandsQueryVariables) => ['GetAvailableBrands', variables];

export const useInfiniteGetAvailableBrandsQuery = <
      TData = InfiniteData<GetAvailableBrandsQuery>,
      TError = unknown
    >(
      variables: GetAvailableBrandsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAvailableBrandsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAvailableBrandsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAvailableBrandsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAvailableBrands.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAvailableBrandsQuery, GetAvailableBrandsQueryVariables>(GetAvailableBrandsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAvailableBrandsQuery.getKey = (variables: GetAvailableBrandsQueryVariables) => ['GetAvailableBrands.infinite', variables];


useGetAvailableBrandsQuery.fetcher = (variables: GetAvailableBrandsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAvailableBrandsQuery, GetAvailableBrandsQueryVariables>(GetAvailableBrandsDocument, variables, options);

export const GetAvailableItemConditionsDocument = `
    query GetAvailableItemConditions($analysisId: ID!, $status: ProductStatus) {
  getAvailableItemConditions(analysisId: $analysisId, status: $status) {
    itemCondition
    count
  }
}
    `;

export const useGetAvailableItemConditionsQuery = <
      TData = GetAvailableItemConditionsQuery,
      TError = unknown
    >(
      variables: GetAvailableItemConditionsQueryVariables,
      options?: Omit<UseQueryOptions<GetAvailableItemConditionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAvailableItemConditionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAvailableItemConditionsQuery, TError, TData>(
      {
    queryKey: ['GetAvailableItemConditions', variables],
    queryFn: graphqlClient<GetAvailableItemConditionsQuery, GetAvailableItemConditionsQueryVariables>(GetAvailableItemConditionsDocument, variables),
    ...options
  }
    )};

useGetAvailableItemConditionsQuery.getKey = (variables: GetAvailableItemConditionsQueryVariables) => ['GetAvailableItemConditions', variables];

export const useInfiniteGetAvailableItemConditionsQuery = <
      TData = InfiniteData<GetAvailableItemConditionsQuery>,
      TError = unknown
    >(
      variables: GetAvailableItemConditionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAvailableItemConditionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAvailableItemConditionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAvailableItemConditionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAvailableItemConditions.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAvailableItemConditionsQuery, GetAvailableItemConditionsQueryVariables>(GetAvailableItemConditionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAvailableItemConditionsQuery.getKey = (variables: GetAvailableItemConditionsQueryVariables) => ['GetAvailableItemConditions.infinite', variables];


useGetAvailableItemConditionsQuery.fetcher = (variables: GetAvailableItemConditionsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAvailableItemConditionsQuery, GetAvailableItemConditionsQueryVariables>(GetAvailableItemConditionsDocument, variables, options);

export const GetProductsByStatusDocument = `
    query GetProductsByStatus($analysisId: ID!, $status: ProductStatus!) {
  getProductsByStatus(analysisId: $analysisId, status: $status) {
    ...ProductBase
  }
}
    ${ProductBaseFragmentDoc}`;

export const useGetProductsByStatusQuery = <
      TData = GetProductsByStatusQuery,
      TError = unknown
    >(
      variables: GetProductsByStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetProductsByStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProductsByStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProductsByStatusQuery, TError, TData>(
      {
    queryKey: ['GetProductsByStatus', variables],
    queryFn: graphqlClient<GetProductsByStatusQuery, GetProductsByStatusQueryVariables>(GetProductsByStatusDocument, variables),
    ...options
  }
    )};

useGetProductsByStatusQuery.getKey = (variables: GetProductsByStatusQueryVariables) => ['GetProductsByStatus', variables];

export const useInfiniteGetProductsByStatusQuery = <
      TData = InfiniteData<GetProductsByStatusQuery>,
      TError = unknown
    >(
      variables: GetProductsByStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProductsByStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProductsByStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetProductsByStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProductsByStatus.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetProductsByStatusQuery, GetProductsByStatusQueryVariables>(GetProductsByStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProductsByStatusQuery.getKey = (variables: GetProductsByStatusQueryVariables) => ['GetProductsByStatus.infinite', variables];


useGetProductsByStatusQuery.fetcher = (variables: GetProductsByStatusQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetProductsByStatusQuery, GetProductsByStatusQueryVariables>(GetProductsByStatusDocument, variables, options);

export const GetNicheSoldProductsDocument = `
    query GetNicheSoldProducts($analysisId: ID!, $brandOrFullPath: String!) {
  getNicheSoldProducts(analysisId: $analysisId, brandOrFullPath: $brandOrFullPath) {
    ...ProductBase
  }
}
    ${ProductBaseFragmentDoc}`;

export const useGetNicheSoldProductsQuery = <
      TData = GetNicheSoldProductsQuery,
      TError = unknown
    >(
      variables: GetNicheSoldProductsQueryVariables,
      options?: Omit<UseQueryOptions<GetNicheSoldProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNicheSoldProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetNicheSoldProductsQuery, TError, TData>(
      {
    queryKey: ['GetNicheSoldProducts', variables],
    queryFn: graphqlClient<GetNicheSoldProductsQuery, GetNicheSoldProductsQueryVariables>(GetNicheSoldProductsDocument, variables),
    ...options
  }
    )};

useGetNicheSoldProductsQuery.getKey = (variables: GetNicheSoldProductsQueryVariables) => ['GetNicheSoldProducts', variables];

export const useInfiniteGetNicheSoldProductsQuery = <
      TData = InfiniteData<GetNicheSoldProductsQuery>,
      TError = unknown
    >(
      variables: GetNicheSoldProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetNicheSoldProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetNicheSoldProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetNicheSoldProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetNicheSoldProducts.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetNicheSoldProductsQuery, GetNicheSoldProductsQueryVariables>(GetNicheSoldProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetNicheSoldProductsQuery.getKey = (variables: GetNicheSoldProductsQueryVariables) => ['GetNicheSoldProducts.infinite', variables];


useGetNicheSoldProductsQuery.fetcher = (variables: GetNicheSoldProductsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetNicheSoldProductsQuery, GetNicheSoldProductsQueryVariables>(GetNicheSoldProductsDocument, variables, options);

export const GetProductFeedDocument = `
    query GetProductFeed($analysisId: ID!, $status: ProductStatus, $limit: Int, $cursor: String, $sort: ProductSort, $brand: String, $searchText: String, $conditionIds: [Int!], $sizeIds: [Int!], $colorIds: [Int!], $countryIds: [Int!], $priceMin: Float, $priceMax: Float) {
  getProductFeed(
    analysisId: $analysisId
    status: $status
    limit: $limit
    cursor: $cursor
    sort: $sort
    brand: $brand
    searchText: $searchText
    conditionIds: $conditionIds
    sizeIds: $sizeIds
    colorIds: $colorIds
    countryIds: $countryIds
    priceMin: $priceMin
    priceMax: $priceMax
  ) {
    products {
      ...ProductBase
    }
    nextCursor
    hasNextPage
  }
}
    ${ProductBaseFragmentDoc}`;

export const useGetProductFeedQuery = <
      TData = GetProductFeedQuery,
      TError = unknown
    >(
      variables: GetProductFeedQueryVariables,
      options?: Omit<UseQueryOptions<GetProductFeedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProductFeedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProductFeedQuery, TError, TData>(
      {
    queryKey: ['GetProductFeed', variables],
    queryFn: graphqlClient<GetProductFeedQuery, GetProductFeedQueryVariables>(GetProductFeedDocument, variables),
    ...options
  }
    )};

useGetProductFeedQuery.getKey = (variables: GetProductFeedQueryVariables) => ['GetProductFeed', variables];

export const useInfiniteGetProductFeedQuery = <
      TData = InfiniteData<GetProductFeedQuery>,
      TError = unknown
    >(
      variables: GetProductFeedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProductFeedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProductFeedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetProductFeedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProductFeed.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetProductFeedQuery, GetProductFeedQueryVariables>(GetProductFeedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProductFeedQuery.getKey = (variables: GetProductFeedQueryVariables) => ['GetProductFeed.infinite', variables];


useGetProductFeedQuery.fetcher = (variables: GetProductFeedQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetProductFeedQuery, GetProductFeedQueryVariables>(GetProductFeedDocument, variables, options);

export const PreviewAnalysisMatchCountDocument = `
    query PreviewAnalysisMatchCount($input: SearchCriteriaInput!) {
  previewAnalysisMatchCount(input: $input) {
    totalCount
    capped
    similarityPending
    exhaustive
    sampledCount
  }
}
    `;

export const usePreviewAnalysisMatchCountQuery = <
      TData = PreviewAnalysisMatchCountQuery,
      TError = unknown
    >(
      variables: PreviewAnalysisMatchCountQueryVariables,
      options?: Omit<UseQueryOptions<PreviewAnalysisMatchCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PreviewAnalysisMatchCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PreviewAnalysisMatchCountQuery, TError, TData>(
      {
    queryKey: ['PreviewAnalysisMatchCount', variables],
    queryFn: graphqlClient<PreviewAnalysisMatchCountQuery, PreviewAnalysisMatchCountQueryVariables>(PreviewAnalysisMatchCountDocument, variables),
    ...options
  }
    )};

usePreviewAnalysisMatchCountQuery.getKey = (variables: PreviewAnalysisMatchCountQueryVariables) => ['PreviewAnalysisMatchCount', variables];

export const useInfinitePreviewAnalysisMatchCountQuery = <
      TData = InfiniteData<PreviewAnalysisMatchCountQuery>,
      TError = unknown
    >(
      variables: PreviewAnalysisMatchCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PreviewAnalysisMatchCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PreviewAnalysisMatchCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PreviewAnalysisMatchCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PreviewAnalysisMatchCount.infinite', variables],
      queryFn: (metaData) => graphqlClient<PreviewAnalysisMatchCountQuery, PreviewAnalysisMatchCountQueryVariables>(PreviewAnalysisMatchCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePreviewAnalysisMatchCountQuery.getKey = (variables: PreviewAnalysisMatchCountQueryVariables) => ['PreviewAnalysisMatchCount.infinite', variables];


usePreviewAnalysisMatchCountQuery.fetcher = (variables: PreviewAnalysisMatchCountQueryVariables, options?: RequestInit['headers']) => graphqlClient<PreviewAnalysisMatchCountQuery, PreviewAnalysisMatchCountQueryVariables>(PreviewAnalysisMatchCountDocument, variables, options);

export const GetVintedCatalogTreeDocument = `
    query GetVintedCatalogTree {
  getVintedCatalogTree {
    id
    title
    children {
      id
      title
      children {
        id
        title
        children {
          id
          title
          children {
            id
            title
            children {
              id
              title
              children {
                id
                title
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetVintedCatalogTreeQuery = <
      TData = GetVintedCatalogTreeQuery,
      TError = unknown
    >(
      variables?: GetVintedCatalogTreeQueryVariables,
      options?: Omit<UseQueryOptions<GetVintedCatalogTreeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVintedCatalogTreeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVintedCatalogTreeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetVintedCatalogTree'] : ['GetVintedCatalogTree', variables],
    queryFn: graphqlClient<GetVintedCatalogTreeQuery, GetVintedCatalogTreeQueryVariables>(GetVintedCatalogTreeDocument, variables),
    ...options
  }
    )};

useGetVintedCatalogTreeQuery.getKey = (variables?: GetVintedCatalogTreeQueryVariables) => variables === undefined ? ['GetVintedCatalogTree'] : ['GetVintedCatalogTree', variables];

export const useInfiniteGetVintedCatalogTreeQuery = <
      TData = InfiniteData<GetVintedCatalogTreeQuery>,
      TError = unknown
    >(
      variables: GetVintedCatalogTreeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVintedCatalogTreeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVintedCatalogTreeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVintedCatalogTreeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetVintedCatalogTree.infinite'] : ['GetVintedCatalogTree.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVintedCatalogTreeQuery, GetVintedCatalogTreeQueryVariables>(GetVintedCatalogTreeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVintedCatalogTreeQuery.getKey = (variables?: GetVintedCatalogTreeQueryVariables) => variables === undefined ? ['GetVintedCatalogTree.infinite'] : ['GetVintedCatalogTree.infinite', variables];


useGetVintedCatalogTreeQuery.fetcher = (variables?: GetVintedCatalogTreeQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVintedCatalogTreeQuery, GetVintedCatalogTreeQueryVariables>(GetVintedCatalogTreeDocument, variables, options);

export const GetVintedCatalogFiltersDocument = `
    query GetVintedCatalogFilters($mainCatalogIds: [Int!]!) {
  getVintedCatalogFilters(mainCatalogIds: $mainCatalogIds) {
    type
    title
    search
    options {
      id
      title
      type
      itemsCount
      hex
      imageUrl
      children {
        id
        title
        itemsCount
      }
    }
  }
}
    `;

export const useGetVintedCatalogFiltersQuery = <
      TData = GetVintedCatalogFiltersQuery,
      TError = unknown
    >(
      variables: GetVintedCatalogFiltersQueryVariables,
      options?: Omit<UseQueryOptions<GetVintedCatalogFiltersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVintedCatalogFiltersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVintedCatalogFiltersQuery, TError, TData>(
      {
    queryKey: ['GetVintedCatalogFilters', variables],
    queryFn: graphqlClient<GetVintedCatalogFiltersQuery, GetVintedCatalogFiltersQueryVariables>(GetVintedCatalogFiltersDocument, variables),
    ...options
  }
    )};

useGetVintedCatalogFiltersQuery.getKey = (variables: GetVintedCatalogFiltersQueryVariables) => ['GetVintedCatalogFilters', variables];

export const useInfiniteGetVintedCatalogFiltersQuery = <
      TData = InfiniteData<GetVintedCatalogFiltersQuery>,
      TError = unknown
    >(
      variables: GetVintedCatalogFiltersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVintedCatalogFiltersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVintedCatalogFiltersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVintedCatalogFiltersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVintedCatalogFilters.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVintedCatalogFiltersQuery, GetVintedCatalogFiltersQueryVariables>(GetVintedCatalogFiltersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVintedCatalogFiltersQuery.getKey = (variables: GetVintedCatalogFiltersQueryVariables) => ['GetVintedCatalogFilters.infinite', variables];


useGetVintedCatalogFiltersQuery.fetcher = (variables: GetVintedCatalogFiltersQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVintedCatalogFiltersQuery, GetVintedCatalogFiltersQueryVariables>(GetVintedCatalogFiltersDocument, variables, options);

export const SearchVintedCatalogFilterOptionsDocument = `
    query SearchVintedCatalogFilterOptions($mainCatalogIds: [Int!]!, $filterType: VintedCatalogFilterType!, $query: String!) {
  searchVintedCatalogFilterOptions(
    mainCatalogIds: $mainCatalogIds
    filterType: $filterType
    query: $query
  ) {
    id
    title
    itemsCount
  }
}
    `;

export const useSearchVintedCatalogFilterOptionsQuery = <
      TData = SearchVintedCatalogFilterOptionsQuery,
      TError = unknown
    >(
      variables: SearchVintedCatalogFilterOptionsQueryVariables,
      options?: Omit<UseQueryOptions<SearchVintedCatalogFilterOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchVintedCatalogFilterOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchVintedCatalogFilterOptionsQuery, TError, TData>(
      {
    queryKey: ['SearchVintedCatalogFilterOptions', variables],
    queryFn: graphqlClient<SearchVintedCatalogFilterOptionsQuery, SearchVintedCatalogFilterOptionsQueryVariables>(SearchVintedCatalogFilterOptionsDocument, variables),
    ...options
  }
    )};

useSearchVintedCatalogFilterOptionsQuery.getKey = (variables: SearchVintedCatalogFilterOptionsQueryVariables) => ['SearchVintedCatalogFilterOptions', variables];

export const useInfiniteSearchVintedCatalogFilterOptionsQuery = <
      TData = InfiniteData<SearchVintedCatalogFilterOptionsQuery>,
      TError = unknown
    >(
      variables: SearchVintedCatalogFilterOptionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchVintedCatalogFilterOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchVintedCatalogFilterOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<SearchVintedCatalogFilterOptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SearchVintedCatalogFilterOptions.infinite', variables],
      queryFn: (metaData) => graphqlClient<SearchVintedCatalogFilterOptionsQuery, SearchVintedCatalogFilterOptionsQueryVariables>(SearchVintedCatalogFilterOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchVintedCatalogFilterOptionsQuery.getKey = (variables: SearchVintedCatalogFilterOptionsQueryVariables) => ['SearchVintedCatalogFilterOptions.infinite', variables];


useSearchVintedCatalogFilterOptionsQuery.fetcher = (variables: SearchVintedCatalogFilterOptionsQueryVariables, options?: RequestInit['headers']) => graphqlClient<SearchVintedCatalogFilterOptionsQuery, SearchVintedCatalogFilterOptionsQueryVariables>(SearchVintedCatalogFilterOptionsDocument, variables, options);

export const ParseVintedCatalogUrlDocument = `
    query ParseVintedCatalogUrl($catalogUrl: String!) {
  parseVintedCatalogUrl(catalogUrl: $catalogUrl) {
    sellerVintedId
    priceMin
    priceMax
    keywords
    catalogs {
      id
      title
    }
    brands {
      id
      title
    }
    conditions {
      id
      title
    }
    colors {
      id
      title
    }
    sizes {
      id
      title
    }
    materials {
      id
      title
    }
    patterns {
      id
      title
    }
    brandCollections {
      id
      title
    }
    videoGamePlatforms {
      id
      title
    }
    videoGameRatings {
      id
      title
    }
    internalMemoryCapacities {
      id
      title
    }
    languageBooks {
      id
      title
    }
    simLocks {
      id
      title
    }
  }
}
    `;

export const useParseVintedCatalogUrlQuery = <
      TData = ParseVintedCatalogUrlQuery,
      TError = unknown
    >(
      variables: ParseVintedCatalogUrlQueryVariables,
      options?: Omit<UseQueryOptions<ParseVintedCatalogUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ParseVintedCatalogUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ParseVintedCatalogUrlQuery, TError, TData>(
      {
    queryKey: ['ParseVintedCatalogUrl', variables],
    queryFn: graphqlClient<ParseVintedCatalogUrlQuery, ParseVintedCatalogUrlQueryVariables>(ParseVintedCatalogUrlDocument, variables),
    ...options
  }
    )};

useParseVintedCatalogUrlQuery.getKey = (variables: ParseVintedCatalogUrlQueryVariables) => ['ParseVintedCatalogUrl', variables];

export const useInfiniteParseVintedCatalogUrlQuery = <
      TData = InfiniteData<ParseVintedCatalogUrlQuery>,
      TError = unknown
    >(
      variables: ParseVintedCatalogUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ParseVintedCatalogUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ParseVintedCatalogUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ParseVintedCatalogUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ParseVintedCatalogUrl.infinite', variables],
      queryFn: (metaData) => graphqlClient<ParseVintedCatalogUrlQuery, ParseVintedCatalogUrlQueryVariables>(ParseVintedCatalogUrlDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteParseVintedCatalogUrlQuery.getKey = (variables: ParseVintedCatalogUrlQueryVariables) => ['ParseVintedCatalogUrl.infinite', variables];


useParseVintedCatalogUrlQuery.fetcher = (variables: ParseVintedCatalogUrlQueryVariables, options?: RequestInit['headers']) => graphqlClient<ParseVintedCatalogUrlQuery, ParseVintedCatalogUrlQueryVariables>(ParseVintedCatalogUrlDocument, variables, options);

export const GetVintedCountriesDocument = `
    query GetVintedCountries {
  getVintedCountries {
    id
    isoCode
    name
    region
  }
}
    `;

export const useGetVintedCountriesQuery = <
      TData = GetVintedCountriesQuery,
      TError = unknown
    >(
      variables?: GetVintedCountriesQueryVariables,
      options?: Omit<UseQueryOptions<GetVintedCountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVintedCountriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVintedCountriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetVintedCountries'] : ['GetVintedCountries', variables],
    queryFn: graphqlClient<GetVintedCountriesQuery, GetVintedCountriesQueryVariables>(GetVintedCountriesDocument, variables),
    ...options
  }
    )};

useGetVintedCountriesQuery.getKey = (variables?: GetVintedCountriesQueryVariables) => variables === undefined ? ['GetVintedCountries'] : ['GetVintedCountries', variables];

export const useInfiniteGetVintedCountriesQuery = <
      TData = InfiniteData<GetVintedCountriesQuery>,
      TError = unknown
    >(
      variables: GetVintedCountriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVintedCountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVintedCountriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVintedCountriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetVintedCountries.infinite'] : ['GetVintedCountries.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVintedCountriesQuery, GetVintedCountriesQueryVariables>(GetVintedCountriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVintedCountriesQuery.getKey = (variables?: GetVintedCountriesQueryVariables) => variables === undefined ? ['GetVintedCountries.infinite'] : ['GetVintedCountries.infinite', variables];


useGetVintedCountriesQuery.fetcher = (variables?: GetVintedCountriesQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVintedCountriesQuery, GetVintedCountriesQueryVariables>(GetVintedCountriesDocument, variables, options);

export const GetAvailableSubscriptionPlansDocument = `
    query GetAvailableSubscriptionPlans {
  getAvailableSubscriptionPlans {
    id
    name
    isPublic
    priceMonthly
    priceYearly
    catalogAnalysisQuotas
    profileAnalysisQuotas
    trialPeriodDays
    trialCatalogAnalysisQuotas
    trialProfileAnalysisQuotas
    trialVeilleQuotas
    vestiaireAccess
  }
}
    `;

export const useGetAvailableSubscriptionPlans = <
      TData = GetAvailableSubscriptionPlansQuery,
      TError = unknown
    >(
      variables?: GetAvailableSubscriptionPlansQueryVariables,
      options?: Omit<UseQueryOptions<GetAvailableSubscriptionPlansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAvailableSubscriptionPlansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAvailableSubscriptionPlansQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAvailableSubscriptionPlans'] : ['GetAvailableSubscriptionPlans', variables],
    queryFn: graphqlClient<GetAvailableSubscriptionPlansQuery, GetAvailableSubscriptionPlansQueryVariables>(GetAvailableSubscriptionPlansDocument, variables),
    ...options
  }
    )};

useGetAvailableSubscriptionPlans.getKey = (variables?: GetAvailableSubscriptionPlansQueryVariables) => variables === undefined ? ['GetAvailableSubscriptionPlans'] : ['GetAvailableSubscriptionPlans', variables];

export const useInfiniteGetAvailableSubscriptionPlans = <
      TData = InfiniteData<GetAvailableSubscriptionPlansQuery>,
      TError = unknown
    >(
      variables: GetAvailableSubscriptionPlansQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAvailableSubscriptionPlansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAvailableSubscriptionPlansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAvailableSubscriptionPlansQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetAvailableSubscriptionPlans.infinite'] : ['GetAvailableSubscriptionPlans.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAvailableSubscriptionPlansQuery, GetAvailableSubscriptionPlansQueryVariables>(GetAvailableSubscriptionPlansDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAvailableSubscriptionPlans.getKey = (variables?: GetAvailableSubscriptionPlansQueryVariables) => variables === undefined ? ['GetAvailableSubscriptionPlans.infinite'] : ['GetAvailableSubscriptionPlans.infinite', variables];


useGetAvailableSubscriptionPlans.fetcher = (variables?: GetAvailableSubscriptionPlansQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAvailableSubscriptionPlansQuery, GetAvailableSubscriptionPlansQueryVariables>(GetAvailableSubscriptionPlansDocument, variables, options);

export const GetCurrentUserSubscriptionDocument = `
    query GetCurrentUserSubscription {
  getCurrentUserSubscription {
    isActive
    isTrialing
    plan {
      id
      name
      periodicity
      price
      nextRenewalAt
    }
    inactivatedAt
    cancelAt
  }
}
    `;

export const useGetCurrentUserSubscription = <
      TData = GetCurrentUserSubscriptionQuery,
      TError = unknown
    >(
      variables?: GetCurrentUserSubscriptionQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentUserSubscriptionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentUserSubscriptionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentUserSubscriptionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetCurrentUserSubscription'] : ['GetCurrentUserSubscription', variables],
    queryFn: graphqlClient<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>(GetCurrentUserSubscriptionDocument, variables),
    ...options
  }
    )};

useGetCurrentUserSubscription.getKey = (variables?: GetCurrentUserSubscriptionQueryVariables) => variables === undefined ? ['GetCurrentUserSubscription'] : ['GetCurrentUserSubscription', variables];

export const useInfiniteGetCurrentUserSubscription = <
      TData = InfiniteData<GetCurrentUserSubscriptionQuery>,
      TError = unknown
    >(
      variables: GetCurrentUserSubscriptionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentUserSubscriptionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentUserSubscriptionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCurrentUserSubscriptionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetCurrentUserSubscription.infinite'] : ['GetCurrentUserSubscription.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>(GetCurrentUserSubscriptionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentUserSubscription.getKey = (variables?: GetCurrentUserSubscriptionQueryVariables) => variables === undefined ? ['GetCurrentUserSubscription.infinite'] : ['GetCurrentUserSubscription.infinite', variables];


useGetCurrentUserSubscription.fetcher = (variables?: GetCurrentUserSubscriptionQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>(GetCurrentUserSubscriptionDocument, variables, options);

export const GetCanStartFreeTrialDocument = `
    query GetCanStartFreeTrial {
  getCanStartFreeTrial
}
    `;

export const useGetCanStartFreeTrialQuery = <
      TData = GetCanStartFreeTrialQuery,
      TError = unknown
    >(
      variables?: GetCanStartFreeTrialQueryVariables,
      options?: Omit<UseQueryOptions<GetCanStartFreeTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCanStartFreeTrialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCanStartFreeTrialQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetCanStartFreeTrial'] : ['GetCanStartFreeTrial', variables],
    queryFn: graphqlClient<GetCanStartFreeTrialQuery, GetCanStartFreeTrialQueryVariables>(GetCanStartFreeTrialDocument, variables),
    ...options
  }
    )};

useGetCanStartFreeTrialQuery.getKey = (variables?: GetCanStartFreeTrialQueryVariables) => variables === undefined ? ['GetCanStartFreeTrial'] : ['GetCanStartFreeTrial', variables];

export const useInfiniteGetCanStartFreeTrialQuery = <
      TData = InfiniteData<GetCanStartFreeTrialQuery>,
      TError = unknown
    >(
      variables: GetCanStartFreeTrialQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCanStartFreeTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCanStartFreeTrialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCanStartFreeTrialQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetCanStartFreeTrial.infinite'] : ['GetCanStartFreeTrial.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetCanStartFreeTrialQuery, GetCanStartFreeTrialQueryVariables>(GetCanStartFreeTrialDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCanStartFreeTrialQuery.getKey = (variables?: GetCanStartFreeTrialQueryVariables) => variables === undefined ? ['GetCanStartFreeTrial.infinite'] : ['GetCanStartFreeTrial.infinite', variables];


useGetCanStartFreeTrialQuery.fetcher = (variables?: GetCanStartFreeTrialQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetCanStartFreeTrialQuery, GetCanStartFreeTrialQueryVariables>(GetCanStartFreeTrialDocument, variables, options);

export const GetTrendListDocument = `
    query GetTrendList($catalogId: Int, $countryId: Int, $list: TrendListKind!, $runOffset: Int) {
  getTrendList(
    catalogId: $catalogId
    countryId: $countryId
    list: $list
    runOffset: $runOffset
  ) {
    list
    computedAt
    weekAnchor
    total
    truncated
    niches {
      id
      isStratum
      name
      nameSource
      label
      keyword
      countryId
      brand {
        id
        name
      }
      catalog {
        rootId
        rootName
        level1Id
        level1Name
        leafId
        leafName
      }
      metrics {
        productCount
        soldPct
        avgPrice
        medianPrice
        timeToSellHours
        salesPerDay
        caPerMonth
        growthPct
      }
      series {
        day
        sales
      }
      seed {
        productId
        title
        imageUrl
        url
      }
      lastSales {
        productId
        title
        price
        imageUrl
        soldAt
        url
      }
      topSellers {
        sellerId
        username
        imageUrl
        sales
      }
      relaunchCriteria {
        catalogIds
        brandIds
        countryIds
        sourceProductId
        similarityThreshold
        keywords
        keywordsOperator
      }
    }
  }
}
    `;

export const useGetTrendListQuery = <
      TData = GetTrendListQuery,
      TError = unknown
    >(
      variables: GetTrendListQueryVariables,
      options?: Omit<UseQueryOptions<GetTrendListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTrendListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTrendListQuery, TError, TData>(
      {
    queryKey: ['GetTrendList', variables],
    queryFn: graphqlClient<GetTrendListQuery, GetTrendListQueryVariables>(GetTrendListDocument, variables),
    ...options
  }
    )};

useGetTrendListQuery.getKey = (variables: GetTrendListQueryVariables) => ['GetTrendList', variables];

export const useInfiniteGetTrendListQuery = <
      TData = InfiniteData<GetTrendListQuery>,
      TError = unknown
    >(
      variables: GetTrendListQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetTrendListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetTrendListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetTrendListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetTrendList.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetTrendListQuery, GetTrendListQueryVariables>(GetTrendListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetTrendListQuery.getKey = (variables: GetTrendListQueryVariables) => ['GetTrendList.infinite', variables];


useGetTrendListQuery.fetcher = (variables: GetTrendListQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetTrendListQuery, GetTrendListQueryVariables>(GetTrendListDocument, variables, options);

export const GetUserLanguageDocument = `
    query GetUserLanguage {
  getUserLanguage
}
    `;

export const useGetUserLanguageQuery = <
      TData = GetUserLanguageQuery,
      TError = unknown
    >(
      variables?: GetUserLanguageQueryVariables,
      options?: Omit<UseQueryOptions<GetUserLanguageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserLanguageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserLanguageQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserLanguage'] : ['GetUserLanguage', variables],
    queryFn: graphqlClient<GetUserLanguageQuery, GetUserLanguageQueryVariables>(GetUserLanguageDocument, variables),
    ...options
  }
    )};

useGetUserLanguageQuery.getKey = (variables?: GetUserLanguageQueryVariables) => variables === undefined ? ['GetUserLanguage'] : ['GetUserLanguage', variables];

export const useInfiniteGetUserLanguageQuery = <
      TData = InfiniteData<GetUserLanguageQuery>,
      TError = unknown
    >(
      variables: GetUserLanguageQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserLanguageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserLanguageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserLanguageQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetUserLanguage.infinite'] : ['GetUserLanguage.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetUserLanguageQuery, GetUserLanguageQueryVariables>(GetUserLanguageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserLanguageQuery.getKey = (variables?: GetUserLanguageQueryVariables) => variables === undefined ? ['GetUserLanguage.infinite'] : ['GetUserLanguage.infinite', variables];


useGetUserLanguageQuery.fetcher = (variables?: GetUserLanguageQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetUserLanguageQuery, GetUserLanguageQueryVariables>(GetUserLanguageDocument, variables, options);

export const GetCurrentUserAnalysisQuotasDocument = `
    query GetCurrentUserAnalysisQuotas {
  getCurrentUserAnalysisQuotas {
    hasPartialPublicAnalysisAccess
    hasFullPublicAnalysisAccess
    catalogAnalysesUsed
    catalogAnalysesMax
    catalogAnalysesAvailable
    profileAnalysesUsed
    profileAnalysesMax
    profileAnalysesAvailable
    canCreateCatalogAnalysis
    canCreateProfileAnalysis
  }
}
    `;

export const useGetCurrentUserAnalysisQuotasQuery = <
      TData = GetCurrentUserAnalysisQuotasQuery,
      TError = unknown
    >(
      variables?: GetCurrentUserAnalysisQuotasQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentUserAnalysisQuotasQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentUserAnalysisQuotasQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentUserAnalysisQuotasQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetCurrentUserAnalysisQuotas'] : ['GetCurrentUserAnalysisQuotas', variables],
    queryFn: graphqlClient<GetCurrentUserAnalysisQuotasQuery, GetCurrentUserAnalysisQuotasQueryVariables>(GetCurrentUserAnalysisQuotasDocument, variables),
    ...options
  }
    )};

useGetCurrentUserAnalysisQuotasQuery.getKey = (variables?: GetCurrentUserAnalysisQuotasQueryVariables) => variables === undefined ? ['GetCurrentUserAnalysisQuotas'] : ['GetCurrentUserAnalysisQuotas', variables];

export const useInfiniteGetCurrentUserAnalysisQuotasQuery = <
      TData = InfiniteData<GetCurrentUserAnalysisQuotasQuery>,
      TError = unknown
    >(
      variables: GetCurrentUserAnalysisQuotasQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentUserAnalysisQuotasQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentUserAnalysisQuotasQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCurrentUserAnalysisQuotasQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetCurrentUserAnalysisQuotas.infinite'] : ['GetCurrentUserAnalysisQuotas.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetCurrentUserAnalysisQuotasQuery, GetCurrentUserAnalysisQuotasQueryVariables>(GetCurrentUserAnalysisQuotasDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentUserAnalysisQuotasQuery.getKey = (variables?: GetCurrentUserAnalysisQuotasQueryVariables) => variables === undefined ? ['GetCurrentUserAnalysisQuotas.infinite'] : ['GetCurrentUserAnalysisQuotas.infinite', variables];


useGetCurrentUserAnalysisQuotasQuery.fetcher = (variables?: GetCurrentUserAnalysisQuotasQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetCurrentUserAnalysisQuotasQuery, GetCurrentUserAnalysisQuotasQueryVariables>(GetCurrentUserAnalysisQuotasDocument, variables, options);

export const GetCurrentUserVestiaireAccessDocument = `
    query GetCurrentUserVestiaireAccess {
  getCurrentUserVestiaireAccess
}
    `;

export const useGetCurrentUserVestiaireAccessQuery = <
      TData = GetCurrentUserVestiaireAccessQuery,
      TError = unknown
    >(
      variables?: GetCurrentUserVestiaireAccessQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentUserVestiaireAccessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentUserVestiaireAccessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentUserVestiaireAccessQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetCurrentUserVestiaireAccess'] : ['GetCurrentUserVestiaireAccess', variables],
    queryFn: graphqlClient<GetCurrentUserVestiaireAccessQuery, GetCurrentUserVestiaireAccessQueryVariables>(GetCurrentUserVestiaireAccessDocument, variables),
    ...options
  }
    )};

useGetCurrentUserVestiaireAccessQuery.getKey = (variables?: GetCurrentUserVestiaireAccessQueryVariables) => variables === undefined ? ['GetCurrentUserVestiaireAccess'] : ['GetCurrentUserVestiaireAccess', variables];

export const useInfiniteGetCurrentUserVestiaireAccessQuery = <
      TData = InfiniteData<GetCurrentUserVestiaireAccessQuery>,
      TError = unknown
    >(
      variables: GetCurrentUserVestiaireAccessQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentUserVestiaireAccessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentUserVestiaireAccessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCurrentUserVestiaireAccessQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetCurrentUserVestiaireAccess.infinite'] : ['GetCurrentUserVestiaireAccess.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetCurrentUserVestiaireAccessQuery, GetCurrentUserVestiaireAccessQueryVariables>(GetCurrentUserVestiaireAccessDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentUserVestiaireAccessQuery.getKey = (variables?: GetCurrentUserVestiaireAccessQueryVariables) => variables === undefined ? ['GetCurrentUserVestiaireAccess.infinite'] : ['GetCurrentUserVestiaireAccess.infinite', variables];


useGetCurrentUserVestiaireAccessQuery.fetcher = (variables?: GetCurrentUserVestiaireAccessQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetCurrentUserVestiaireAccessQuery, GetCurrentUserVestiaireAccessQueryVariables>(GetCurrentUserVestiaireAccessDocument, variables, options);

export const GetUserVeillesDocument = `
    query GetUserVeilles {
  getUserVeilles {
    ...VeilleBase
  }
}
    ${VeilleBaseFragmentDoc}`;

export const useGetUserVeillesQuery = <
      TData = GetUserVeillesQuery,
      TError = unknown
    >(
      variables?: GetUserVeillesQueryVariables,
      options?: Omit<UseQueryOptions<GetUserVeillesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserVeillesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserVeillesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserVeilles'] : ['GetUserVeilles', variables],
    queryFn: graphqlClient<GetUserVeillesQuery, GetUserVeillesQueryVariables>(GetUserVeillesDocument, variables),
    ...options
  }
    )};

useGetUserVeillesQuery.getKey = (variables?: GetUserVeillesQueryVariables) => variables === undefined ? ['GetUserVeilles'] : ['GetUserVeilles', variables];

export const useInfiniteGetUserVeillesQuery = <
      TData = InfiniteData<GetUserVeillesQuery>,
      TError = unknown
    >(
      variables: GetUserVeillesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserVeillesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserVeillesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserVeillesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetUserVeilles.infinite'] : ['GetUserVeilles.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetUserVeillesQuery, GetUserVeillesQueryVariables>(GetUserVeillesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserVeillesQuery.getKey = (variables?: GetUserVeillesQueryVariables) => variables === undefined ? ['GetUserVeilles.infinite'] : ['GetUserVeilles.infinite', variables];


useGetUserVeillesQuery.fetcher = (variables?: GetUserVeillesQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetUserVeillesQuery, GetUserVeillesQueryVariables>(GetUserVeillesDocument, variables, options);

export const GetVeilleByIdDocument = `
    query GetVeilleById($id: ID!) {
  getVeilleById(id: $id) {
    ...VeilleBase
  }
}
    ${VeilleBaseFragmentDoc}`;

export const useGetVeilleByIdQuery = <
      TData = GetVeilleByIdQuery,
      TError = unknown
    >(
      variables: GetVeilleByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetVeilleByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVeilleByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVeilleByIdQuery, TError, TData>(
      {
    queryKey: ['GetVeilleById', variables],
    queryFn: graphqlClient<GetVeilleByIdQuery, GetVeilleByIdQueryVariables>(GetVeilleByIdDocument, variables),
    ...options
  }
    )};

useGetVeilleByIdQuery.getKey = (variables: GetVeilleByIdQueryVariables) => ['GetVeilleById', variables];

export const useInfiniteGetVeilleByIdQuery = <
      TData = InfiniteData<GetVeilleByIdQuery>,
      TError = unknown
    >(
      variables: GetVeilleByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVeilleByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVeilleByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVeilleByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVeilleById.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVeilleByIdQuery, GetVeilleByIdQueryVariables>(GetVeilleByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVeilleByIdQuery.getKey = (variables: GetVeilleByIdQueryVariables) => ['GetVeilleById.infinite', variables];


useGetVeilleByIdQuery.fetcher = (variables: GetVeilleByIdQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVeilleByIdQuery, GetVeilleByIdQueryVariables>(GetVeilleByIdDocument, variables, options);

export const GetCurrentUserVeilleQuotasDocument = `
    query GetCurrentUserVeilleQuotas {
  getCurrentUserVeilleQuotas {
    veillesUsed
    veillesMax
    veillesAvailable
    canCreateVeille
  }
}
    `;

export const useGetCurrentUserVeilleQuotasQuery = <
      TData = GetCurrentUserVeilleQuotasQuery,
      TError = unknown
    >(
      variables?: GetCurrentUserVeilleQuotasQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentUserVeilleQuotasQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentUserVeilleQuotasQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentUserVeilleQuotasQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetCurrentUserVeilleQuotas'] : ['GetCurrentUserVeilleQuotas', variables],
    queryFn: graphqlClient<GetCurrentUserVeilleQuotasQuery, GetCurrentUserVeilleQuotasQueryVariables>(GetCurrentUserVeilleQuotasDocument, variables),
    ...options
  }
    )};

useGetCurrentUserVeilleQuotasQuery.getKey = (variables?: GetCurrentUserVeilleQuotasQueryVariables) => variables === undefined ? ['GetCurrentUserVeilleQuotas'] : ['GetCurrentUserVeilleQuotas', variables];

export const useInfiniteGetCurrentUserVeilleQuotasQuery = <
      TData = InfiniteData<GetCurrentUserVeilleQuotasQuery>,
      TError = unknown
    >(
      variables: GetCurrentUserVeilleQuotasQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentUserVeilleQuotasQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentUserVeilleQuotasQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCurrentUserVeilleQuotasQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetCurrentUserVeilleQuotas.infinite'] : ['GetCurrentUserVeilleQuotas.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetCurrentUserVeilleQuotasQuery, GetCurrentUserVeilleQuotasQueryVariables>(GetCurrentUserVeilleQuotasDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentUserVeilleQuotasQuery.getKey = (variables?: GetCurrentUserVeilleQuotasQueryVariables) => variables === undefined ? ['GetCurrentUserVeilleQuotas.infinite'] : ['GetCurrentUserVeilleQuotas.infinite', variables];


useGetCurrentUserVeilleQuotasQuery.fetcher = (variables?: GetCurrentUserVeilleQuotasQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetCurrentUserVeilleQuotasQuery, GetCurrentUserVeilleQuotasQueryVariables>(GetCurrentUserVeilleQuotasDocument, variables, options);

export const GetSellerByLoginDocument = `
    query GetSellerByLogin($login: String!) {
  getSellerByLogin(login: $login) {
    sellerVintedId
    login
  }
}
    `;

export const useGetSellerByLoginQuery = <
      TData = GetSellerByLoginQuery,
      TError = unknown
    >(
      variables: GetSellerByLoginQueryVariables,
      options?: Omit<UseQueryOptions<GetSellerByLoginQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSellerByLoginQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSellerByLoginQuery, TError, TData>(
      {
    queryKey: ['GetSellerByLogin', variables],
    queryFn: graphqlClient<GetSellerByLoginQuery, GetSellerByLoginQueryVariables>(GetSellerByLoginDocument, variables),
    ...options
  }
    )};

useGetSellerByLoginQuery.getKey = (variables: GetSellerByLoginQueryVariables) => ['GetSellerByLogin', variables];

export const useInfiniteGetSellerByLoginQuery = <
      TData = InfiniteData<GetSellerByLoginQuery>,
      TError = unknown
    >(
      variables: GetSellerByLoginQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSellerByLoginQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSellerByLoginQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetSellerByLoginQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetSellerByLogin.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetSellerByLoginQuery, GetSellerByLoginQueryVariables>(GetSellerByLoginDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSellerByLoginQuery.getKey = (variables: GetSellerByLoginQueryVariables) => ['GetSellerByLogin.infinite', variables];


useGetSellerByLoginQuery.fetcher = (variables: GetSellerByLoginQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetSellerByLoginQuery, GetSellerByLoginQueryVariables>(GetSellerByLoginDocument, variables, options);

export const GetVeilleDailyStatsDocument = `
    query GetVeilleDailyStats($veilleId: ID!, $from: DateTime, $to: DateTime) {
  getVeilleDailyStats(veilleId: $veilleId, from: $from, to: $to) {
    day
    sales
    newItems
    sellers
    averagePrice
    sellThroughRate
  }
}
    `;

export const useGetVeilleDailyStatsQuery = <
      TData = GetVeilleDailyStatsQuery,
      TError = unknown
    >(
      variables: GetVeilleDailyStatsQueryVariables,
      options?: Omit<UseQueryOptions<GetVeilleDailyStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVeilleDailyStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVeilleDailyStatsQuery, TError, TData>(
      {
    queryKey: ['GetVeilleDailyStats', variables],
    queryFn: graphqlClient<GetVeilleDailyStatsQuery, GetVeilleDailyStatsQueryVariables>(GetVeilleDailyStatsDocument, variables),
    ...options
  }
    )};

useGetVeilleDailyStatsQuery.getKey = (variables: GetVeilleDailyStatsQueryVariables) => ['GetVeilleDailyStats', variables];

export const useInfiniteGetVeilleDailyStatsQuery = <
      TData = InfiniteData<GetVeilleDailyStatsQuery>,
      TError = unknown
    >(
      variables: GetVeilleDailyStatsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVeilleDailyStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVeilleDailyStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVeilleDailyStatsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVeilleDailyStats.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVeilleDailyStatsQuery, GetVeilleDailyStatsQueryVariables>(GetVeilleDailyStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVeilleDailyStatsQuery.getKey = (variables: GetVeilleDailyStatsQueryVariables) => ['GetVeilleDailyStats.infinite', variables];


useGetVeilleDailyStatsQuery.fetcher = (variables: GetVeilleDailyStatsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVeilleDailyStatsQuery, GetVeilleDailyStatsQueryVariables>(GetVeilleDailyStatsDocument, variables, options);

export const GetVeilleWeeklyStatsDocument = `
    query GetVeilleWeeklyStats($veilleId: ID!, $from: DateTime, $to: DateTime) {
  getVeilleWeeklyStats(veilleId: $veilleId, from: $from, to: $to) {
    weekStart
    daysCounted
    sales
    newItems
    sellers
    averagePrice
    sellThroughRate
  }
}
    `;

export const useGetVeilleWeeklyStatsQuery = <
      TData = GetVeilleWeeklyStatsQuery,
      TError = unknown
    >(
      variables: GetVeilleWeeklyStatsQueryVariables,
      options?: Omit<UseQueryOptions<GetVeilleWeeklyStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVeilleWeeklyStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVeilleWeeklyStatsQuery, TError, TData>(
      {
    queryKey: ['GetVeilleWeeklyStats', variables],
    queryFn: graphqlClient<GetVeilleWeeklyStatsQuery, GetVeilleWeeklyStatsQueryVariables>(GetVeilleWeeklyStatsDocument, variables),
    ...options
  }
    )};

useGetVeilleWeeklyStatsQuery.getKey = (variables: GetVeilleWeeklyStatsQueryVariables) => ['GetVeilleWeeklyStats', variables];

export const useInfiniteGetVeilleWeeklyStatsQuery = <
      TData = InfiniteData<GetVeilleWeeklyStatsQuery>,
      TError = unknown
    >(
      variables: GetVeilleWeeklyStatsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVeilleWeeklyStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVeilleWeeklyStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVeilleWeeklyStatsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVeilleWeeklyStats.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVeilleWeeklyStatsQuery, GetVeilleWeeklyStatsQueryVariables>(GetVeilleWeeklyStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVeilleWeeklyStatsQuery.getKey = (variables: GetVeilleWeeklyStatsQueryVariables) => ['GetVeilleWeeklyStats.infinite', variables];


useGetVeilleWeeklyStatsQuery.fetcher = (variables: GetVeilleWeeklyStatsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVeilleWeeklyStatsQuery, GetVeilleWeeklyStatsQueryVariables>(GetVeilleWeeklyStatsDocument, variables, options);

export const GetVeilleStatsComparisonDocument = `
    query GetVeilleStatsComparison($veilleId: ID!, $from: DateTime, $to: DateTime) {
  getVeilleStatsComparison(veilleId: $veilleId, from: $from, to: $to) {
    currentPeriodDays
    previousPeriodDays
    salesVariation
    newItemsVariation
    sellersVariation
    averagePriceVariation
    sellThroughRateVariation
  }
}
    `;

export const useGetVeilleStatsComparisonQuery = <
      TData = GetVeilleStatsComparisonQuery,
      TError = unknown
    >(
      variables: GetVeilleStatsComparisonQueryVariables,
      options?: Omit<UseQueryOptions<GetVeilleStatsComparisonQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVeilleStatsComparisonQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVeilleStatsComparisonQuery, TError, TData>(
      {
    queryKey: ['GetVeilleStatsComparison', variables],
    queryFn: graphqlClient<GetVeilleStatsComparisonQuery, GetVeilleStatsComparisonQueryVariables>(GetVeilleStatsComparisonDocument, variables),
    ...options
  }
    )};

useGetVeilleStatsComparisonQuery.getKey = (variables: GetVeilleStatsComparisonQueryVariables) => ['GetVeilleStatsComparison', variables];

export const useInfiniteGetVeilleStatsComparisonQuery = <
      TData = InfiniteData<GetVeilleStatsComparisonQuery>,
      TError = unknown
    >(
      variables: GetVeilleStatsComparisonQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVeilleStatsComparisonQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVeilleStatsComparisonQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVeilleStatsComparisonQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVeilleStatsComparison.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVeilleStatsComparisonQuery, GetVeilleStatsComparisonQueryVariables>(GetVeilleStatsComparisonDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVeilleStatsComparisonQuery.getKey = (variables: GetVeilleStatsComparisonQueryVariables) => ['GetVeilleStatsComparison.infinite', variables];


useGetVeilleStatsComparisonQuery.fetcher = (variables: GetVeilleStatsComparisonQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVeilleStatsComparisonQuery, GetVeilleStatsComparisonQueryVariables>(GetVeilleStatsComparisonDocument, variables, options);

export const GetVeilleFeedDocument = `
    query GetVeilleFeed($veilleId: ID!, $windowMinutes: Int, $limit: Int, $after: String) {
  getVeilleFeed(
    veilleId: $veilleId
    windowMinutes: $windowMinutes
    limit: $limit
    after: $after
  ) {
    items {
      productId
      title
      price
      soldAt
      sellerId
      imageUrl
      url
      brandTitle
      conditionTitle
      sellerLogin
      sellerFeedbackCount
      sellerFeedbackRating
      favouriteCount
      uploadedAt
    }
    nextCursor
  }
}
    `;

export const useGetVeilleFeedQuery = <
      TData = GetVeilleFeedQuery,
      TError = unknown
    >(
      variables: GetVeilleFeedQueryVariables,
      options?: Omit<UseQueryOptions<GetVeilleFeedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVeilleFeedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVeilleFeedQuery, TError, TData>(
      {
    queryKey: ['GetVeilleFeed', variables],
    queryFn: graphqlClient<GetVeilleFeedQuery, GetVeilleFeedQueryVariables>(GetVeilleFeedDocument, variables),
    ...options
  }
    )};

useGetVeilleFeedQuery.getKey = (variables: GetVeilleFeedQueryVariables) => ['GetVeilleFeed', variables];

export const useInfiniteGetVeilleFeedQuery = <
      TData = InfiniteData<GetVeilleFeedQuery>,
      TError = unknown
    >(
      variables: GetVeilleFeedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVeilleFeedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVeilleFeedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVeilleFeedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVeilleFeed.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVeilleFeedQuery, GetVeilleFeedQueryVariables>(GetVeilleFeedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVeilleFeedQuery.getKey = (variables: GetVeilleFeedQueryVariables) => ['GetVeilleFeed.infinite', variables];


useGetVeilleFeedQuery.fetcher = (variables: GetVeilleFeedQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVeilleFeedQuery, GetVeilleFeedQueryVariables>(GetVeilleFeedDocument, variables, options);

export const GetVeilleLiveCurveDocument = `
    query GetVeilleLiveCurve($veilleId: ID!) {
  getVeilleLiveCurve(veilleId: $veilleId) {
    bucketStart
    sales
    newItems
    salesPerMinute
    newItemsPerMinute
  }
}
    `;

export const useGetVeilleLiveCurveQuery = <
      TData = GetVeilleLiveCurveQuery,
      TError = unknown
    >(
      variables: GetVeilleLiveCurveQueryVariables,
      options?: Omit<UseQueryOptions<GetVeilleLiveCurveQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVeilleLiveCurveQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVeilleLiveCurveQuery, TError, TData>(
      {
    queryKey: ['GetVeilleLiveCurve', variables],
    queryFn: graphqlClient<GetVeilleLiveCurveQuery, GetVeilleLiveCurveQueryVariables>(GetVeilleLiveCurveDocument, variables),
    ...options
  }
    )};

useGetVeilleLiveCurveQuery.getKey = (variables: GetVeilleLiveCurveQueryVariables) => ['GetVeilleLiveCurve', variables];

export const useInfiniteGetVeilleLiveCurveQuery = <
      TData = InfiniteData<GetVeilleLiveCurveQuery>,
      TError = unknown
    >(
      variables: GetVeilleLiveCurveQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVeilleLiveCurveQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVeilleLiveCurveQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVeilleLiveCurveQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVeilleLiveCurve.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVeilleLiveCurveQuery, GetVeilleLiveCurveQueryVariables>(GetVeilleLiveCurveDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVeilleLiveCurveQuery.getKey = (variables: GetVeilleLiveCurveQueryVariables) => ['GetVeilleLiveCurve.infinite', variables];


useGetVeilleLiveCurveQuery.fetcher = (variables: GetVeilleLiveCurveQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVeilleLiveCurveQuery, GetVeilleLiveCurveQueryVariables>(GetVeilleLiveCurveDocument, variables, options);

export const GetUserNotificationSettingsDocument = `
    query GetUserNotificationSettings {
  getUserNotificationSettings {
    discordWebhook
    notificationEmail
  }
}
    `;

export const useGetUserNotificationSettingsQuery = <
      TData = GetUserNotificationSettingsQuery,
      TError = unknown
    >(
      variables?: GetUserNotificationSettingsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserNotificationSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserNotificationSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserNotificationSettingsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserNotificationSettings'] : ['GetUserNotificationSettings', variables],
    queryFn: graphqlClient<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>(GetUserNotificationSettingsDocument, variables),
    ...options
  }
    )};

useGetUserNotificationSettingsQuery.getKey = (variables?: GetUserNotificationSettingsQueryVariables) => variables === undefined ? ['GetUserNotificationSettings'] : ['GetUserNotificationSettings', variables];

export const useInfiniteGetUserNotificationSettingsQuery = <
      TData = InfiniteData<GetUserNotificationSettingsQuery>,
      TError = unknown
    >(
      variables: GetUserNotificationSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserNotificationSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserNotificationSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserNotificationSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetUserNotificationSettings.infinite'] : ['GetUserNotificationSettings.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>(GetUserNotificationSettingsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserNotificationSettingsQuery.getKey = (variables?: GetUserNotificationSettingsQueryVariables) => variables === undefined ? ['GetUserNotificationSettings.infinite'] : ['GetUserNotificationSettings.infinite', variables];


useGetUserNotificationSettingsQuery.fetcher = (variables?: GetUserNotificationSettingsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>(GetUserNotificationSettingsDocument, variables, options);

export const GetVeilleNotificationConfigDocument = `
    query GetVeilleNotificationConfig($veilleId: ID!) {
  getVeilleNotificationConfig(veilleId: $veilleId) {
    veilleId
    eachSale
    discordEnabled
    thresholds
    dailyReport
    weeklyReport
    emailEnabled
    notificationEmail
    lastDeliveryFailed
    lastReason
  }
}
    `;

export const useGetVeilleNotificationConfigQuery = <
      TData = GetVeilleNotificationConfigQuery,
      TError = unknown
    >(
      variables: GetVeilleNotificationConfigQueryVariables,
      options?: Omit<UseQueryOptions<GetVeilleNotificationConfigQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVeilleNotificationConfigQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVeilleNotificationConfigQuery, TError, TData>(
      {
    queryKey: ['GetVeilleNotificationConfig', variables],
    queryFn: graphqlClient<GetVeilleNotificationConfigQuery, GetVeilleNotificationConfigQueryVariables>(GetVeilleNotificationConfigDocument, variables),
    ...options
  }
    )};

useGetVeilleNotificationConfigQuery.getKey = (variables: GetVeilleNotificationConfigQueryVariables) => ['GetVeilleNotificationConfig', variables];

export const useInfiniteGetVeilleNotificationConfigQuery = <
      TData = InfiniteData<GetVeilleNotificationConfigQuery>,
      TError = unknown
    >(
      variables: GetVeilleNotificationConfigQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVeilleNotificationConfigQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVeilleNotificationConfigQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVeilleNotificationConfigQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVeilleNotificationConfig.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVeilleNotificationConfigQuery, GetVeilleNotificationConfigQueryVariables>(GetVeilleNotificationConfigDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVeilleNotificationConfigQuery.getKey = (variables: GetVeilleNotificationConfigQueryVariables) => ['GetVeilleNotificationConfig.infinite', variables];


useGetVeilleNotificationConfigQuery.fetcher = (variables: GetVeilleNotificationConfigQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVeilleNotificationConfigQuery, GetVeilleNotificationConfigQueryVariables>(GetVeilleNotificationConfigDocument, variables, options);

export const GetVeilleNotificationHistoryDocument = `
    query GetVeilleNotificationHistory($veilleId: ID!, $limit: Int) {
  getVeilleNotificationHistory(veilleId: $veilleId, limit: $limit) {
    at
    kind
    ok
    reason
    label
  }
}
    `;

export const useGetVeilleNotificationHistoryQuery = <
      TData = GetVeilleNotificationHistoryQuery,
      TError = unknown
    >(
      variables: GetVeilleNotificationHistoryQueryVariables,
      options?: Omit<UseQueryOptions<GetVeilleNotificationHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVeilleNotificationHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVeilleNotificationHistoryQuery, TError, TData>(
      {
    queryKey: ['GetVeilleNotificationHistory', variables],
    queryFn: graphqlClient<GetVeilleNotificationHistoryQuery, GetVeilleNotificationHistoryQueryVariables>(GetVeilleNotificationHistoryDocument, variables),
    ...options
  }
    )};

useGetVeilleNotificationHistoryQuery.getKey = (variables: GetVeilleNotificationHistoryQueryVariables) => ['GetVeilleNotificationHistory', variables];

export const useInfiniteGetVeilleNotificationHistoryQuery = <
      TData = InfiniteData<GetVeilleNotificationHistoryQuery>,
      TError = unknown
    >(
      variables: GetVeilleNotificationHistoryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVeilleNotificationHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVeilleNotificationHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVeilleNotificationHistoryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVeilleNotificationHistory.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVeilleNotificationHistoryQuery, GetVeilleNotificationHistoryQueryVariables>(GetVeilleNotificationHistoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVeilleNotificationHistoryQuery.getKey = (variables: GetVeilleNotificationHistoryQueryVariables) => ['GetVeilleNotificationHistory.infinite', variables];


useGetVeilleNotificationHistoryQuery.fetcher = (variables: GetVeilleNotificationHistoryQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVeilleNotificationHistoryQuery, GetVeilleNotificationHistoryQueryVariables>(GetVeilleNotificationHistoryDocument, variables, options);

export const GetVestiaireCatalogTreeDocument = `
    query GetVestiaireCatalogTree {
  getVestiaireCatalogTree {
    id
    kind
    title
    children {
      id
      kind
      title
      children {
        id
        kind
        title
        children {
          id
          kind
          title
        }
      }
    }
  }
}
    `;

export const useGetVestiaireCatalogTreeQuery = <
      TData = GetVestiaireCatalogTreeQuery,
      TError = unknown
    >(
      variables?: GetVestiaireCatalogTreeQueryVariables,
      options?: Omit<UseQueryOptions<GetVestiaireCatalogTreeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVestiaireCatalogTreeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVestiaireCatalogTreeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetVestiaireCatalogTree'] : ['GetVestiaireCatalogTree', variables],
    queryFn: graphqlClient<GetVestiaireCatalogTreeQuery, GetVestiaireCatalogTreeQueryVariables>(GetVestiaireCatalogTreeDocument, variables),
    ...options
  }
    )};

useGetVestiaireCatalogTreeQuery.getKey = (variables?: GetVestiaireCatalogTreeQueryVariables) => variables === undefined ? ['GetVestiaireCatalogTree'] : ['GetVestiaireCatalogTree', variables];

export const useInfiniteGetVestiaireCatalogTreeQuery = <
      TData = InfiniteData<GetVestiaireCatalogTreeQuery>,
      TError = unknown
    >(
      variables: GetVestiaireCatalogTreeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVestiaireCatalogTreeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVestiaireCatalogTreeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVestiaireCatalogTreeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetVestiaireCatalogTree.infinite'] : ['GetVestiaireCatalogTree.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVestiaireCatalogTreeQuery, GetVestiaireCatalogTreeQueryVariables>(GetVestiaireCatalogTreeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVestiaireCatalogTreeQuery.getKey = (variables?: GetVestiaireCatalogTreeQueryVariables) => variables === undefined ? ['GetVestiaireCatalogTree.infinite'] : ['GetVestiaireCatalogTree.infinite', variables];


useGetVestiaireCatalogTreeQuery.fetcher = (variables?: GetVestiaireCatalogTreeQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVestiaireCatalogTreeQuery, GetVestiaireCatalogTreeQueryVariables>(GetVestiaireCatalogTreeDocument, variables, options);

export const GetVestiaireFilterOptionsDocument = `
    query GetVestiaireFilterOptions($filterType: VestiaireFilterType!, $query: String, $limit: Int, $ids: [Int!]) {
  getVestiaireFilterOptions(
    filterType: $filterType
    query: $query
    limit: $limit
    ids: $ids
  ) {
    id
    title
    parentId
    level
  }
}
    `;

export const useGetVestiaireFilterOptionsQuery = <
      TData = GetVestiaireFilterOptionsQuery,
      TError = unknown
    >(
      variables: GetVestiaireFilterOptionsQueryVariables,
      options?: Omit<UseQueryOptions<GetVestiaireFilterOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVestiaireFilterOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVestiaireFilterOptionsQuery, TError, TData>(
      {
    queryKey: ['GetVestiaireFilterOptions', variables],
    queryFn: graphqlClient<GetVestiaireFilterOptionsQuery, GetVestiaireFilterOptionsQueryVariables>(GetVestiaireFilterOptionsDocument, variables),
    ...options
  }
    )};

useGetVestiaireFilterOptionsQuery.getKey = (variables: GetVestiaireFilterOptionsQueryVariables) => ['GetVestiaireFilterOptions', variables];

export const useInfiniteGetVestiaireFilterOptionsQuery = <
      TData = InfiniteData<GetVestiaireFilterOptionsQuery>,
      TError = unknown
    >(
      variables: GetVestiaireFilterOptionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVestiaireFilterOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVestiaireFilterOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVestiaireFilterOptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVestiaireFilterOptions.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVestiaireFilterOptionsQuery, GetVestiaireFilterOptionsQueryVariables>(GetVestiaireFilterOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVestiaireFilterOptionsQuery.getKey = (variables: GetVestiaireFilterOptionsQueryVariables) => ['GetVestiaireFilterOptions.infinite', variables];


useGetVestiaireFilterOptionsQuery.fetcher = (variables: GetVestiaireFilterOptionsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVestiaireFilterOptionsQuery, GetVestiaireFilterOptionsQueryVariables>(GetVestiaireFilterOptionsDocument, variables, options);

export const GetVestiaireCountriesDocument = `
    query GetVestiaireCountries {
  getVestiaireCountries {
    id
    isoCode
    name
    region
    sellerCount
  }
}
    `;

export const useGetVestiaireCountriesQuery = <
      TData = GetVestiaireCountriesQuery,
      TError = unknown
    >(
      variables?: GetVestiaireCountriesQueryVariables,
      options?: Omit<UseQueryOptions<GetVestiaireCountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVestiaireCountriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVestiaireCountriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetVestiaireCountries'] : ['GetVestiaireCountries', variables],
    queryFn: graphqlClient<GetVestiaireCountriesQuery, GetVestiaireCountriesQueryVariables>(GetVestiaireCountriesDocument, variables),
    ...options
  }
    )};

useGetVestiaireCountriesQuery.getKey = (variables?: GetVestiaireCountriesQueryVariables) => variables === undefined ? ['GetVestiaireCountries'] : ['GetVestiaireCountries', variables];

export const useInfiniteGetVestiaireCountriesQuery = <
      TData = InfiniteData<GetVestiaireCountriesQuery>,
      TError = unknown
    >(
      variables: GetVestiaireCountriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVestiaireCountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVestiaireCountriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetVestiaireCountriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetVestiaireCountries.infinite'] : ['GetVestiaireCountries.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetVestiaireCountriesQuery, GetVestiaireCountriesQueryVariables>(GetVestiaireCountriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVestiaireCountriesQuery.getKey = (variables?: GetVestiaireCountriesQueryVariables) => variables === undefined ? ['GetVestiaireCountries.infinite'] : ['GetVestiaireCountries.infinite', variables];


useGetVestiaireCountriesQuery.fetcher = (variables?: GetVestiaireCountriesQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetVestiaireCountriesQuery, GetVestiaireCountriesQueryVariables>(GetVestiaireCountriesDocument, variables, options);

export const PreviewVestiaireMatchCountDocument = `
    query PreviewVestiaireMatchCount($input: VestiaireSearchCriteriaInput!) {
  previewVestiaireMatchCount(input: $input) {
    totalCount
    sampledCount
    capped
    sampleWindowDays
    priceMin
    priceMax
    similarityPending
  }
}
    `;

export const usePreviewVestiaireMatchCountQuery = <
      TData = PreviewVestiaireMatchCountQuery,
      TError = unknown
    >(
      variables: PreviewVestiaireMatchCountQueryVariables,
      options?: Omit<UseQueryOptions<PreviewVestiaireMatchCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PreviewVestiaireMatchCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PreviewVestiaireMatchCountQuery, TError, TData>(
      {
    queryKey: ['PreviewVestiaireMatchCount', variables],
    queryFn: graphqlClient<PreviewVestiaireMatchCountQuery, PreviewVestiaireMatchCountQueryVariables>(PreviewVestiaireMatchCountDocument, variables),
    ...options
  }
    )};

usePreviewVestiaireMatchCountQuery.getKey = (variables: PreviewVestiaireMatchCountQueryVariables) => ['PreviewVestiaireMatchCount', variables];

export const useInfinitePreviewVestiaireMatchCountQuery = <
      TData = InfiniteData<PreviewVestiaireMatchCountQuery>,
      TError = unknown
    >(
      variables: PreviewVestiaireMatchCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PreviewVestiaireMatchCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PreviewVestiaireMatchCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PreviewVestiaireMatchCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PreviewVestiaireMatchCount.infinite', variables],
      queryFn: (metaData) => graphqlClient<PreviewVestiaireMatchCountQuery, PreviewVestiaireMatchCountQueryVariables>(PreviewVestiaireMatchCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePreviewVestiaireMatchCountQuery.getKey = (variables: PreviewVestiaireMatchCountQueryVariables) => ['PreviewVestiaireMatchCount.infinite', variables];


usePreviewVestiaireMatchCountQuery.fetcher = (variables: PreviewVestiaireMatchCountQueryVariables, options?: RequestInit['headers']) => graphqlClient<PreviewVestiaireMatchCountQuery, PreviewVestiaireMatchCountQueryVariables>(PreviewVestiaireMatchCountDocument, variables, options);

export const ParseVestiaireSellerRefDocument = `
    query ParseVestiaireSellerRef($input: String!) {
  parseVestiaireSellerRef(input: $input) {
    sellerId
    profileUrl
    username
    known
  }
}
    `;

export const useParseVestiaireSellerRefQuery = <
      TData = ParseVestiaireSellerRefQuery,
      TError = unknown
    >(
      variables: ParseVestiaireSellerRefQueryVariables,
      options?: Omit<UseQueryOptions<ParseVestiaireSellerRefQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ParseVestiaireSellerRefQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ParseVestiaireSellerRefQuery, TError, TData>(
      {
    queryKey: ['ParseVestiaireSellerRef', variables],
    queryFn: graphqlClient<ParseVestiaireSellerRefQuery, ParseVestiaireSellerRefQueryVariables>(ParseVestiaireSellerRefDocument, variables),
    ...options
  }
    )};

useParseVestiaireSellerRefQuery.getKey = (variables: ParseVestiaireSellerRefQueryVariables) => ['ParseVestiaireSellerRef', variables];

export const useInfiniteParseVestiaireSellerRefQuery = <
      TData = InfiniteData<ParseVestiaireSellerRefQuery>,
      TError = unknown
    >(
      variables: ParseVestiaireSellerRefQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ParseVestiaireSellerRefQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ParseVestiaireSellerRefQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ParseVestiaireSellerRefQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ParseVestiaireSellerRef.infinite', variables],
      queryFn: (metaData) => graphqlClient<ParseVestiaireSellerRefQuery, ParseVestiaireSellerRefQueryVariables>(ParseVestiaireSellerRefDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteParseVestiaireSellerRefQuery.getKey = (variables: ParseVestiaireSellerRefQueryVariables) => ['ParseVestiaireSellerRef.infinite', variables];


useParseVestiaireSellerRefQuery.fetcher = (variables: ParseVestiaireSellerRefQueryVariables, options?: RequestInit['headers']) => graphqlClient<ParseVestiaireSellerRefQuery, ParseVestiaireSellerRefQueryVariables>(ParseVestiaireSellerRefDocument, variables, options);

export const ParseVestiaireSearchUrlDocument = `
    query ParseVestiaireSearchUrl($url: String!) {
  parseVestiaireSearchUrl(url: $url) {
    criteria {
      universeIds
      catalogRootIds
      catalogLevel1Ids
      catalogLevel2Ids
      brandIds
      modelIds
      conditionIds
      colorIds
      materialIds
      countryIds
      sellerBadges
      itemBadges
      priceMin
      priceMax
      keywords
    }
    ignored {
      key
      value
    }
    brands {
      id
      title
    }
    models {
      id
      title
    }
  }
}
    `;

export const useParseVestiaireSearchUrlQuery = <
      TData = ParseVestiaireSearchUrlQuery,
      TError = unknown
    >(
      variables: ParseVestiaireSearchUrlQueryVariables,
      options?: Omit<UseQueryOptions<ParseVestiaireSearchUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ParseVestiaireSearchUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ParseVestiaireSearchUrlQuery, TError, TData>(
      {
    queryKey: ['ParseVestiaireSearchUrl', variables],
    queryFn: graphqlClient<ParseVestiaireSearchUrlQuery, ParseVestiaireSearchUrlQueryVariables>(ParseVestiaireSearchUrlDocument, variables),
    ...options
  }
    )};

useParseVestiaireSearchUrlQuery.getKey = (variables: ParseVestiaireSearchUrlQueryVariables) => ['ParseVestiaireSearchUrl', variables];

export const useInfiniteParseVestiaireSearchUrlQuery = <
      TData = InfiniteData<ParseVestiaireSearchUrlQuery>,
      TError = unknown
    >(
      variables: ParseVestiaireSearchUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ParseVestiaireSearchUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ParseVestiaireSearchUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ParseVestiaireSearchUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ParseVestiaireSearchUrl.infinite', variables],
      queryFn: (metaData) => graphqlClient<ParseVestiaireSearchUrlQuery, ParseVestiaireSearchUrlQueryVariables>(ParseVestiaireSearchUrlDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteParseVestiaireSearchUrlQuery.getKey = (variables: ParseVestiaireSearchUrlQueryVariables) => ['ParseVestiaireSearchUrl.infinite', variables];


useParseVestiaireSearchUrlQuery.fetcher = (variables: ParseVestiaireSearchUrlQueryVariables, options?: RequestInit['headers']) => graphqlClient<ParseVestiaireSearchUrlQuery, ParseVestiaireSearchUrlQueryVariables>(ParseVestiaireSearchUrlDocument, variables, options);
